/* ============================================================
   REBUILD CONFIGURATOR — FRONTEND LOGICA
   Hoort in: assets/rebuild-configurator.js

   Staat volledig LOS van configurator.js: geen gedeelde functies, geen
   gedeelde state, geen gedeelde element-ID's. Kan dus veilig op een eigen
   pagina naast (of zonder) de bestaande configurator draaien.

   Hoe het werkt:
   1. Bovenaan drie filters, in deze volgorde: stijl, breedte, kleur (zie
      TOP_FILTER_KEYS hieronder) — dezelfde trechterlogica als stap 1 van
      de bestaande configurator, maar hier voor ÉÉN keuze in plaats van een
      hele configuratie. Lattenbodem staat hier bewust NIET meer bij (zie
      punt 1b) — je kunt in plaats daarvan ook zoeken op SKU/naam, dwars
      door deze filters heen (zie rSearchLeft/rPickLeftBed).
   1b. Zodra een bed is aangeklikt (via de filters óf via zoeken): bestaat
      dat bed in meerdere lattenbodem-uitvoeringen (dezelfde stijl/breedte/
      kleur/bedtype/top/ladder, alleen de lattenbodem verschilt), dan komt
      er een extra tussenstap: "welke lattenbodem zit er in jouw bed?".
      Bestaat het bed maar in één lattenbodem-uitvoering, dan wordt die
      automatisch gebruikt en slaat de tool deze stap over. Zie
      rBedGroupKey()/rPickLeftBed()/rPickLeftSlats() hieronder.
   2. Links: een raster met alle bedden die aan de filters voldoen. Klikken
      kiest het HUIDIGE bed.
   3. Rechts: zodra het huidige bed gekozen is, een raster met bedden
      waar je naartoe kunt ombouwen. Breedte, kleur en lattenbodem liggen
      dan vast (gelijk aan het huidige bed — dat wijzigen zou te kostbaar
      worden); alleen de STIJL mag veranderen, en dan alleen volgens de
      toegestane overstappen uit het metaobject "Configurator rebuild rule"
      (bv. Montessori -> Original). Bedtype/top/ladder/extra's worden hier
      niet getoond en spelen geen rol in de keuze.
   4. Onderaan: de onderdelen die het gekozen bed méér heeft dan het
      huidige bed, met omschrijving, SKU en prijs (per markt), een totaal,
      en een knop om ze in de winkelmand te zetten -- OF, in dealer-modus
      (zie DEALER-MODUS hieronder), een knop om er een PDF-offerte van te
      maken.

   Uitzonderingen/verdere speciale regels komen in een latere stap.

   DEALER-MODUS (7 sep 2026) -- zelfde principe als de hoofdconfigurator
   (zie configurator-sectie.liquid): staat "Dealer-modus" in de
   sectie-instellingen aan, dan verandert de laatste stap. In plaats van
   "In winkelmand" verschijnt "Offerte maken": er wordt dan niets besteld,
   maar een PDF met de ontbrekende onderdelen (en eventueel gekozen
   accessoires) klaargezet om te downloaden of te mailen. Dit hergebruikt
   dezelfde gedeelde PDF-motor (offerte-pdf.js, window.OffertePdf) als de
   hoofdconfigurator -- zie offerte-pdf.js voor de volledige uitleg over
   hoe die motor werkt (lettertype, foto-terugval, lay-out). Alles wat
   HIERONDER in dit bestand staat (rBouwOfferteRegels, rGenereerOffertePdf,
   enz.) is bewust een eigen, kleine laag bovenop die gedeelde motor --
   dezelfde opzet als genereerOffertePdf/downloadOfferte/
   verstuurOfferteViaEmail in configurator.js, maar met eigen naamgeving en
   eigen state, zodat dit bestand nog steeds niets deelt met (en dus niets
   kan breken aan) de hoofdconfigurator zelf.
   ============================================================ */

/* Welke filters bovenaan staan, en in welke volgorde. Labels en of een
   filter "optioneel" is komen nog steeds uit het metaobject
   "Configurator filter" (RDATA.filters) — hier wordt alleen bepaald WELKE
   van die filters getoond worden en in welke volgorde. Wijzigen = deze
   regel aanpassen, verder is er niets aan de code te doen. */
/* Lattenbodem (filter_slats) stond hier tot 30 aug 2026 ook bij, als vierde
   filter. Op verzoek is dat vervangen door een aparte stap ("welke
   lattenbodem zit er in jouw bed?") die alleen verschijnt als het gekozen
   bed daadwerkelijk in meerdere lattenbodem-uitvoeringen bestaat -- zie
   rPickLeftBed()/rPickLeftSlats() en de "slats1"-stap in rAllSteps()
   hieronder. */
var TOP_FILTER_KEYS = ["filter_style", "filter_width", "filter_colour"];

/* Startwaarden: de tool opent niet leeg, maar met deze combinatie al gekozen
   (in dezelfde volgorde als TOP_FILTER_KEYS hierboven). Werkt op de RUWE
   metafieldwaarde ("Original", "White", ...) EN op de vertaalde pil-tekst
   ("Origineel", "Wit", ...) — welke van de twee je hier ook intypt, hij
   wordt bij het laden tegen beide gelegd. Past hij ook dan nog niet exact,
   dan wordt er een losse woord-voor-woord vergelijking geprobeerd (zodat
   bv. "Standard 16 slats" ook "Standard - 16 curved slats" herkent).
   Matcht niets, dan blijft dat filter leeg en verschijnt er een waarschuwing
   in de browserconsole (rechtermuisknop -> Inspecteren -> Console) met de
   exacte reden — daar kun je dan aan zien welke tekst het wél had moeten
   zijn. Leeg laten (bv. filter_width: "") betekent: dat filter niet
   vooraf invullen. */
var DEFAULT_FILTERS = {
  filter_style:  "Original",
  filter_width:  "90",
  filter_colour: "White",
};

/* Voorkeursvolgorde: zodra een filter meerdere mogelijke waarden heeft (bv.
   na het wijzigen van style, of nadat een eerder filter is versmald), kiest
   de tool zelf automatisch de eerste optie uit deze lijst die daadwerkelijk
   beschikbaar is — er blijft dus nooit een filter "open" staan als er een
   voorkeur voor bestaat. filter_style staat hier bewust NIET in: daar is
   geen voorkeursvolgorde voor gevraagd, dus die blijft een bewuste keuze
   van de klant. Zelfde matchlogica (rFindMatchingValue) als DEFAULT_FILTERS
   hierboven: werkt op zowel de ruwe metafieldwaarde als het vertaalde label
   en op losse woorden, dus "16" vindt ook "Standard - 16 curved slats". */
var AUTO_PICK_PRIORITY = {
  filter_width:  ["90", "120", "140"],
  filter_colour: ["White", "Whitewash"],
};

/* =====================================================================
   VERTALINGEN
   Zelfde patroon als configurator.js: Engels is de fallback, de taal volgt
   de winkel automatisch. NL is zorgvuldig nagekeken; DA/DE/FR zijn een
   eerste vertaling en verdienen een check door iemand die de markt kent
   (zelfde kanttekening staat al bij de knopteksten van de hoofdconfigurator).
   ===================================================================== */
const R_TRANSLATIONS = {
  en: {
    stepOf:             "Step {n} of {total}",
    step1Title:         "Choose your current bed",
    step2Title:         "Choose the bed you want",
    step2Sub:           "You'll only see beds with the same width, colour and slatted base as your bed, in an allowed style. A different width or colour isn't possible with this tool.",
    slatsStepTitle:     "Which slatted base is in your bed?",
    slatsStepSub:       "This bed is available with more than one slatted base — pick the one you have.",
    slatsStepNote:      "You chose this bed. Now pick the slatted base that's actually in it:",
    step3Title:         "Parts you need",
    step3Sub:           "Choose both beds to see which parts you need.",
    step3SubDynamic:    "This is what you need to rebuild {from} into {to}.",
    lockedNote:         "This stays the same as your current bed:",
    changeLeftBed:      "Choose a different current bed",
    styleOnlyNote:      "Only the style may change — and only where that's allowed here.",
    pinnedTitle: "Your bed has:",
    pinnedWidth: "Width",
    pinnedColour: "Colour",
    pinnedSlats: "Slatted base",
    notListedTitle: "Can't find the bed you want?",
    notListedBody: "Type its name or SKU in the search box and we'll show why it isn't possible with your bed. A different slatted base can't be changed here either; please contact customer service for that.",
    excludedTitle: "Not possible with your bed",
    reasonWidth: "different width ({v})",
    reasonColour: "different colour ({v})",
    reasonSlats: "different slatted base ({v})",
    reasonStyle: "rebuilding to this style isn't allowed",
    excludedMore: "+ {n} more — refine your search",
    excludedBecause: "Why not: {r}",
    changeBothBeds:     "Choose different beds",
    prev:               "← Previous",
    next:               "Next →",
    noMatch:            "No bed matches this combination",
    chooseAllFilters:   "Choose a value for every filter above to see beds.",
    noRightMatches:     "No allowed rebuilds are set up for this bed's style yet",
    searchPlaceholder:  "Search by SKU or name…",
    clearSearch:        "Clear search",
    noSearchMatch:      "No bed matches “{query}”",
    orUseFilters:       "or use the filters to find your bed",
    chooseLeftFirst:    "Choose your current bed first",
    chooseRightBed:     "Choose the bed you want to rebuild it into",
    sameBed:            "That's the same bed — nothing is missing",
    noPartsMissing:     "Nothing missing — this bed doesn't need any extra parts",
    notOrderableYet:    "Not orderable yet",
    dataMissingWarning: "The parts list for this bed hasn't been filled in yet, so we can't compare it reliably.",
    total:              "Total",
    addToCart:          "Add to cart — {price}",
    addToCartShort:     "Add to cart",
    rebuildNotOrderable: "This rebuild can't be ordered yet: one or more required parts aren't in the shop yet. Please get in touch with us.",
    startOver:          "Start over",
    cartError:          "Something went wrong while adding these parts to the cart.",
    networkError:       "Network error: {msg}",
    loadError:          "Could not load the rebuild configurator ({msg}).",
    propRebuild:        "Rebuild",
    rebuildTitleLine:   "Rebuild from {from} to {to}",
    specsShow:      "Specifications",
    specsClose:     "Close",
    infoProductPage:"View product page",
    wantAccessoriesQuestion: "Would you also like to order accessories for this bed?",
    yes:                "Yes",
    no:                 "No",
    changeAccAnswer:    "Change answer",
    wantsAccessoriesConfirmed: "You've chosen to also order accessories.",
    continueToAccessories: "Continue to accessories →",
    noAccessoriesForThisBed: "No accessories are available for this bed in this step.",
    propAccessoryFor:   "Accessory for {sku}",
    subAccessoryTitle:  "Additional options for {v} (optional)",
    required:           "required",
    unavailable:        "Currently unavailable",
    requiresMissing:    "Requires {v}",
    remove:             "Remove",
    fewer:              "One less",
    more:               "One more",
    slotTop:            "Top bunk",
    slotBottom:         "Bottom bunk",
    slotOther:          "Sleeping area {n}",
    slotGuest: "Guest bed",
    slotBedOnly: "Bed",
    noMattress: "No mattress",
    sameAsBottom: "Same as bottom bunk: {v}",
    readMore: "More info",
    createQuote:      "Create quote — {price}",
    createQuoteShort: "Create quote",
    quoteModalTitle:  "Create a quote",
    quoteIntro:       "This creates a PDF with the missing parts (and accessories, if chosen). No order is placed.",
    quoteEmailLabel:  "Customer's email address",
    quoteEmailPlaceholder: "name@example.com",
    quoteNameLabel:   "Customer's name",
    quoteNamePlaceholder: "Name",
    quoteDealerLabel: "Dealer name",
    quoteDealerPlaceholder: "e.g. Kids Furniture Amsterdam",
    quoteDealerRequired: "Please enter the dealer name.",
    quoteNameRequired: "Please enter the customer's name.",
    quoteDealerEmailLabel: "Dealer's email address",
    quoteDealerEmailPlaceholder: "dealer@example.com",
    quoteInvalidDealerEmail: "Please enter a valid dealer email address.",
    quoteDownloadBtn: "Download PDF",
    quoteEmailBtn:    "Send by email",
    quoteGenerating:  "Creating…",
    quoteCancelBtn:   "Cancel",
    quoteInvalidEmail:"Please enter a valid email address.",
    quoteError:       "Something went wrong while creating the quote.",
    quoteNoItems:     "Please choose both beds first.",
    quoteShareText:   "Quote for {email}",
    quoteMailSubject: "Your Lifetime Kidsrooms quote",
    quoteMailBody:    "Hello,\n\nPlease find the quote attached ({file}).\n\nKind regards,\nLifetime Kidsrooms",
    quotePdfTitle:    "Quote",
    quotePdfDate:     "Date",
    quotePdfDealer:   "Dealer",
    quotePdfCustomer: "Customer",
    quotePdfItem:     "Item",
    quotePdfSku:      "SKU",
    quotePdfQty:      "Qty",
    quotePdfPrice:    "Price",
    quotePdfLineTotal:"Subtotal",
    quotePdfTotal:    "Total",
    quotePdfNoPrices: "Prices are not available in this market.",
    quotePdfFooter:   "This is a non-binding quote, not an order confirmation.",
    quotePdfFooterPrices:      "All prices are recommended retail prices, incl. VAT",
    quotePdfFooterErrors:      "Errors and omissions excepted",
    quotePdfFooterChanges:     "Price and product changes reserved",
    quotePdfFooterColours:     "Colours can differ from reality.",
    quotePdfFooterAvailability:"Due to production constraints, stock availability, or sales considerations, availability can only be confirmed after placing the order.",
    quotePdfContinued:"continued",
  },
  nl: {
    stepOf:             "Stap {n} van {total}",
    step1Title:         "Kies je huidige bed",
    step2Title:         "Kies het bed dat je wilt",
    step2Sub:           "Je ziet alleen bedden met dezelfde breedte, kleur en lattenbodem als jouw bed, in een toegestane stijl. Een andere breedte of kleur is met deze tool niet mogelijk.",
    slatsStepTitle:     "Welke lattenbodem zit er in jouw bed?",
    slatsStepSub:       "Dit bed is er met meerdere lattenbodems — kies de uitvoering die jij hebt.",
    slatsStepNote:      "Je koos dit bed. Kies nu de lattenbodem die er echt in zit:",
    step3Title:         "Benodigde onderdelen",
    step3Sub:           "Kies eerst beide bedden om te zien welke onderdelen je nodig hebt.",
    step3SubDynamic:    "Dit heb je nodig om van {from} naar {to} om te bouwen.",
    lockedNote:         "Dit blijft hetzelfde als bij jouw huidige bed:",
    changeLeftBed:      "Ander huidig bed kiezen",
    styleOnlyNote:      "Alleen de stijl mag veranderen — en dan alleen als dat hiernaast is toegestaan.",
    pinnedTitle: "Jouw bed heeft:",
    pinnedWidth: "Breedte",
    pinnedColour: "Kleur",
    pinnedSlats: "Lattenbodem",
    notListedTitle: "Kun je het bed dat je wilt niet vinden?",
    notListedBody: "Typ de naam of SKU in het zoekveld, dan laten we zien waarom het niet kan met jouw bed. Ook een andere lattenbodem kan hier niet; neem daarvoor contact op met de klantenservice.",
    excludedTitle: "Niet mogelijk met jouw bed",
    reasonWidth: "andere breedte ({v})",
    reasonColour: "andere kleur ({v})",
    reasonSlats: "andere lattenbodem ({v})",
    reasonStyle: "ombouwen naar deze stijl is niet toegestaan",
    excludedMore: "+ {n} meer — verfijn je zoekopdracht",
    excludedBecause: "Waarom niet: {r}",
    changeBothBeds:     "Ander bed kiezen",
    prev:               "← Vorige",
    next:               "Volgende →",
    noMatch:            "Geen bed past bij deze combinatie",
    chooseAllFilters:   "Kies bij elk filter hierboven een waarde om bedden te zien.",
    noRightMatches:     "Voor de stijl van dit bed zijn nog geen toegestane overstappen ingesteld",
    searchPlaceholder:  "Zoek op SKU of naam…",
    clearSearch:        "Zoekopdracht wissen",
    noSearchMatch:      "Geen bed gevonden voor “{query}”",
    orUseFilters:       "of gebruik de filters om je bed te vinden",
    chooseLeftFirst:    "Kies eerst je huidige bed",
    chooseRightBed:     "Kies het bed dat je ervan wilt maken",
    sameBed:            "Dit is hetzelfde bed — er ontbreekt niets",
    noPartsMissing:     "Niets ontbreekt — dit bed heeft geen extra onderdelen nodig",
    notOrderableYet:    "Nog niet besteltbaar",
    dataMissingWarning: "De onderdelenlijst voor dit bed is nog niet ingevuld, dus we kunnen geen betrouwbare vergelijking maken.",
    total:              "Totaal",
    addToCart:          "In winkelmand — {price}",
    addToCartShort:     "In winkelmand",
    rebuildNotOrderable: "Deze ombouw kan nog niet besteld worden: één of meer benodigde onderdelen staan nog niet in de webshop. Neem contact met ons op.",
    startOver:          "Opnieuw beginnen",
    cartError:          "Er ging iets mis bij het toevoegen van deze onderdelen aan de winkelmand.",
    networkError:       "Netwerkfout: {msg}",
    loadError:          "Kon de re-build configurator niet laden ({msg}).",
    propRebuild:        "Ombouw",
    rebuildTitleLine:   "Ombouw van {from} naar {to}",
    specsShow:      "Specificaties",
    specsClose:     "Sluiten",
    infoProductPage:"Bekijk productpagina",
    wantAccessoriesQuestion: "Wil je ook accessoires bij dit bed bestellen?",
    yes:                "Ja",
    no:                 "Nee",
    changeAccAnswer:    "Antwoord wijzigen",
    wantsAccessoriesConfirmed: "Je hebt aangegeven ook accessoires te willen bestellen.",
    continueToAccessories: "Verder naar de accessoires →",
    noAccessoriesForThisBed: "Voor dit bed zijn in deze stap geen accessoires beschikbaar.",
    propAccessoryFor:   "Accessoire bij {sku}",
    subAccessoryTitle:  "Aanvullende opties bij {v} (optioneel)",
    required:           "verplicht",
    unavailable:        "Nu niet leverbaar",
    requiresMissing:    "Alleen met {v}",
    remove:             "Verwijderen",
    fewer:              "Eén minder",
    more:               "Eén meer",
    slotTop:            "Bovenbed",
    slotBottom:         "Onderbed",
    slotOther:          "Ligvlak {n}",
    slotGuest: "Logeerbed",
    slotBedOnly: "Bed",
    noMattress: "Geen matras",
    sameAsBottom: "Zelfde als onderbed: {v}",
    readMore: "Meer info",
    createQuote:      "Offerte maken — {price}",
    createQuoteShort: "Offerte maken",
    quoteModalTitle:  "Offerte maken",
    quoteIntro:       "Dit maakt een PDF met de ontbrekende onderdelen (en gekozen accessoires). Er wordt niets besteld.",
    quoteEmailLabel:  "E-mailadres van de klant",
    quoteEmailPlaceholder: "naam@voorbeeld.nl",
    quoteNameLabel:   "Naam van de klant",
    quoteNamePlaceholder: "Naam",
    quoteDealerLabel: "Naam dealer",
    quoteDealerPlaceholder: "bijv. Kinderkamer Amsterdam",
    quoteDealerRequired: "Vul de naam van de dealer in.",
    quoteNameRequired: "Vul de naam van de klant in.",
    quoteDealerEmailLabel: "E-mailadres van de dealer",
    quoteDealerEmailPlaceholder: "dealer@voorbeeld.nl",
    quoteInvalidDealerEmail: "Vul een geldig e-mailadres van de dealer in.",
    quoteDownloadBtn: "PDF downloaden",
    quoteEmailBtn:    "Per e-mail versturen",
    quoteGenerating:  "Bezig…",
    quoteCancelBtn:   "Annuleren",
    quoteInvalidEmail:"Vul een geldig e-mailadres in.",
    quoteError:       "Er ging iets mis bij het maken van de offerte.",
    quoteNoItems:     "Kies eerst beide bedden.",
    quoteShareText:   "Offerte voor {email}",
    quoteMailSubject: "Uw offerte van Lifetime Kidsrooms",
    quoteMailBody:    "Hallo,\n\nHierbij de offerte als bijlage ({file}).\n\nMet vriendelijke groet,\nLifetime Kidsrooms",
    quotePdfTitle:    "Offerte",
    quotePdfDate:     "Datum",
    quotePdfDealer:   "Dealer",
    quotePdfCustomer: "Klant",
    quotePdfItem:     "Artikel",
    quotePdfSku:      "SKU",
    quotePdfQty:      "Aantal",
    quotePdfPrice:    "Prijs",
    quotePdfLineTotal:"Subtotaal",
    quotePdfTotal:    "Totaal",
    quotePdfNoPrices: "Prijzen zijn niet beschikbaar in deze markt.",
    quotePdfFooter:   "Dit is een vrijblijvende offerte, geen orderbevestiging.",
    quotePdfFooterPrices:      "Alle prijzen zijn adviesverkoopprijzen, inclusief btw",
    quotePdfFooterErrors:      "Zet- en drukfouten voorbehouden",
    quotePdfFooterChanges:     "Prijs- en productwijzigingen voorbehouden",
    quotePdfFooterColours:     "Kleuren kunnen afwijken van de werkelijkheid.",
    quotePdfFooterAvailability:"Vanwege productiebeperkingen, voorraad of verkoopoverwegingen kan beschikbaarheid pas na het plaatsen van de bestelling worden bevestigd.",
    quotePdfContinued:"vervolg",
  },
  da: {
    stepOf:             "Trin {n} af {total}",
    step1Title:         "Vælg din nuværende seng",
    step2Title:         "Vælg sengen, du ønsker",
    step2Sub:           "Du ser kun senge med samme bredde, farve og lamelbund som din seng, i en tilladt stil. En anden bredde eller farve er ikke mulig med dette værktøj.",
    slatsStepTitle:     "Hvilken lamelbund er der i din seng?",
    slatsStepSub:       "Denne seng findes med flere lamelbunde — vælg den, du har.",
    slatsStepNote:      "Du valgte denne seng. Vælg nu den lamelbund, der rent faktisk sidder i den:",
    step3Title:         "Nødvendige dele",
    step3Sub:           "Vælg begge senge for at se, hvilke dele du skal bruge.",
    step3SubDynamic:    "Dette skal du bruge for at bygge {from} om til {to}.",
    lockedNote:         "Dette forbliver det samme som på din nuværende seng:",
    changeLeftBed:      "Vælg en anden nuværende seng",
    styleOnlyNote:      "Kun stilen må ændres — og kun hvor det er tilladt her.",
    pinnedTitle: "Din seng har:",
    pinnedWidth: "Bredde",
    pinnedColour: "Farve",
    pinnedSlats: "Lamelbund",
    notListedTitle: "Kan du ikke finde den seng, du vil have?",
    notListedBody: "Skriv navn eller SKU i søgefeltet, så viser vi, hvorfor det ikke er muligt med din seng. En anden lamelbund kan heller ikke ændres her; kontakt kundeservice.",
    excludedTitle: "Ikke muligt med din seng",
    reasonWidth: "anden bredde ({v})",
    reasonColour: "anden farve ({v})",
    reasonSlats: "anden lamelbund ({v})",
    reasonStyle: "ombygning til denne stil er ikke tilladt",
    excludedMore: "+ {n} flere — præciser din søgning",
    excludedBecause: "Hvorfor ikke: {r}",
    changeBothBeds:     "Vælg andre senge",
    prev:               "← Forrige",
    next:               "Næste →",
    noMatch:            "Ingen seng matcher denne kombination",
    chooseAllFilters:   "Vælg en værdi for hvert filter ovenfor for at se senge.",
    noRightMatches:     "Der er endnu ikke sat tilladte ombygninger op for denne sengs stil",
    searchPlaceholder:  "Søg på SKU eller navn…",
    clearSearch:        "Ryd søgning",
    noSearchMatch:      "Ingen seng fundet for “{query}”",
    orUseFilters:       "eller brug filtrene til at finde din seng",
    chooseLeftFirst:    "Vælg først din nuværende seng",
    chooseRightBed:     "Vælg sengen, du vil bygge den om til",
    sameBed:            "Det er den samme seng — der mangler ikke noget",
    noPartsMissing:     "Intet mangler — denne seng har ikke brug for ekstra dele",
    notOrderableYet:    "Endnu ikke muligt at bestille",
    dataMissingWarning: "Dellisten for denne seng er endnu ikke udfyldt, så vi kan ikke lave en pålidelig sammenligning.",
    total:              "Total",
    addToCart:          "Læg i kurv — {price}",
    addToCartShort:     "Læg i kurv",
    rebuildNotOrderable: "Denne ombygning kan endnu ikke bestilles: en eller flere nødvendige dele findes endnu ikke i shoppen. Kontakt os venligst.",
    startOver:          "Start forfra",
    cartError:          "Der opstod en fejl, da disse dele skulle lægges i kurven.",
    networkError:       "Netværksfejl: {msg}",
    loadError:          "Kunne ikke indlæse ombygningskonfiguratoren ({msg}).",
    propRebuild:        "Ombygning",
    rebuildTitleLine:   "Ombygning fra {from} til {to}",
    specsShow:      "Specifikationer",
    specsClose:     "Luk",
    infoProductPage:"Se produktsiden",
    wantAccessoriesQuestion: "Vil du også bestille tilbehør til denne seng?",
    yes:                "Ja",
    no:                 "Nej",
    changeAccAnswer:    "Skift svar",
    wantsAccessoriesConfirmed: "Du har valgt også at bestille tilbehør.",
    continueToAccessories: "Videre til tilbehør →",
    noAccessoriesForThisBed: "Der er intet tilbehør til denne seng i dette trin.",
    propAccessoryFor:   "Tilbehør til {sku}",
    subAccessoryTitle:  "Yderligere valgmuligheder til {v} (valgfrit)",
    required:           "påkrævet",
    unavailable:        "Ikke tilgængelig lige nu",
    requiresMissing:    "Kræver {v}",
    remove:             "Fjern",
    fewer:              "Én mindre",
    more:               "Én mere",
    slotTop:            "Øverste køje",
    slotBottom:         "Nederste køje",
    slotOther:          "Liggeflade {n}",
    slotGuest: "Gæstebed",
    slotBedOnly: "Seng",
    noMattress: "Ingen madras",
    sameAsBottom: "Samme som nederste køje: {v}",
    readMore: "Mere info",
    createQuote:      "Opret tilbud — {price}",
    createQuoteShort: "Opret tilbud",
    quoteModalTitle:  "Opret tilbud",
    quoteIntro:       "Dette laver en PDF med de manglende dele (og eventuelt tilbehør). Der bestilles ikke noget.",
    quoteEmailLabel:  "Kundens e-mailadresse",
    quoteEmailPlaceholder: "navn@eksempel.dk",
    quoteNameLabel:   "Kundens navn",
    quoteNamePlaceholder: "Navn",
    quoteDealerLabel: "Forhandlernavn",
    quoteDealerPlaceholder: "f.eks. Børneværelse København",
    quoteDealerRequired: "Indtast venligst forhandlerens navn.",
    quoteNameRequired: "Indtast venligst kundens navn.",
    quoteDealerEmailLabel: "Forhandlerens e-mailadresse",
    quoteDealerEmailPlaceholder: "forhandler@eksempel.dk",
    quoteInvalidDealerEmail: "Indtast venligst en gyldig e-mailadresse for forhandleren.",
    quoteDownloadBtn: "Download PDF",
    quoteEmailBtn:    "Send via e-mail",
    quoteGenerating:  "Behandler…",
    quoteCancelBtn:   "Annuller",
    quoteInvalidEmail:"Indtast venligst en gyldig e-mailadresse.",
    quoteError:       "Noget gik galt under oprettelsen af tilbuddet.",
    quoteNoItems:     "Vælg først begge senge.",
    quoteShareText:   "Tilbud til {email}",
    quoteMailSubject: "Dit tilbud fra Lifetime Kidsrooms",
    quoteMailBody:    "Hej,\n\nSe venligst det vedhæftede tilbud ({file}).\n\nMed venlig hilsen,\nLifetime Kidsrooms",
    quotePdfTitle:    "Tilbud",
    quotePdfDate:     "Dato",
    quotePdfDealer:   "Forhandler",
    quotePdfCustomer: "Kunde",
    quotePdfItem:     "Vare",
    quotePdfSku:      "SKU",
    quotePdfQty:      "Antal",
    quotePdfPrice:    "Pris",
    quotePdfLineTotal:"Subtotal",
    quotePdfTotal:    "I alt",
    quotePdfNoPrices: "Priser er ikke tilgængelige i dette marked.",
    quotePdfFooter:   "Dette er et uforpligtende tilbud, ikke en ordrebekræftelse.",
    quotePdfFooterPrices:      "Alle priser er vejledende udsalgspriser, inkl. moms",
    quotePdfFooterErrors:      "Der tages forbehold for trykfejl",
    quotePdfFooterChanges:     "Der tages forbehold for pris- og produktændringer",
    quotePdfFooterColours:     "Farver kan afvige fra virkeligheden.",
    quotePdfFooterAvailability:"På grund af produktionsbegrænsninger, lagerbeholdning eller salgsmæssige hensyn kan tilgængelighed først bekræftes efter afgivelse af ordren.",
    quotePdfContinued:"fortsat",
  },
  de: {
    stepOf:             "Schritt {n} von {total}",
    step1Title:         "Wähle dein aktuelles Bett",
    step2Title:         "Wähle das Bett, das du möchtest",
    step2Sub:           "Du siehst nur Betten mit derselben Breite, Farbe und demselben Lattenrost wie dein Bett, in einem erlaubten Stil. Eine andere Breite oder Farbe ist mit diesem Tool nicht möglich.",
    slatsStepTitle:     "Welcher Lattenrost ist in deinem Bett?",
    slatsStepSub:       "Dieses Bett gibt es mit mehreren Lattenrosten — wähle die Ausführung, die du hast.",
    slatsStepNote:      "Du hast dieses Bett gewählt. Wähle jetzt den Lattenrost, der tatsächlich darin verbaut ist:",
    step3Title:         "Benötigte Teile",
    step3Sub:           "Wähle beide Betten, um zu sehen, welche Teile du brauchst.",
    step3SubDynamic:    "Das brauchst du, um {from} in {to} umzubauen.",
    lockedNote:         "Das bleibt wie bei deinem aktuellen Bett:",
    changeLeftBed:      "Anderes aktuelles Bett wählen",
    styleOnlyNote:      "Nur der Stil darf sich ändern — und nur, wenn das hier erlaubt ist.",
    pinnedTitle: "Dein Bett hat:",
    pinnedWidth: "Breite",
    pinnedColour: "Farbe",
    pinnedSlats: "Lattenrost",
    notListedTitle: "Du findest das gewünschte Bett nicht?",
    notListedBody: "Gib den Namen oder die SKU im Suchfeld ein, dann zeigen wir dir, warum es mit deinem Bett nicht geht. Auch ein anderer Lattenrost lässt sich hier nicht ändern; bitte wende dich dafür an den Kundenservice.",
    excludedTitle: "Mit deinem Bett nicht möglich",
    reasonWidth: "andere Breite ({v})",
    reasonColour: "andere Farbe ({v})",
    reasonSlats: "anderer Lattenrost ({v})",
    reasonStyle: "Umbau in diesen Stil ist nicht erlaubt",
    excludedMore: "+ {n} weitere — Suche verfeinern",
    excludedBecause: "Warum nicht: {r}",
    changeBothBeds:     "Andere Betten wählen",
    prev:               "← Zurück",
    next:               "Weiter →",
    noMatch:            "Kein Bett passt zu dieser Kombination",
    chooseAllFilters:   "Wähle für jeden Filter oben einen Wert aus, um Betten zu sehen.",
    noRightMatches:     "Für den Stil dieses Bettes sind noch keine erlaubten Umbauten eingerichtet",
    searchPlaceholder:  "Nach SKU oder Name suchen…",
    clearSearch:        "Suche löschen",
    noSearchMatch:      "Kein Bett gefunden für „{query}“",
    orUseFilters:       "oder benutze die Filter, um dein Bett zu finden",
    chooseLeftFirst:    "Wähle zuerst dein aktuelles Bett",
    chooseRightBed:     "Wähle das Bett, in das du umbauen möchtest",
    sameBed:            "Das ist dasselbe Bett — es fehlt nichts",
    noPartsMissing:     "Nichts fehlt — dieses Bett benötigt keine zusätzlichen Teile",
    notOrderableYet:    "Noch nicht bestellbar",
    dataMissingWarning: "Die Teileliste für dieses Bett ist noch nicht ausgefüllt, daher können wir keinen verlässlichen Vergleich anzeigen.",
    total:              "Gesamt",
    addToCart:          "In den Warenkorb — {price}",
    addToCartShort:     "In den Warenkorb",
    rebuildNotOrderable: "Dieser Umbau kann noch nicht bestellt werden: ein oder mehrere benötigte Teile sind noch nicht im Shop verfügbar. Bitte kontaktieren Sie uns.",
    startOver:          "Neu beginnen",
    cartError:          "Beim Hinzufügen dieser Teile zum Warenkorb ist ein Fehler aufgetreten.",
    networkError:       "Netzwerkfehler: {msg}",
    loadError:          "Der Umbau-Konfigurator konnte nicht geladen werden ({msg}).",
    propRebuild:        "Umbau",
    rebuildTitleLine:   "Umbau von {from} nach {to}",
    specsShow:      "Spezifikationen",
    specsClose:     "Schließen",
    infoProductPage:"Zur Produktseite",
    wantAccessoriesQuestion: "Möchten Sie auch Zubehör für dieses Bett bestellen?",
    yes:                "Ja",
    no:                 "Nein",
    changeAccAnswer:    "Antwort ändern",
    wantsAccessoriesConfirmed: "Sie haben sich dafür entschieden, auch Zubehör zu bestellen.",
    continueToAccessories: "Weiter zum Zubehör →",
    noAccessoriesForThisBed: "Für dieses Bett gibt es in diesem Schritt kein Zubehör.",
    propAccessoryFor:   "Zubehör für {sku}",
    subAccessoryTitle:  "Zusätzliche Optionen für {v} (optional)",
    required:           "erforderlich",
    unavailable:        "Zurzeit nicht verfügbar",
    requiresMissing:    "Nur mit {v}",
    remove:             "Entfernen",
    fewer:              "Eins weniger",
    more:               "Eins mehr",
    slotTop:            "Oberes Bett",
    slotBottom:         "Unteres Bett",
    slotOther:          "Liegefläche {n}",
    slotGuest: "Gästebett",
    slotBedOnly: "Bett",
    noMattress: "Keine Matratze",
    sameAsBottom: "Wie das untere Bett: {v}",
    readMore: "Mehr Infos",
    createQuote:      "Angebot erstellen — {price}",
    createQuoteShort: "Angebot erstellen",
    quoteModalTitle:  "Angebot erstellen",
    quoteIntro:       "Damit wird ein PDF mit den fehlenden Teilen (und ggf. Zubehör) erstellt. Es wird nichts bestellt.",
    quoteEmailLabel:  "E-Mail-Adresse des Kunden",
    quoteEmailPlaceholder: "name@beispiel.de",
    quoteNameLabel:   "Name des Kunden",
    quoteNamePlaceholder: "Name",
    quoteDealerLabel: "Händlername",
    quoteDealerPlaceholder: "z. B. Kinderzimmer Berlin",
    quoteDealerRequired: "Bitte geben Sie den Händlernamen ein.",
    quoteNameRequired: "Bitte geben Sie den Namen des Kunden ein.",
    quoteDealerEmailLabel: "E-Mail-Adresse des Händlers",
    quoteDealerEmailPlaceholder: "haendler@beispiel.de",
    quoteInvalidDealerEmail: "Bitte geben Sie eine gültige E-Mail-Adresse des Händlers ein.",
    quoteDownloadBtn: "PDF herunterladen",
    quoteEmailBtn:    "Per E-Mail senden",
    quoteGenerating:  "Wird erstellt…",
    quoteCancelBtn:   "Abbrechen",
    quoteInvalidEmail:"Bitte geben Sie eine gültige E-Mail-Adresse ein.",
    quoteError:       "Beim Erstellen des Angebots ist etwas schiefgelaufen.",
    quoteNoItems:     "Bitte wählen Sie zuerst beide Betten.",
    quoteShareText:   "Angebot für {email}",
    quoteMailSubject: "Ihr Angebot von Lifetime Kidsrooms",
    quoteMailBody:    "Hallo,\n\nanbei das Angebot ({file}).\n\nMit freundlichen Grüßen,\nLifetime Kidsrooms",
    quotePdfTitle:    "Angebot",
    quotePdfDate:     "Datum",
    quotePdfDealer:   "Händler",
    quotePdfCustomer: "Kunde",
    quotePdfItem:     "Artikel",
    quotePdfSku:      "SKU",
    quotePdfQty:      "Menge",
    quotePdfPrice:    "Preis",
    quotePdfLineTotal:"Zwischensumme",
    quotePdfTotal:    "Gesamt",
    quotePdfNoPrices: "Preise sind in diesem Markt nicht verfügbar.",
    quotePdfFooter:   "Dies ist ein unverbindliches Angebot, keine Auftragsbestätigung.",
    quotePdfFooterPrices:      "Alle Preise sind unverbindliche Preisempfehlungen, inkl. MwSt.",
    quotePdfFooterErrors:      "Druckfehler vorbehalten",
    quotePdfFooterChanges:     "Preis- und Produktänderungen vorbehalten",
    quotePdfFooterColours:     "Farben können von der Realität abweichen.",
    quotePdfFooterAvailability:"Aufgrund von Produktionsbeschränkungen, Lagerbeständen oder verkaufsbezogenen Erwägungen kann die Verfügbarkeit erst nach Auftragserteilung bestätigt werden.",
    quotePdfContinued:"Fortsetzung",
  },
  fr: {
    stepOf:             "Étape {n} sur {total}",
    step1Title:         "Choisissez votre lit actuel",
    step2Title:         "Choisissez le lit que vous voulez",
    step2Sub:           "Vous ne voyez que les lits de même largeur, couleur et sommier que votre lit, dans un style autorisé. Une autre largeur ou couleur n'est pas possible avec cet outil.",
    slatsStepTitle:     "Quel sommier a votre lit ?",
    slatsStepSub:       "Ce lit existe avec plusieurs sommiers — choisissez celui que vous avez.",
    slatsStepNote:      "Vous avez choisi ce lit. Choisissez maintenant le sommier qui s'y trouve réellement :",
    step3Title:         "Pièces nécessaires",
    step3Sub:           "Choisissez les deux lits pour voir les pièces dont vous avez besoin.",
    step3SubDynamic:    "Voici ce qu'il vous faut pour transformer {from} en {to}.",
    lockedNote:         "Ceci reste identique à votre lit actuel :",
    changeLeftBed:      "Choisir un autre lit actuel",
    styleOnlyNote:      "Seul le style peut changer — et uniquement si c'est autorisé ici.",
    pinnedTitle: "Votre lit a :",
    pinnedWidth: "Largeur",
    pinnedColour: "Couleur",
    pinnedSlats: "Sommier",
    notListedTitle: "Vous ne trouvez pas le lit souhaité ?",
    notListedBody: "Saisissez son nom ou son SKU dans le champ de recherche et nous vous montrerons pourquoi ce n'est pas possible avec votre lit. Un autre sommier ne peut pas non plus être changé ici ; veuillez contacter le service client.",
    excludedTitle: "Impossible avec votre lit",
    reasonWidth: "autre largeur ({v})",
    reasonColour: "autre couleur ({v})",
    reasonSlats: "autre sommier ({v})",
    reasonStyle: "la reconstruction vers ce style n'est pas autorisée",
    excludedMore: "+ {n} de plus — affinez votre recherche",
    excludedBecause: "Pourquoi pas : {r}",
    changeBothBeds:     "Choisir d'autres lits",
    prev:               "← Précédent",
    next:               "Suivant →",
    noMatch:            "Aucun lit ne correspond à cette combinaison",
    chooseAllFilters:   "Choisissez une valeur pour chaque filtre ci-dessus pour voir les lits.",
    noRightMatches:     "Aucune reconstruction autorisée n'est encore configurée pour le style de ce lit",
    searchPlaceholder:  "Rechercher par SKU ou nom…",
    clearSearch:        "Effacer la recherche",
    noSearchMatch:      "Aucun lit trouvé pour « {query} »",
    orUseFilters:       "ou utilise les filtres pour trouver ton lit",
    chooseLeftFirst:    "Choisissez d'abord votre lit actuel",
    chooseRightBed:     "Choisissez le lit que vous souhaitez obtenir",
    sameBed:            "C'est le même lit — il ne manque rien",
    noPartsMissing:     "Rien ne manque — ce lit n'a besoin d'aucune pièce supplémentaire",
    notOrderableYet:    "Pas encore disponible à la commande",
    dataMissingWarning: "La liste des pièces de ce lit n'a pas encore été renseignée, la comparaison peut donc être incomplète.",
    total:              "Total",
    addToCart:          "Ajouter au panier — {price}",
    addToCartShort:     "Ajouter au panier",
    rebuildNotOrderable: "Cette transformation ne peut pas encore être commandée : une ou plusieurs pièces nécessaires ne sont pas encore disponibles dans la boutique. Veuillez nous contacter.",
    startOver:          "Recommencer",
    cartError:          "Une erreur s'est produite lors de l'ajout de ces pièces au panier.",
    networkError:       "Erreur réseau : {msg}",
    loadError:          "Impossible de charger le configurateur de reconstruction ({msg}).",
    propRebuild:        "Reconstruction",
    rebuildTitleLine:   "Transformation de {from} en {to}",
    specsShow:      "Caractéristiques",
    specsClose:     "Fermer",
    infoProductPage:"Voir la fiche produit",
    wantAccessoriesQuestion: "Souhaitez-vous aussi commander des accessoires pour ce lit ?",
    yes:                "Oui",
    no:                 "Non",
    changeAccAnswer:    "Changer de réponse",
    wantsAccessoriesConfirmed: "Vous avez choisi de commander aussi des accessoires.",
    continueToAccessories: "Continuer vers les accessoires →",
    noAccessoriesForThisBed: "Aucun accessoire disponible pour ce lit à cette étape.",
    propAccessoryFor:   "Accessoire pour {sku}",
    subAccessoryTitle:  "Options supplémentaires pour {v} (facultatif)",
    required:           "obligatoire",
    unavailable:        "Momentanément indisponible",
    requiresMissing:    "Nécessite {v}",
    remove:             "Supprimer",
    fewer:              "Un de moins",
    more:               "Un de plus",
    slotTop:            "Couchage supérieur",
    slotBottom:         "Couchage inférieur",
    slotOther:          "Couchage {n}",
    slotGuest: "Lit d'appoint",
    slotBedOnly: "Lit",
    noMattress: "Pas de matelas",
    sameAsBottom: "Identique au couchage inférieur : {v}",
    readMore: "Plus d'infos",
    createQuote:      "Créer un devis — {price}",
    createQuoteShort: "Créer un devis",
    quoteModalTitle:  "Créer un devis",
    quoteIntro:       "Ceci crée un PDF avec les pièces manquantes (et les accessoires, le cas échéant). Aucune commande n'est passée.",
    quoteEmailLabel:  "Adresse e-mail du client",
    quoteEmailPlaceholder: "nom@exemple.fr",
    quoteNameLabel:   "Nom du client",
    quoteNamePlaceholder: "Nom",
    quoteDealerLabel: "Nom du revendeur",
    quoteDealerPlaceholder: "p. ex. Chambre d'enfant Paris",
    quoteDealerRequired: "Veuillez saisir le nom du revendeur.",
    quoteNameRequired: "Veuillez saisir le nom du client.",
    quoteDealerEmailLabel: "Adresse e-mail du revendeur",
    quoteDealerEmailPlaceholder: "revendeur@exemple.fr",
    quoteInvalidDealerEmail: "Veuillez saisir une adresse e-mail valide pour le revendeur.",
    quoteDownloadBtn: "Télécharger le PDF",
    quoteEmailBtn:    "Envoyer par e-mail",
    quoteGenerating:  "Création…",
    quoteCancelBtn:   "Annuler",
    quoteInvalidEmail:"Veuillez saisir une adresse e-mail valide.",
    quoteError:       "Une erreur s'est produite lors de la création du devis.",
    quoteNoItems:     "Veuillez d'abord choisir les deux lits.",
    quoteShareText:   "Devis pour {email}",
    quoteMailSubject: "Votre devis Lifetime Kidsrooms",
    quoteMailBody:    "Bonjour,\n\nVeuillez trouver le devis en pièce jointe ({file}).\n\nCordialement,\nLifetime Kidsrooms",
    quotePdfTitle:    "Devis",
    quotePdfDate:     "Date",
    quotePdfDealer:   "Revendeur",
    quotePdfCustomer: "Client",
    quotePdfItem:     "Article",
    quotePdfSku:      "SKU",
    quotePdfQty:      "Qté",
    quotePdfPrice:    "Prix",
    quotePdfLineTotal:"Sous-total",
    quotePdfTotal:    "Total",
    quotePdfNoPrices: "Les prix ne sont pas disponibles sur ce marché.",
    quotePdfFooter:   "Ceci est un devis sans engagement, pas une confirmation de commande.",
    quotePdfFooterPrices:      "Tous les prix sont des prix de vente conseillés, TVA incluse",
    quotePdfFooterErrors:      "Sous réserve d'erreurs typographiques",
    quotePdfFooterChanges:     "Sous réserve de modifications de prix et de produits",
    quotePdfFooterColours:     "Les couleurs peuvent différer de la réalité.",
    quotePdfFooterAvailability:"En raison de contraintes de production, de la disponibilité des stocks ou de considérations commerciales, la disponibilité ne peut être confirmée qu'après la passation de la commande.",
    quotePdfContinued:"suite",
  },
};

function rDetectLocale(){
  const fromSetting = window.REBUILD_CONFIGURATOR_SETTINGS && window.REBUILD_CONFIGURATOR_SETTINGS.locale;
  const raw = fromSetting
    || (window.Shopify && window.Shopify.locale)
    || document.documentElement.getAttribute("lang")
    || "en";
  return String(raw).toLowerCase().split("-")[0];
}
const R_LOCALE = rDetectLocale();

function rt(key, vars){
  const dict = R_TRANSLATIONS[R_LOCALE] || R_TRANSLATIONS.en;
  let str = (dict && dict[key]) || R_TRANSLATIONS.en[key] || key;
  if (vars) for (const k in vars) str = str.replace("{"+k+"}", vars[k]);
  return str;
}

/* =====================================================================
   DATA LADEN & STATE
   ===================================================================== */
var RDATA = null;
var filters = {};              // gekozen waarden van de filters bovenaan
var selectedLeftSku = null;    // definitief gekozen "huidig bed" (specifieke SKU, dus met lattenbodem)
var selectedRightSku = null;   // gekozen "bed dat je ervan maakt"

/* Welk bed (los van de lattenbodem) er in stap 1 is aangeklikt -- op
   verzoek 30 aug 2026. Eén "bed" kan meerdere lattenbodem-uitvoeringen
   hebben (verschillende SKU's, verder identiek); dit onthoudt WELKE van
   die bedden is aangeklikt, ook zolang de exacte lattenbodem nog niet is
   gekozen (dus voordat selectedLeftSku definitief gezet wordt). Zie
   rBedGroupKey()/rPickLeftBed()/rPickLeftSlats() hieronder. */
var selectedLeftGroupKey = null;

/* Zoekveld boven de bedoverzichten in stap 1 en 2 (30 aug 2026) -- vooral
   bedoeld voor service-mensen die een SKU uit hun hoofd kennen, maar zoekt
   voor de zekerheid ook mee op de productnaam. Puur front-end: filtert
   alleen wat al op het scherm staat, raakt geen data of backend. Losse
   state per stap, want de kandidatenlijst is in stap 1 en 2 een andere. */
var rSearchLeft = "";
var rSearchRight = "";

/* Accessoirevraag in stap 3 (28 aug 2026): null = nog niet beantwoord,
   true = "ja, ook accessoires", false = "nee, alleen de onderdelen". */
var rWantsAcc = null;
var selectedRAcc = {};   // keuze-sleutel -> accessoire-object
var rAccQty = {};        // keuze-sleutel -> aantal (minimaal 1)
// Sub-accessoires (12 sep 2026, bv. de matraskeuze voor het logeerbed): een
// EXTRA, optionele keuze die pas verschijnt zodra een bepaalde "ouder"-
// accessoire gekozen is. Bewust een eigen, aparte state-vorm i.p.v.
// hergebruik van selectedRAcc/rAccQty -- zie de toelichting bij
// rSubAccessoryOf() verderop, en om dezelfde reden als selectedRAcc zelf
// (rebuild-configurator.js) een losse kopie is van selectedAcc
// (configurator.js): niets delen, niets kunnen breken.
// Bewust gekozen "Geen matras" per stap|categorie|ligvlak (zelfde idee als
// geenKeuze in configurator.js). In de rebuild-tool is dit puur een
// weergave-keuze: er wordt niets besteld en de Volgende-knop blijft vrij.
var rGeenKeuze = {};
var selectedRSubAcc = {};   // sku (hoofdletters) -> accessoire-object
// Aantal per sub-accessoire (10 sep 2026, max_qty-ondersteuning). Los van
// rAccQty: de sleutel hier is altijd de kale SKU (geen ligvlak).
var rSubAccQty = {};        // sku (hoofdletters) -> aantal (minimaal 1)

function loadRebuildData(){
  const app = document.getElementById("rebuild-app");
  const el = document.getElementById("bed-rebuild-data");
  if (!app) return; // sectie niet op deze pagina
  if (!el) {
    app.innerHTML = `<div class="empty-note">${rt("loadError", {msg: "geen databron gevonden op de pagina"})}</div>`;
    return;
  }
  try {
    RDATA = JSON.parse(el.textContent);
  } catch (e) {
    app.innerHTML = `<div class="empty-note">${rt("loadError", {msg: e.message})}</div>`;
    return;
  }

  // Liquid levert prijzen in centen; de rest van de code rekent in eenheden.
  (RDATA.beds || []).forEach(b => {
    if (b.shopify && b.shopify.price != null && b.shopify.price !== "") {
      b.shopify.price = Number(b.shopify.price) / 100;
    }
  });
  (RDATA.parts || []).forEach(p => {
    if (p.shopify && p.shopify.price != null && p.shopify.price !== "") {
      p.shopify.price = Number(p.shopify.price) / 100;
    }
  });
  (RDATA.accessories || []).forEach(a => {
    if (a.shopify && a.shopify.price != null && a.shopify.price !== "") {
      a.shopify.price = Number(a.shopify.price) / 100;
    }
  });

  RDATA.filters = (RDATA.filters || []).slice().sort((a, b) => (+a.order) - (+b.order));
  RDATA.steps = (RDATA.steps || []).slice().sort((a, b) => (+a.step_no) - (+b.step_no));
  RDATA.compatMap = rBouwCompatMap(RDATA.accessories || [], RDATA.beds || []);
  rApplyDefaultFilters();

  // Meten (15 sep 2026): de ombouw-tool is hier succesvol geopend met echte
  // data uit Shopify (anders was hierboven al gestopt met een foutmelding).
  // Eén keer per bezoek, zelfde principe als meldBron()/gebruikGemeld in
  // configurator.js -- die heeft ook nog een "demo"-uitzondering, maar die
  // is hier niet nodig: dit bestand heeft geen demo-terugval.
  if (!rGebruikGemeld) {
    rGebruikGemeld = true;
    rMeetGebeurtenis("bed_rebuild_view", { channel: rMeetKanaal() });
  }

  renderR();
}

/* =====================================================================
   FILTERS BOVENAAN — trechterlogica zoals in de bestaande configurator,
   maar beperkt tot TOP_FILTER_KEYS en op ÉÉN gedeelde state.
   ===================================================================== */
function rFiltersOrder(){
  const alle = RDATA.filters || [];
  return TOP_FILTER_KEYS.map(key => alle.find(f => f.filter_key === key)).filter(Boolean);
}

/* Breedte wordt in deze tool gegroepeerd tot drie vaste opties: 90, 120 en
   140. Een ruwe waarde als "90 & 120" (bv. een stapelbed met twee
   breedtes) valt onder de groep waar hij MEE BEGINT -- dus "90 & 120" en
   "90 & 90" horen allebei bij 90, ongeacht wat er na de "&" staat. Dit
   geldt uitsluitend voor het filter/de vergelijking in déze tool; het
   raakt het metafield zelf of de hoofdconfigurator niet. */
var WIDTH_BUCKETS = ["90", "120", "140"];
function rWidthBucket(raw){
  const s = String(raw || "").trim();
  return WIDTH_BUCKETS.find(b => s.startsWith(b)) || null;
}

function rBedMatchesFilterValue(bed, filterKey, gekozen){
  if (filterKey === "filter_width") return rWidthBucket(bed.filter_width) === gekozen;
  const waarden = String(bed[filterKey] || "").split(",").map(x => x.trim().toLowerCase());
  return waarden.includes(String(gekozen).toLowerCase());
}

function rBedMatchesState(bed, state){
  return rFiltersOrder().every(f => {
    const gekozen = state[f.filter_key];
    if (!gekozen) return true;
    return rBedMatchesFilterValue(bed, f.filter_key, gekozen);
  });
}

function rMatches(state){
  return (RDATA.beds || []).filter(b => rBedMatchesState(b, state));
}

function rFilterUnlocked(i, state){
  const ordered = rFiltersOrder();
  for (let j = 0; j < i; j++) {
    const f = ordered[j];
    if (f.optional === "yes") continue;
    if (!state[f.filter_key]) return false;
  }
  return true;
}

function rValuesForFilter(i, state){
  const ordered = rFiltersOrder();
  const f = ordered[i];
  const kandidaten = (RDATA.beds || []).filter(b =>
    ordered.slice(0, i).every(ff => {
      const gekozen = state[ff.filter_key];
      if (!gekozen) return true;
      return rBedMatchesFilterValue(b, ff.filter_key, gekozen);
    })
  );
  const set = new Set();
  if (f.filter_key === "filter_width") {
    kandidaten.forEach(b => { const bucket = rWidthBucket(b.filter_width); if (bucket) set.add(bucket); });
    return WIDTH_BUCKETS.filter(b => set.has(b));
  }
  kandidaten.forEach(b => {
    String(b[f.filter_key] || "").split(",").map(x => x.trim()).filter(Boolean).forEach(v => set.add(v));
  });
  return [...set];
}

function rUniqueFilterVals(key){
  if (key === "filter_width") {
    const set = new Set();
    (RDATA.beds || []).forEach(b => { const bucket = rWidthBucket(b.filter_width); if (bucket) set.add(bucket); });
    return WIDTH_BUCKETS.filter(b => set.has(b));
  }
  const set = new Set();
  (RDATA.beds || []).forEach(b =>
    String(b[key] || "").split(",").map(x => x.trim()).filter(Boolean).forEach(v => set.add(v))
  );
  return [...set];
}

const rAutoPickGewaarschuwd = new Set();

// Kiest voor `filterKey` de best-beschikbare waarde uit `kandidaten` volgens
// AUTO_PICK_PRIORITY (eerste match in de voorkeurslijst wint). Geeft null
// terug als er voor dit filter geen voorkeurslijst is, of als geen enkele
// voorkeur bij de huidige kandidaten past (dan blijft het filter leeg, met
// een eenmalige waarschuwing in de console).
function rAutoPickWaarde(filterKey, kandidaten){
  const voorkeuren = AUTO_PICK_PRIORITY[filterKey];
  if (!voorkeuren) return null;
  for (const voorkeur of voorkeuren) {
    const gevonden = rFindMatchingValue(filterKey, kandidaten, voorkeur);
    if (gevonden) return gevonden;
  }
  const sleutel = filterKey + ":" + kandidaten.join("|");
  if (!rAutoPickGewaarschuwd.has(sleutel)) {
    rAutoPickGewaarschuwd.add(sleutel);
    console.warn(`Rebuild configurator: geen van de voorkeurswaarden voor ${filterKey} (${voorkeuren.join(", ")}) is gevonden — dit filter blijft leeg. Beschikbare waarden: ${kandidaten.join(", ") || "(geen)"}.`);
  }
  return null;
}

function rAutoAdvance(state){
  const ordered = rFiltersOrder();
  let gewijzigd = true;
  let veiligheidsteller = 0;
  while (gewijzigd && veiligheidsteller < 50) {
    gewijzigd = false;
    veiligheidsteller++;
    for (let i = 0; i < ordered.length; i++) {
      const f = ordered[i];
      if (state[f.filter_key]) continue;
      if (f.optional === "yes") continue;
      if (!rFilterUnlocked(i, state)) continue;
      const mogelijk = rValuesForFilter(i, state);
      if (mogelijk.length === 0) continue;
      if (mogelijk.length === 1) {
        state[f.filter_key] = mogelijk[0];
        gewijzigd = true;
        continue;
      }
      // Meerdere kandidaten mogelijk: geen automatische keuze voor style
      // (geen voorkeurslijst), maar width/colour/slats krijgen altijd een
      // waarde via AUTO_PICK_PRIORITY, zodat er nooit een filter open blijft
      // staan zolang er een voorkeur beschikbaar is.
      const voorkeur = rAutoPickWaarde(f.filter_key, mogelijk);
      if (voorkeur) {
        state[f.filter_key] = voorkeur;
        gewijzigd = true;
      }
    }
  }
}

const rGewaarschuwd = new Set();
function rWaardeLabel(filterKey, waarde){
  const lijst = (RDATA && RDATA.filterValueLabels) || [];
  const gevonden = lijst.find(v =>
    v.filter_key === filterKey && String(v.key).toLowerCase() === String(waarde).toLowerCase());
  if (gevonden && gevonden.label) return gevonden.label;
  const sleutel = filterKey + ":" + waarde;
  if (lijst.length && !rGewaarschuwd.has(sleutel)) {
    rGewaarschuwd.add(sleutel);
    console.warn(`Rebuild configurator: geen vertaling voor ${filterKey}:"${waarde}".`);
  }
  return waarde;
}

// Zoekt in `kandidaten` (ruwe waarden) naar iets dat overeenkomt met
// `wanted` — geprobeerd wordt, in volgorde: exacte ruwe waarde, exact
// vertaald label, losse-woorden-match op de ruwe waarde, losse-woorden-match
// op het vertaalde label. Geeft de RUWE waarde terug (zodat hij verder in
// `filters` past), of null als er niets bij past.
function rFindMatchingValue(filterKey, kandidaten, wanted){
  if (!wanted) return null;
  const w = String(wanted).trim().toLowerCase();
  if (!w) return null;

  let hit = kandidaten.find(v => String(v).trim().toLowerCase() === w);
  if (hit) return hit;

  hit = kandidaten.find(v => String(rWaardeLabel(filterKey, v)).trim().toLowerCase() === w);
  if (hit) return hit;

  const woorden = w.split(/[\s,.\-_/]+/).filter(Boolean);
  if (!woorden.length) return null;

  hit = kandidaten.find(v => {
    const vLower = String(v).toLowerCase();
    return woorden.every(word => vLower.includes(word));
  });
  if (hit) return hit;

  hit = kandidaten.find(v => {
    const lLower = String(rWaardeLabel(filterKey, v)).toLowerCase();
    return woorden.every(word => lLower.includes(word));
  });
  return hit || null;
}

// Vult bij het laden de filters vast met DEFAULT_FILTERS, in dezelfde
// volgorde als TOP_FILTER_KEYS (elke stap gebruikt de dan nog geldige
// kandidaten, want een eerdere keuze beperkt de latere — zelfde trechter
// als wanneer een klant zelf klikt). Filters die al een waarde hebben
// (bv. na een eerdere aanroep) worden overgeslagen.
function rApplyDefaultFilters(){
  const ordered = rFiltersOrder();
  ordered.forEach((f, i) => {
    if (filters[f.filter_key]) return;
    const wanted = DEFAULT_FILTERS[f.filter_key];
    if (!wanted) return;
    if (!rFilterUnlocked(i, filters)) return;
    const kandidaten = rValuesForFilter(i, filters);
    const gevonden = rFindMatchingValue(f.filter_key, kandidaten, wanted);
    if (gevonden) {
      filters[f.filter_key] = gevonden;
    } else {
      console.warn(`Rebuild configurator: startwaarde "${wanted}" voor ${f.filter_key} niet gevonden in de data — dit filter blijft leeg. Beschikbare waarden: ${kandidaten.join(", ") || "(geen)"}.`);
    }
  });
  rAutoAdvance(filters);
}

// Zijn alle (niet-optionele) filters bovenaan gekozen? Zolang dat niet zo
// is, tonen we bewust geen enkel bed — een keuze is bij elk filter verplicht.
function rAllTopFiltersChosen(){
  return rFiltersOrder().every(f => f.optional === "yes" || !!filters[f.filter_key]);
}

function rToggleFilter(key, value){
  // Een filter mag nooit leeg komen te staan: nogmaals op de al gekozen
  // pil klikken doet dus NIETS. Een filter "uitzetten" kan alleen indirect,
  // door er een ANDERE waarde voor te kiezen (of door een filter hogerop
  // te wijzigen, wat alles eronder opnieuw laat kiezen).
  if (String(filters[key] || "").toLowerCase() === String(value).toLowerCase()) {
    return;
  }
  const ordered = rFiltersOrder();
  const idx = ordered.findIndex(f => f.filter_key === key);
  filters[key] = value;
  // Een keuze wijzigen wist alles ERONDER, net als in de bestaande configurator.
  ordered.slice(idx + 1).forEach(f => delete filters[f.filter_key]);
  rAutoAdvance(filters);
  // De pool bedden verandert -> eerdere keuzes links/rechts vervallen.
  selectedLeftSku = null;
  selectedLeftGroupKey = null;
  selectedRightSku = null;
  rResetAccKeuze();
  rSearchLeft = "";
  rSearchRight = "";
  renderR();
}

/* =====================================================================
   LINKS/RECHTS SELECTEREN
   ===================================================================== */
function rLeftBed(){
  return selectedLeftSku ? (RDATA.beds || []).find(b => b.sku === selectedLeftSku) || null : null;
}
function rRightBed(){
  return selectedRightSku ? (RDATA.beds || []).find(b => b.sku === selectedRightSku) || null : null;
}
function rFindBed(sku){
  const key = String(sku || "").trim().toUpperCase();
  return (RDATA.beds || []).find(b => String(b.sku || "").trim().toUpperCase() === key) || null;
}

/* "Hetzelfde bed" los van de lattenbodem (30 aug 2026): alle velden die een
   ANDER bed zouden maken, behalve filter_slats zelf en de SKU/onderdelen-
   lijst/Shopify-info (die verschillen juist WEL per lattenbodem-variant).
   Twee varianten met dezelfde sleutel zijn dus "hetzelfde bed, andere
   lattenbodem" -- daar gaat de nieuwe tussenstap over. */
function rBedGroupKey(bed){
  return [
    "filter_style", "filter_bedtype", "filter_top", "filter_ladder", "filter_width", "filter_extra", "filter_colour",
  ].map(k => String((bed && bed[k]) || "").trim().toLowerCase()).join("||");
}

// Alle lattenbodem-varianten van "hetzelfde bed" (zie rBedGroupKey hierboven),
// in de volgorde waarin ze in RDATA.beds staan.
function rSlatsVariantsForGroup(groupKey){
  return (RDATA.beds || []).filter(b => rBedGroupKey(b) === groupKey);
}

// Groepeert een lijst bedden (varianten) tot "dezelfde bedden" -- gebruikt
// om de rasterweergave in stap 1 te ontdubbelen, zodat een bed met
// meerdere lattenbodems niet als 2 of 3 haast-identieke kaartjes verschijnt.
// Geeft een array van arrays terug (elke sub-array = alle varianten van
// één bed), in de volgorde waarin de groepen voor het eerst voorkomen.
function rGroupBedsBySlats(bedsList){
  const volgorde = [];
  const map = new Map();
  (bedsList || []).forEach(b => {
    const key = rBedGroupKey(b);
    if (!map.has(key)) { map.set(key, []); volgorde.push(key); }
    map.get(key).push(b);
  });
  return volgorde.map(key => map.get(key));
}

// Aantal VERSCHILLENDE lattenbodem-waarden binnen een groep. Bewust niet
// gewoon het aantal SKU's tellen: als twee SKU's toevallig dezelfde
// lattenbodem-waarde hebben (bv. een bed waarvan de onderdelenlijst nog in
// twee losse regels staat, of een echte datafout), heeft een vraag "welke
// lattenbodem zit erin" geen zinnig antwoord om uit te kiezen -- dan is er
// feitelijk maar 1 optie en slaan we de tussenstap gewoon over.
function rDistinctSlatsCount(groupBeds){
  const set = new Set();
  (groupBeds || []).forEach(b => set.add(String((b && b.filter_slats) || "").trim().toLowerCase()));
  return set.size;
}

function rLeftGroupHasSlatsChoice(){
  if (!selectedLeftGroupKey) return false;
  return rDistinctSlatsCount(rSlatsVariantsForGroup(selectedLeftGroupKey)) > 1;
}

// Definitieve, directe keuze voor het huidige bed -- ÉÉN specifieke SKU
// (dus de lattenbodem staat al vast). Houdt selectedLeftGroupKey gelijk
// aan die SKU, zodat rLeftGroupHasSlatsChoice()/rAllSteps() altijd weten
// bij welke "bedgroep" de definitieve keuze hoort, ook wanneer deze
// functie direct wordt aangeroepen (bv. door bestaande tests of eender
// welke andere plek die meteen een concrete SKU kiest).
function rSelectLeft(sku){
  selectedLeftSku = sku || null;
  selectedLeftGroupKey = sku ? rBedGroupKey(rFindBed(sku)) : null;
  selectedRightSku = null; // rechterkant hangt af van het linker bed, dus opnieuw kiezen
  rResetAccKeuze(); // ander huidig bed kan een ander gewenst bed opleveren, dus de accessoirevraag opnieuw
  rSearchRight = ""; // nieuwe kandidatenlijst in stap 2, oude zoekopdracht is niet meer relevant
  renderR();
}

// Klant klikt een bedkaartje aan in stap 1 (via de filters óf via zoeken).
// `repSku` is de SKU van de representatieve variant die op dat kaartje
// getoond werd (bij een bed met maar 1 lattenbodem is dat toch al de enige
// echte SKU). Heeft dit bed maar 1 ECHTE lattenbodem-uitvoering (zie
// rDistinctSlatsCount hierboven), dan is de keuze meteen definitief (zoals
// voorheen, via rSelectLeft). Zijn er meerdere, dan onthouden we welk BED
// gekozen is -- de SKU staat dan nog niet vast, dus de precieze lattenbodem
// moet nog gekozen worden in de nieuwe tussenstap.
//
// Springt NIET automatisch door naar die tussenstap (op verzoek 1 sep
// 2026: dat voelde inconsistent, want een klik in stap 2/3 springt ook
// nooit vanzelf door). Het gekozen kaartje toont zich meteen als
// "geselecteerd" (zie rRenderStep1BedGrid), de stappenlijst krijgt er al
// wel de nieuwe tussenstap bij (rAllSteps() kijkt naar selectedLeftGroupKey)
// en de "Volgende"-knop wordt daardoor meteen bruikbaar -- de klant klikt
// zelf verder, net als bij elke andere stap.
function rPickLeftBed(repSku){
  const rep = rFindBed(repSku);
  if (!rep) return;
  const groupKey = rBedGroupKey(rep);
  const varianten = rSlatsVariantsForGroup(groupKey);
  if (rDistinctSlatsCount(varianten) > 1) {
    selectedLeftGroupKey = groupKey;
    selectedLeftSku = null; // pas definitief zodra de lattenbodem-vraag beantwoord is
    selectedRightSku = null;
    rResetAccKeuze();
    rSearchRight = "";
    renderR();
  } else {
    rSelectLeft(varianten.length ? varianten[0].sku : rep.sku);
  }
}

// Klant beantwoordt de "welke lattenbodem?"-tussenstap. Maakt de keuze uit
// rPickLeftBed() hierboven definitief. Net als bij een ondubbelzinnige
// bedkeuze (rPickLeftBed met maar 1 variant) gaat de tool NIET vanzelf naar
// stap 2 -- de klant klikt zelf op "Volgende", zodat er nog even tijd is om
// de referentie-informatie te bekijken.
function rPickLeftSlats(sku){
  const bed = rFindBed(sku);
  if (!bed || rBedGroupKey(bed) !== selectedLeftGroupKey) return; // hoort niet bij het gekozen bed -- negeren
  rSelectLeft(sku);
}

function rSelectRight(sku){
  selectedRightSku = sku;
  rResetAccKeuze(); // ander gewenst bed: eerdere accessoirekeuzes/antwoord passen mogelijk niet meer
  renderR();
}

// De accessoirevraag en eventueel al gekozen accessoires horen bij ÉÉN
// specifiek gewenst bed. Verandert dat bed (of het huidige bed, want dat
// kan het gewenste bed indirect wijzigen), dan beginnen we voor de
// accessoires gewoon opnieuw -- eenvoudiger en veiliger dan proberen te
// bepalen welke keuzes toevallig nog passen.
function rResetAccKeuze(){
  rWantsAcc = null;
  selectedRAcc = {};
  rAccQty = {};
  selectedRSubAcc = {};
  rSubAccQty = {};
  rGeenKeuze = {};
}

// Welke stijlen mag je vanuit deze stijl "overstappen", volgens het
// metaobject "Configurator rebuild rule"? Hoofdletterongevoelig, net als de
// rest van de configurator.
function rAllowedTargetStyles(style){
  const key = String(style || "").toLowerCase();
  const set = new Set();
  (RDATA.styleTransitions || []).forEach(r => {
    if (String(r.from || "").toLowerCase() === key && r.to) set.add(String(r.to));
  });
  return set;
}

// Bedden waar je het gekozen linker bed naartoe kan ombouwen: zelfde
// breedte, kleur en lattenbodem (die liggen vast), en een stijl die is
// toegestaan vanuit de stijl van het linker bed. Bedtype/top/ladder/extra
// spelen bewust geen rol.
function rRightCandidates(leftBed){
  if (!leftBed) return [];
  const toegestaan = new Set([...rAllowedTargetStyles(leftBed.filter_style)].map(s => s.toLowerCase()));
  if (!toegestaan.size) return [];
  return (RDATA.beds || []).filter(b => {
    if (b.sku === leftBed.sku) return false;
    if (rWidthBucket(b.filter_width) !== rWidthBucket(leftBed.filter_width)) return false;
    if (String(b.filter_colour || "").toLowerCase() !== String(leftBed.filter_colour || "").toLowerCase()) return false;
    if (String(b.filter_slats || "").toLowerCase() !== String(leftBed.filter_slats || "").toLowerCase()) return false;
    return toegestaan.has(String(b.filter_style || "").toLowerCase());
  });
}

/* =====================================================================
   FOTO'S — zelfde eenvoudige terugval als elders: configuratorfoto
   proberen, bij een 404 terugvallen op de gewone productfoto.
   ===================================================================== */
function rFotoVan(item){
  const sh = (item && item.shopify) || {};
  return sh.configuratorImage || sh.image || "";
}
// Terugvalfoto voor de PDF (fetch-gebaseerd, kent geen onerror): dezelfde
// gewone product-/variantfoto als rFotoOnErrorAttr hieronder voor het
// scherm gebruikt. Alleen zinvol als er OOK een configuratorfoto is (staat
// er geen, dan is sh.image al de eerste keus in rFotoVan en is er dus
// niets om op terug te vallen). Zie offerte-pdf.js/rGenereerOffertePdf.
function rFotoTerugval(item){
  const sh = (item && item.shopify) || {};
  return (sh.configuratorImage && sh.image) ? sh.image : "";
}
function rFotoOnErrorAttr(item){
  const sh = (item && item.shopify) || {};
  const terugval = sh.image || "";
  if (!terugval) return "this.style.display='none'";
  const url = String(terugval).replace(/'/g, "\\'");
  return `if(!this.dataset.tweede){this.dataset.tweede=1;this.src='${url}';}else{this.style.display='none'}`;
}

/* Lattenbodemfoto's (tussenstap): hergebruikt dezelfde, al geüploade
   foto's als de hoofdconfigurator (Content > Files: "configurator-16-
   slats.webp", "-23-", "-28-" — zie beheerhandleiding.md). filesBase komt
   uit rebuild-configurator-data.liquid (zelfde Liquid-truc als
   configurator-data-2.liquid). Als er geen filesBase is, of geen getal in
   de lattenbodemwaarde staat, geven we "" terug zodat de aanroeper op de
   gewone bedfoto terugvalt -- er wordt hier nooit een kapotte src getoond. */
function rSlatsFoto(waarde){
  const basis = (RDATA && RDATA.filesBase) || "";
  if (!basis) return "";
  const m = String(waarde || "").match(/(\d+)/);
  if (!m) return "";
  return basis + "configurator-" + m[1] + "-slats.webp";
}
/* Als de specifieke lattenbodemfoto zelf 404 geeft, terugvallen op de
   gewone bedfoto van dat SKU (en pas daarna, zoals gebruikelijk, op de
   productfoto) -- nooit een lege/kapotte afbeelding tonen. */
function rSlatsFotoOnErrorAttr(bed){
  const terugval = rFotoVan(bed);
  if (!terugval) return "this.style.display='none'";
  const url = String(terugval).replace(/'/g, "\\'");
  return `if(!this.dataset.tweede){this.dataset.tweede=1;this.src='${url}';}else{this.style.display='none'}`;
}

/* =====================================================================
   PRIJS
   ===================================================================== */
function rCurrency(){
  const b = (RDATA.beds || []).find(x => x.shopify && x.shopify.currency)
         || (RDATA.parts || []).find(x => x.shopify && x.shopify.currency);
  return b ? b.shopify.currency : null;
}

function rMoney(v, cur){
  if (v == null || v === "") return "";
  const n = Number(v);
  if (!isFinite(n)) return "";
  const currency = cur || rCurrency() || "";
  if (!currency) return n.toFixed(2);
  try {
    return new Intl.NumberFormat(R_LOCALE, {
      style: "currency",
      currency,
      minimumFractionDigits: Number.isInteger(n) ? 0 : 2,
      maximumFractionDigits: 2,
    }).format(n);
  } catch {
    return currency + " " + n.toFixed(2);
  }
}

/* =====================================================================
   PAKKETTEN VAN MEERDERE ONDERDELEN (9 sep 2026, herzien 12 sep 2026)
   Sommige SKU's zijn geen "samengesteld artikel" maar een fysiek pakket
   waar meerdere losse onderdelen samen in 1 doos zitten. Voorbeeld: SKU 671
   bevat de losse onderdelen 626, 670, "616 1" en 624 (per kleur een eigen
   SKU-reeks). Zonder deze tabel ziet rComputeDiff() geen verband tussen
   671 en zijn losse onderdelen, met als gevolg dat een klant die al een
   671 heeft toch nog eens de losse onderdelen erbij krijgt aangeboden (of
   omgekeerd) -- dubbele onderdelen in de ombouw.

   Beheer: per KLEUR een eigen regel (de losse SKU's verschillen per kleur).

   Herzien 12 sep 2026: de eerdere versie (twee losse "aan/uit"-regels, één
   per richting) bleek een praktijkgeval niet te dekken. Gemeld: bed 4930
   heeft in zijn EIGEN onderdelenlijst het pakket 671 staan; een klant met
   bed 4940 die al 3 van de 4 losse onderdelen van dat pakket heeft (alleen
   624 mist) kreeg bij een ombouw naar 4930 toch het HELE pakket 671 als
   "ontbrekend" te zien -- terwijl alleen het losse onderdeel 624 er nog
   bij moest. De vorige regel telde een pakket namelijk alleen als "in
   bezit" bij een VOLLEDIGE match van alle losse onderdelen; bij een
   gedeeltelijke match (3 van de 4) gebeurde er niets, en bleef het volledige
   pakket als ontbrekend staan.

   Nieuwe, eenvoudiger opzet: vóór de vergelijking wordt een pakket-SKU in
   ZOWEL bed A als bed B se eigen onderdelenlijst altijd VERVANGEN door zijn
   losse onderdelen (rPlatgeslagenAantallen hieronder) -- dus nooit een
   pakket-SKU én zijn losse onderdelen tegelijk meetellen. Daarna vergelijkt
   rComputeDiff() gewoon per los onderdeel, met dezelfde aantallen-logica
   als altijd (7 sep 2026-bugfix). Dat werkt vanzelf correct in elke
   combinatie: bed A/B met het pakket, met (een deel van) de losse
   onderdelen, of een mix -- inclusief dit gemelde geval (alleen het ene
   missende losse onderdeel komt op de lijst, niet het hele pakket).

   Let op: "616 1-10"/"616 1-01W" bestonden op 9 sep 2026 nog niet als
   artikel in de webshop (geverifieerd) -- ze staan hier vast alvast in,
   zodra ze zijn aangemaakt werkt de koppeling automatisch mee. */
var PART_PACKAGES = {
  "671-10":  ["626-10", "670-10", "616 1-10", "624-10"],
  "671-01W": ["626-01W", "670-01W", "616 1-01W", "624-01W"],
};

// Rekent een ruwe onderdelenlijst (zie rPartsOf) om naar AANTALLEN per SKU,
// waarbij een pakket-SKU (PART_PACKAGES hierboven) VERVANGEN wordt door
// zijn losse onderdelen -- nooit allebei tegelijk meegeteld. Retourneert
// zowel de aantallen (voor rComputeDiff) als een "weergave"-tabel die voor
// elke SKU de nette schrijfwijze onthoudt (voor als een los onderdeel via
// een pakket op de lijst komt, i.p.v. rechtstreeks in de brontekst stond).
function rPlatgeslagenAantallen(lijst){
  const basis = rPartsAantallen(lijst);
  const aantallen = new Map();
  const weergave = new Map();
  lijst.forEach(ruw => {
    const k = String(ruw).trim().toUpperCase();
    if (!weergave.has(k)) weergave.set(k, String(ruw).trim());
  });
  basis.forEach((aantal, key) => {
    const pakketSku = Object.keys(PART_PACKAGES).find(s => s.toUpperCase() === key);
    if (pakketSku) {
      PART_PACKAGES[pakketSku].forEach(onderdeelSku => {
        const k = onderdeelSku.toUpperCase();
        aantallen.set(k, (aantallen.get(k) || 0) + aantal);
        if (!weergave.has(k)) weergave.set(k, onderdeelSku);
      });
    } else {
      aantallen.set(key, (aantallen.get(key) || 0) + aantal);
    }
  });
  return { aantallen, weergave };
}

// Voor de eenvoudige "heeft-hij-het-of-niet"-toets die rApplyPartExceptions
// hieronder gebruikt (geen aantallen nodig, alleen aan/uit) -- zelfde
// platslaan als hierboven, alleen de aanwezigheid telt.
function rPlatgeslagenSet(parts){
  return new Set(rPlatgeslagenAantallen(parts).aantallen.keys());
}

/* =====================================================================
   UITZONDERINGEN OP DE ONDERDELEN-VERGELIJKING
   Voor bijzondere gevallen die de gewone vergelijking (alles wat bed B
   heeft en bed A niet) niet dekt: onderdelen die normaal als "ontbrekend"
   op de lijst zouden komen, maar die niet nodig zijn omdat het HUIDIGE bed
   al iets heeft dat ze overbodig maakt.

   Beheer: deze lijst wordt hier in de code bijgehouden (geen apart
   metaobject in Shopify) -- stuur de concrete gevallen door, dan voeg ik
   ze hier toe. Iedere regel geldt voor één specifiek bed 1 naar één
   specifiek bed 2 (dus niet "elk bed met stijl X"):
     fromSku:   alleen van toepassing bij ombouw VANAF dit specifieke bed
     toSku:     alleen van toepassing bij ombouw NAAR dit specifieke bed
     ifHasAll:  lijst van SKU's -- alleen als het huidige bed ZE ALLEMAAL
                al heeft (niet genoeg als het er maar één van heeft)
     skipParts: lijst van SKU's die dan vervallen uit de "ontbreekt"-lijst
                (kan er één zijn, maar ook meerdere tegelijk)

   Nog leeg: er zijn nog geen concrete gevallen doorgegeven. */
var PART_EXCEPTIONS = [
  // Voorbeeld (fictief, nog niet actief):
  // {
  //   fromSku: "MONT-90-WHITE-STD",
  //   toSku:   "ORIG-90-WHITE-STD",
  //   ifHasAll: ["610A-10", "6101B-10"],
  //   skipParts: ["7820-10"],
  // },
];

function rApplyPartExceptions(bedA, bedB, partsA, missing){
  const setA = rPlatgeslagenSet(partsA);
  const relevant = PART_EXCEPTIONS.filter(r =>
    String(r.fromSku || "").toUpperCase() === String(bedA.sku).toUpperCase()
    && String(r.toSku || "").toUpperCase() === String(bedB.sku).toUpperCase());
  if (!relevant.length) return missing;

  const teVervallen = new Set();
  relevant.forEach(r => {
    const heeftAlles = (r.ifHasAll || []).length > 0
      && (r.ifHasAll || []).every(x => setA.has(String(x).toUpperCase()));
    if (heeftAlles) (r.skipParts || []).forEach(sku => teVervallen.add(String(sku).toUpperCase()));
  });
  if (!teVervallen.size) return missing;
  return missing.filter(sku => !teVervallen.has(sku.toUpperCase()));
}

/* =====================================================================
   ALGEMENE UITZONDERING: "616 1" niet nodig bij 670/671 -> 670/671
   (12 sep 2026)
   Los van PART_EXCEPTIONS hierboven (die alleen voor één specifiek
   bed-naar-bed-paar geldt): als het HUIDIGE bed al het onderdeel 670 heeft
   -- rechtstreeks, of via het pakket 671 (dat door rPlatgeslagenAantallen
   hierboven al is platgeslagen naar zijn losse onderdelen, dus dan zit 670
   er automatisch al in) -- EN het GEWENSTE bed ook 670 nodig heeft (idem,
   rechtstreeks of via 671), dan hoeft het onderdeel "616 1" niet
   aangeboden te worden: dat onderdeel hoort bij de montage van 670 zelf en
   zit er dus al aan zodra je 670 al hebt. Dit geldt voor ELK bed-naar-bed-
   paar (niet gekoppeld aan één specifiek paar SKU's, zoals PART_EXCEPTIONS
   hierboven) en per kleur: 670-10 hoort bij 616 1-10, 670-01W bij
   616 1-01W, enzovoort -- welke kleur-achtervoegsel er ook bij komt, deze
   functie herkent 670-<achtervoegsel> automatisch en koppelt het aan
   616 1-<datzelfde achtervoegsel>. */
function rApply616EenUitzondering(aantalA, aantalB, missing){
  let resultaat = missing;
  aantalA.forEach((_, keyA) => {
    const match = /^670-(.+)$/i.exec(keyA);
    if (!match) return;
    const kleur = match[1];
    const key670BedB = ("670-" + kleur).toUpperCase();
    const key6161 = ("616 1-" + kleur).toUpperCase();
    if (aantalB.has(key670BedB)) {
      resultaat = resultaat.filter(sku => sku.toUpperCase() !== key6161);
    }
  });
  return resultaat;
}

/* =====================================================================
   ONDERDELEN VERGELIJKEN
   ===================================================================== */
function rPartsOf(bed){
  return String(bed.parts_raw || "").split(",").map(x => x.trim()).filter(Boolean);
}

function rFindPart(sku){
  const key = String(sku).trim().toUpperCase();
  return (RDATA.parts || []).find(p => String(p.sku).trim().toUpperCase() === key) || null;
}

// Onderdelen die bed B (rechts) heeft en bed A (links) niet — de optelsom
// die de klant moet bijbestellen. Bewust ALLEEN deze richting (zie
// projectafspraak): wat van bed A overblijft en bij B niet meer nodig is,
// tellen we niet mee.
//
// (7 sep 2026, bugfix) Een SKU kan meerdere keren in het comma-gescheiden
// metafield staan -- dat betekent dat er dat AANTAL van nodig is voor dat
// bed (bv. "7820-10,7820-10" = 2 stuks). De vergelijking moet dus per SKU
// het AANTAL van bed B minus het aantal van bed A nemen, niet alleen kijken
// of de SKU wel/niet in bed A voorkomt. Vroeger werd elke SKU als simpele
// aan/uit-vlag behandeld: stond hij al bij bed A (ongeacht hoeveel keer),
// dan werd hij helemaal overgeslagen -- ga je bv. van een bed met 1x een
// onderdeel naar een bed met 2x datzelfde onderdeel, dan miste er dus 1x op
// de lijst terwijl dat er wél bij moet.
function rPartsAantallen(lijst){
  const tellingen = new Map();
  lijst.forEach(sku => {
    const key = sku.toUpperCase();
    tellingen.set(key, (tellingen.get(key) || 0) + 1);
  });
  return tellingen;
}

function rComputeDiff(){
  const bedA = rLeftBed();
  const bedB = rRightBed();
  if (!bedA || !bedB) return null;

  const partsA = rPartsOf(bedA);
  const partsB = rPartsOf(bedB);
  // rPlatgeslagenAantallen past PART_PACKAGES toe: een pakket-SKU (bv.
  // 671-10) wordt VERVANGEN door zijn losse onderdelen, zodat de
  // vergelijking hieronder altijd op onderdeel-niveau gebeurt -- ongeacht
  // of bed A/B het pakket, de losse onderdelen, of een mix daarvan in zijn
  // eigen onderdelenlijst heeft staan (zie toelichting bij PART_PACKAGES
  // hierboven). Op BEIDE bedden toepassen: ook bed B's eigen vereiste kan
  // in de Shopify-data als het pakket genoteerd staan.
  const platA = rPlatgeslagenAantallen(partsA);
  const platB = rPlatgeslagenAantallen(partsB);
  const aantalA = platA.aantallen;
  const aantalB = platB.aantallen;

  let missing = [];
  const missingQty = {};
  aantalB.forEach((aantalNodigTotaal, key) => {
    const nodig = aantalNodigTotaal - (aantalA.get(key) || 0);
    if (nodig > 0) {
      missing.push(platB.weergave.get(key) || key);
      missingQty[key] = nodig;
    }
  });

  missing = rApplyPartExceptions(bedA, bedB, partsA, missing);
  missing = rApply616EenUitzondering(aantalA, aantalB, missing);
  // Een uitzondering (PART_EXCEPTIONS of rApply616EenUitzondering) kan een
  // SKU uit "missing" halen -- ruim dan ook het bijbehorende aantal op,
  // anders blijft er een aantal staan voor een SKU die niet meer op de
  // lijst voorkomt.
  const overgebleven = new Set(missing.map(s => s.toUpperCase()));
  Object.keys(missingQty).forEach(k => { if (!overgebleven.has(k)) delete missingQty[k]; });

  return { bedA, bedB, partsA, partsB, missing, missingQty };
}

// Hoeveel van deze SKU staat er nog op de "ontbreekt"-lijst? (1 als er om
// wat voor reden dan ook geen aantal bekend is -- veiligheidsnet, zou niet
// moeten voorkomen voor een SKU die uit rComputeDiff() komt.)
function rMissingQtyVan(diff, sku){
  return (diff && diff.missingQty && diff.missingQty[String(sku).toUpperCase()]) || 1;
}

// Kan deze ombouw volledig besteld worden? Op verzoek (1 sep 2026): zodra
// ook maar 1 benodigd onderdeel nog geen product in de webshop is, mag de
// HELE ombouw niet meer besteld worden -- niet alleen dat ene onderdeel
// overslaan en de rest gewoon laten doorgaan (zoals hiervoor).
// (14 sep 2026, op verzoek, gecorrigeerd) "Geen product" betekent hier
// ALLEEN: de SKU staat niet in de onderdelencatalogus (rIsAvailable ->
// false). Of het onderdeel wel/geen PRIJS heeft, zegt hier niets over --
// op een markt zonder prijzen bestaat het onderdeel gewoon, alleen zonder
// bedrag (zie rHasPrice, en hetzelfde principe als isAvailable()/
// hasPrice() in configurator.js). Vroeger werd Number(price) > 0 gebruikt
// als maat voor "bestaat dit onderdeel", waardoor een prijsloze markt
// per ongeluk als "niet besteltbaar" werd behandeld.
function rAllPartsOrderable(){
  const diff = rComputeDiff();
  if (!diff) return true; // nog geen 2 bedden gekozen: niets om te blokkeren
  return diff.missing.every(sku => rIsAvailable(rFindPart(sku)));
}

// Is er, los van prijzen, sowieso iets om te bestellen/offreren? Zonder
// deze check zou de winkelmand-/offerteknop hierboven ook aanklikbaar
// worden als er toevallig niets ontbreekt en geen accessoires gekozen zijn
// (bv. twee bedden die precies dezelfde onderdelen gebruiken) -- dat zou
// een lege bestelling/offerte opleveren. Dit vervangt de oude "totaal > 0"-
// check, die per ongeluk ook een prijsloze markt met wél benodigde
// onderdelen blokkeerde (14 sep 2026, op verzoek).
function rHeeftTeBestellenItems(){
  const diff = rComputeDiff();
  const aantalOntbrekend = diff ? diff.missing.length : 0;
  return aantalOntbrekend > 0 || Object.keys(selectedRAcc).length > 0 || Object.keys(selectedRSubAcc).length > 0;
}

// Heeft deze markt een bedrag voor ALLES wat nu meetelt (de nog ontbrekende
// onderdelen die ook echt bestaan, plus eventueel gekozen accessoires)?
// Zo niet, dan is dit een markt zonder prijzen en laten we het totaalbedrag
// (en het bedrag in de knoptekst) helemaal weg -- zelfde principe als
// "compleet"/hasPrice() in configurator.js: een onderdeel zonder prijs
// maakt het hele totaal onbetrouwbaar, dus tonen we liever niets dan een
// half of onjuist ("€0,00") bedrag (14 sep 2026, op verzoek).
function rHeeftAllePrijzen(){
  const diff = rComputeDiff();
  const onderdelenOk = !diff || diff.missing
    .map(sku => rFindPart(sku))
    .filter(rIsAvailable) // een écht ontbrekend onderdeel telt hier niet mee
    .every(rHasPrice);
  const accOk = Object.values(selectedRAcc).every(rHasPrice);
  const subAccOk = Object.values(selectedRSubAcc).every(rHasPrice);
  return onderdelenOk && accOk && subAccOk;
}

/* =====================================================================
   ACCESSOIRES BIJ HET GEWENSTE BED (28 aug 2026)
   ---------------------------------------------------------------------
   Op verzoek: na de onderdelenlijst in stap 3 krijgt de klant de vraag "wil
   je ook accessoires bij dit bed bestellen?". Bij "ja" volgen dezelfde
   accessoirecategorieën als in de hoofdconfigurator (matras & beddengoed,
   dak/backpanel, houten accessoires, extra veiligheid, ...) maar dan voor
   het GEWENSTE bed (rechterbed, stap 2) -- niet het huidige bed. Dit is een
   bewuste, beperkte "kopie" van de gelijknamige logica in configurator.js:
   dezelfde Sheet-data (stappen/accessoires/compatibiliteit) wordt hier
   opnieuw uitgelezen via rebuild-configurator-data.liquid, maar met eigen
   functienamen en eigen state (selectedRAcc/rAccQty), zodat dit bestand
   niets deelt met en niets kan breken aan de hoofdconfigurator.

   Bewuste vereenvoudigingen t.o.v. de hoofdconfigurator (met opzet, om de
   omvang beheersbaar te houden -- laat het weten als een ervan toch nodig
   blijkt):
   - (Was hier eerst weggelaten, op 7 sep 2026 alsnog toegevoegd omdat het
     bleek te ontbreken: de informatie-popup/i-knop per accessoire. Zie
     rGroteFotoVan/rHasSpecs/rHeeftInfo/rOpenInfo verderop in dit blok.)
   - "Verplichte" categorieën (bv. een matras) worden nog wel als zodanig
     GETOOND (het "verplicht"-label op de categorie), maar houden de
     Volgende-knop hier niet tegen: dit hele stappenblok is zelf al een
     bewuste, optionele extra ("wil je OOK...") voor een klant die meestal
     de bestaande matras/lattenbodem/etc. van zijn huidige bed hergebruikt,
     dus verplicht afdwingen zou hier averechts werken. In de hoofdcon-
     figurator (een NIEUW bed kopen) blijft dat gewoon verplicht.
   ===================================================================== */
const R_MAX_QTY = 10;

function rCellValues(v){
  if (v === undefined || v === null) return [];
  return String(v).split(",").map(x => x.trim()).filter(Boolean);
}

function rIsAvailable(item){
  if (!item || !item.shopify) return false;
  return item.shopify.publishedOnline !== false;
}
function rHasPrice(item){
  const p = item && item.shopify ? item.shopify.price : null;
  if (p === null || p === undefined || p === "") return false;
  return Number(p) > 0;
}

/* Keuze-sleutel: normaal gewoon de SKU. Heeft het gewenste bed twee
   ligvlakken (stapelbed), dan krijgt elk ligvlak een eigen sleutel, zodat
   hetzelfde matras twee keer gekozen kan worden (boven én onder). */
function rAccKey(sku, slot){ return (slot === null || slot === undefined) ? String(sku) : `${sku}@${slot}`; }
function rSkuOfKey(key){ return String(key).split("@")[0]; }
function rSlotOfKey(key){
  const d = String(key).split("@");
  return d.length > 1 ? Number(d[1]) : null;
}

function rMaxQtyFor(acc){
  const n = parseInt(String((acc && acc.max_qty) || "").trim(), 10);
  if (!Number.isFinite(n) || n < 1) return 1;
  return Math.min(n, R_MAX_QTY);
}
function rAccQtyOf(key){
  return Math.min(R_MAX_QTY, Math.max(1, rAccQty[key] || 1));
}

// De breedtekolom van het bed vertelt hoeveel matrassen (ligvlakken) er
// nodig zijn: "90" is er één, "90 & 120" en "90 & 90" zijn er twee. Werkt op
// de RUWE breedtewaarde van het bed (niet de 90/120/140-groepering van de
// filters bovenaan -- die is alleen voor het filter zelf).
function rSleepSurfaces(bed){
  if (!bed) return [];
  const basis = String(bed.filter_width || "").split("&").map(x => x.trim()).filter(Boolean);
  // Bed met een logeerbed erin (12 okt 2026, zelfde als sleepSurfaces() in
  // configurator.js): het logeerbed is een extra ligvlak, vooraan (index 0).
  const g = rGastBreedte(bed);
  return g ? [g, ...basis] : basis;
}
/* --- Logeerbed als eigen ligvlak (12 okt 2026) ---
   Herkend aan een accessoire-categorie die met "Guest bed " begint en bij dit
   bed past (bv. "Guest bed mattress 90x200"). Zo'n categorie staat alleen bij
   het logeerbed en vervangt daar de gewone categorie zonder voorvoegsel. */
const R_GAST_VOORVOEGSEL = /^guest bed\s+/i;
function rIsGastCat(cat){ return R_GAST_VOORVOEGSEL.test(String(cat || "")); }
function rGastBreedte(bed){
  if (!bed || !RDATA || !RDATA.accessories || !RDATA.compatMap) return null;
  const items = RDATA.accessories.filter(a => rIsGastCat(a.category) && rAccCompatibleWithBed(a, bed.sku));
  if (!items.length) return null;
  for (const a of items) { const w = rCategoryWidth(a.category); if (w) return w; }
  return String(bed.filter_width || "").split("&")[0].trim() || null;
}
function rHeeftGastVlak(bed){ return rGastBreedte(bed || rRightBed()) !== null; }
function rGastTegenhangers(){
  const set = new Set();
  ((RDATA && RDATA.accessories) || []).forEach(a => {
    if (rIsGastCat(a.category)) set.add(String(a.category).replace(R_GAST_VOORVOEGSEL, "").trim().toLowerCase());
  });
  return set;
}
// "Mattress 90x200" -> "90"; "Duvet cover" -> null
function rCategoryWidth(cat){
  const m = String(cat || "").match(/(\d+)\s*[x×]\s*\d+/i);
  return m ? m[1] : null;
}
function rSlotLabel(i, aantal){
  if (rHeeftGastVlak()) {
    if (i === 0) return rt("slotGuest");
    if (aantal === 2) return rt("slotBedOnly");
    return rt("slotOther", { n: i + 1 });
  }
  if (aantal === 2) return i === 0 ? rt("slotTop") : rt("slotBottom");
  return rt("slotOther", { n: i + 1 });
}

/* --- Ligvlak-logica zoals in de hoofdconfigurator (12 okt 2026) --- */
// Artikelen van deze stap die bij het gewenste bed passen.
function rStapItems(stepNo){
  const bedB = rRightBed();
  return (RDATA.accessories || []).filter(a => String(a.step_no) === String(stepNo) &&
    (!bedB || rAccCompatibleWithBed(a, bedB.sku)));
}
// Een stap met maat-categorieen ("Fitted sheet 90x200") is een stap per
// ligvlak; een categorie zonder maat in zo'n stap (dekbedovertrek) kiest de
// klant dan ook per ligvlak.
function rStapPerVlak(stepNo){
  return rStapItems(stepNo).some(a => rCategoryWidth(a.category));
}
function rPerVlakCat(cat, stepNo){
  return !!rCategoryWidth(cat) || rStapPerVlak(stepNo);
}
// Past deze categorie bij ligvlak i? Zonder maat in de naam: bij elk ligvlak.
function rVlakPast(cat, i, vlakken){
  const heeftGast = rHeeftGastVlak();
  const isGast = rIsGastCat(cat);
  if (isGast && !(heeftGast && i === 0)) return false;           // alleen op het logeerbed
  if (heeftGast && i === 0 && !isGast &&
      rGastTegenhangers().has(String(cat || "").trim().toLowerCase())) return false;   // vervangen door de eigen categorie
  const w = rCategoryWidth(cat);
  return w ? w === vlakken[i] : true;
}
// "Moet kiezen" (metaobject Configurator step) toont hier alleen het kaartje
// "Geen matras"; de Volgende-knop wordt er in de rebuild-tool niet door geblokkeerd.
function rStapMoetKiezen(step){
  return !!step && String(step.must_choose || "").toLowerCase() === "yes";
}
function rPlichtCategorieen(step, cats, vlakken){
  if (!rStapMoetKiezen(step)) return [];
  const metMaat = cats.filter(c => rCategoryWidth(c));
  let lijst = metMaat.length ? metMaat : cats.slice();
  if (vlakken.length === 1) {
    const pas = lijst.filter(c => rCategoryWidth(c) === vlakken[0]);
    if (pas.length) lijst = pas;
  }
  return lijst;
}
function rGeenKey(stepNo, cat, slot){
  return `${stepNo}|${cat}|${(slot === null || slot === undefined) ? "" : slot}`;
}
function rIsGeenGekozen(stepNo, cat, slot){
  return !!rGeenKeuze[rGeenKey(stepNo, cat, slot)];
}

const rCatGewaarschuwd = new Set();
function rCategoryLabel(cat){
  const lijst = (RDATA && RDATA.categoryLabels) || [];
  const gevonden = lijst.find(c => String(c.key).toLowerCase() === String(cat).toLowerCase());
  if (gevonden && gevonden.label) return gevonden.label;
  if (lijst.length && !rCatGewaarschuwd.has(cat)) {
    rCatGewaarschuwd.add(cat);
    console.warn(`Rebuild configurator: geen vertaling voor categorie "${cat}". Maak een entry aan in het metaobject Configurator category.`);
  }
  return cat;
}

/* ---------------- Compatibiliteitsregels ----------------
   Zelfde drie soorten waarden als in de hoofdconfigurator, door elkaar en
   komma-gescheiden: losse SKU's, "ALL", of "filter_key:waarde" (met "|" voor
   OF en "&" voor EN). Hier één-op-één overgenomen, want het is precies
   dezelfde Sheet-kolom (compatible_with_sku) die wordt uitgelezen. */
function rVindKolom(kolommen, naam){
  const wil = String(naam).trim().toLowerCase();
  if (!wil) return null;
  return kolommen.find(c => c.toLowerCase() === wil)
      || kolommen.find(c => c.toLowerCase() === "filter_" + wil)
      || null;
}
function rLeesRegel(regel, kolommen){
  let delen = String(regel).split("&").map(x => x.trim()).filter(Boolean);
  if (delen.length > 1 && !delen.every(d => d.includes(":"))) delen = [String(regel).trim()];
  const voorwaarden = [];
  for (const deel of delen) {
    const i = deel.indexOf(":");
    if (i === -1) return { fout: `"${deel}" mist een dubbele punt` };
    const naam = deel.slice(0, i).trim();
    const kol = rVindKolom(kolommen, naam);
    if (!kol) return { fout: `kolom "${naam}" bestaat niet` };
    const waarden = deel.slice(i + 1).split("|").map(v => v.trim().toLowerCase()).filter(Boolean);
    if (!waarden.length) return { fout: `geen waarde achter "${naam}:"` };
    voorwaarden.push({ kol, waarden });
  }
  return { voorwaarden };
}
function rBeddenVoorRegel(regel, bedden, kolommen){
  const g = rLeesRegel(regel, kolommen);
  if (g.fout) return g;
  const skus = bedden
    .filter(b => g.voorwaarden.every(v => rCellValues(b[v.kol]).some(x => v.waarden.includes(x.toLowerCase()))))
    .map(b => (b.sku || "").trim().toUpperCase())
    .filter(Boolean);
  return { skus: [...new Set(skus)] };
}
function rBouwCompatMap(accessoires, bedden){
  const kolommen = [...new Set(bedden.flatMap(b => Object.keys(b)))];
  const map = {};
  const problemen = [];
  for (const acc of accessoires) {
    const sku = (acc.sku || "").trim().toUpperCase();
    if (!sku) continue;
    const cel = acc.compatible_with_sku || "";
    const stukken = rCellValues(cel);
    if (stukken.some(x => x.toUpperCase() === "ALL")) { map[sku] = "ALL"; continue; }
    const uit = new Set();
    for (const stuk of stukken) {
      if (!stuk.includes(":")) { uit.add(stuk.toUpperCase()); continue; }
      const res = rBeddenVoorRegel(stuk, bedden, kolommen);
      if (res.fout) { problemen.push(`${sku} · ${stuk} → ${res.fout}`); continue; }
      if (!res.skus.length) problemen.push(`${sku} · ${stuk} → geen enkel bed voldoet`);
      res.skus.forEach(x => uit.add(x));
    }
    map[sku] = [...uit];
  }
  if (problemen.length) console.warn("Rebuild configurator: compatibiliteitsregels met een probleem:\n" + problemen.join("\n"));
  return map;
}
function rAccCompatibleWithBed(acc, bedSku){
  const c = (RDATA.compatMap || {})[(acc.sku || "").trim().toUpperCase()];
  if (!c) return false;
  const target = (bedSku || "").trim().toUpperCase();
  return c === "ALL" || c.includes(target);
}

/* ---------------- Afhankelijkheden tussen accessoires (metafield "requires") ----------------
   Zelfde mechanisme als de hoofdconfigurator: kiest de klant bv. het
   rugpaneel, dan komt het bijbehorende dak er automatisch bij; verdwijnt
   het dak, dan gaat het rugpaneel mee. */
function rVereistenVan(acc){
  return rCellValues(acc && acc.requires).map(x => x.trim().toUpperCase()).filter(Boolean);
}
function rIsGekozenAcc(sku){
  return Object.keys(selectedRAcc).some(k => rSkuOfKey(k).toUpperCase() === String(sku).toUpperCase());
}
function rVereisteBruikbaarAcc(sku, bedB){
  const item = (RDATA.accessories || []).find(a => String(a.sku).toUpperCase() === String(sku).toUpperCase());
  if (!item) return null;
  if (!rIsAvailable(item)) return null;
  if (bedB && !rAccCompatibleWithBed(item, bedB.sku)) return null;
  return item;
}
function rOntbrekendeVereiste(acc){
  const bedB = rRightBed();
  for (const sku of rVereistenVan(acc)) {
    if (!rVereisteBruikbaarAcc(sku, bedB)) return sku;
  }
  return null;
}
function rNaamVanSku(sku){
  const item = (RDATA.accessories || []).find(a => String(a.sku).toUpperCase() === String(sku).toUpperCase());
  return (item && item.shopify && item.shopify.title) || sku;
}
function rKiesInternAcc(acc, n, slot){
  const key = rAccKey(acc.sku, slot);
  // Een gekozen artikel maakt een eerdere bewuste "geen" ongedaan.
  delete rGeenKeuze[rGeenKey(acc.step_no, acc.category, slot)];
  if (String(acc.selection).toLowerCase() === "single") {
    Object.keys(selectedRAcc).forEach(other => {
      if (other === key) return;
      const o = selectedRAcc[other];
      if (o.category === acc.category && String(o.step_no) === String(acc.step_no) && rSlotOfKey(other) === rSlotOfKey(key)) {
        delete selectedRAcc[other]; delete rAccQty[other];
      }
    });
  }
  selectedRAcc[key] = acc;
  rAccQty[key] = n;
}
function rKiesVereistenBij(acc, gezien){
  gezien = gezien || new Set();
  const bedB = rRightBed();
  for (const sku of rVereistenVan(acc)) {
    if (gezien.has(sku)) continue;
    gezien.add(sku);
    if (rIsGekozenAcc(sku)) continue;
    const item = rVereisteBruikbaarAcc(sku, bedB);
    if (!item) continue;
    rKiesInternAcc(item, 1, null);
    rKiesVereistenBij(item, gezien);
  }
}
function rHandhaafVereisten(){
  let veranderd = true;
  while (veranderd) {
    veranderd = false;
    for (const key of Object.keys(selectedRAcc)) {
      const acc = selectedRAcc[key];
      const mist = rVereistenVan(acc).some(sku => !rIsGekozenAcc(sku));
      if (mist) { delete selectedRAcc[key]; delete rAccQty[key]; veranderd = true; }
    }
  }
}

/* ---------------- Sub-accessoires (metafield "sub_accessory_of", 12 sep 2026) ----------------
   Voor een geval als het logeerbed (7049): kiest de klant dat, dan mag hij
   er DAARNAAST optioneel nog een matras specifiek voor dat logeerbed bij
   kiezen (een beperkte lijst, bv. alleen 701R/70921/70922) -- los van de
   matras die hij toch al voor zijn eigen bed kiest in de gewone matrasstap.

   Dit is BEWUST iets anders dan "requires" hierboven:
   - "requires" kiest de vereiste automatisch MEE en dwingt hem af (dak
     erbij zodra je het rugpaneel kiest, en andersom).
   - een sub-accessoire wordt NOOIT automatisch gekozen -- de klant kiest
     'm zelf, of laat 'm gewoon staan. Hij verschijnt pas ALS keuzemogelijk-
     heid zodra de ouder gekozen is (metafield "sub_accessory_of" op de
     sub-accessoire-variant: komma-gescheiden lijst van ouder-SKU's, bv.
     "7049-10, 7049-01W" -- zo geldt het voor beide kleuren van het
     logeerbed). Kies je de ouder weer weg, dan vervalt een eventueel
     gekozen sub-accessoire automatisch mee (net als bij "requires", maar
     dan in de andere richting).
   Generiek genoeg voor een volgend, vergelijkbaar geval later -- niet
   hardcoded aan SKU 7049 gekoppeld. */
function rSubAccessoryOf(acc){
  // Een ouder mag een bed-regel achter zich hebben: "7049-10@filter_width:90".
  // Voor alle bestaande logica telt alleen het SKU-deel (voor de @).
  return rCellValues(acc && acc.sub_accessory_of)
    .map(x => x.split("@")[0].trim().toUpperCase()).filter(Boolean);
}
/* Bed-regel bij een ouder (12 okt 2026, afdekplaten 7052 / 70512 / 70514):
   "7049-10@filter_width:90|90 & 90" = alleen tonen als het gewenste bed die
   waarde heeft. Zelfde regelsyntax als compatible_with. Zonder "@..." geldt
   geen beperking (de matrassen). */
function rSubAccBedRegel(acc, ouderSku){
  const doel = String(ouderSku).trim().toUpperCase();
  for (const x of rCellValues(acc && acc.sub_accessory_of)) {
    const i = x.indexOf("@");
    const sku = (i === -1 ? x : x.slice(0, i)).trim().toUpperCase();
    if (sku === doel) return i === -1 ? "" : x.slice(i + 1).trim();
  }
  return "";
}
function rSubAccPastBijOuder(acc, ouderSku){
  const regel = rSubAccBedRegel(acc, ouderSku);
  const bedB = rRightBed();
  if (!regel || !bedB) return true;
  const bedden = RDATA.beds || [];
  const kolommen = [...new Set(bedden.flatMap(b => Object.keys(b)))];
  const res = rBeddenVoorRegel(regel, bedden, kolommen);
  if (res.fout) { console.warn(`Rebuild configurator: sub-accessoire ${acc.sku}: ${res.fout}`); return false; }
  return res.skus.includes(String(bedB.sku || "").trim().toUpperCase());
}
function rSubAccessoriesVoor(ouderSku){
  const doel = String(ouderSku).trim().toUpperCase();
  return (RDATA.accessories || []).filter(a => rSubAccessoryOf(a).includes(doel) && rSubAccPastBijOuder(a, doel));
}
function rIsGekozenSubAcc(sku){
  return !!selectedRSubAcc[String(sku).trim().toUpperCase()];
}
// Hoeveel stuks staat er nu gekozen van deze sub-accessoire (minimaal 1).
function rSubAccQtyOf(key){
  return Math.min(R_MAX_QTY, Math.max(1, rSubAccQty[key] || 1));
}
// Ruimt andere gekozen sub-accessoires op die met "acc" overlappen: zelfde
// ouder(s) EN zelfde categorie (10 sep 2026, was: alle sub-accessoires van
// dezelfde ouder, ongeacht categorie). Zo blijft er per categorie hoogstens
// één sub-accessoire gekozen (bv. één dak), maar een dak- en een
// rugpaneel-keuze onder dezelfde ouder-optie kunnen nu wel samen gekozen
// staan -- nodig voor de "House Construction H128 cm"-optie (6371-090).
function rMaakPlaatsVoorSubAcc(acc){
  const ouders = rSubAccessoryOf(acc);
  Object.keys(selectedRSubAcc).forEach(k => {
    const overig = selectedRSubAcc[k];
    if (String(overig.sku).toUpperCase() === String(acc.sku).toUpperCase()) return;
    if (overig.category !== acc.category) return;
    const overigeOuders = rSubAccessoryOf(overig);
    if (overigeOuders.some(o => ouders.includes(o))) {
      delete selectedRSubAcc[k];
      delete rSubAccQty[k];
    }
  });
}
/* Kiest automatisch de "vereiste partner" van een sub-accessoire erbij, bv.
   rugpaneel 7821 vereist dak 7820 (metafield configurator.requires, zelfde
   veld als bij gewone accessoires -- zie rKiesVereistenBij hierboven). Dit
   telt hier ALLEEN als die partner zelf ook een sub-accessoire is van (een
   van) dezelfde ouder(s); is dat niet zo, dan is het een gewone,
   top-level vereiste en regelt rKiesVereistenBij dat al. */
function rKiesSubAccVereistenBij(acc, gezien){
  gezien = gezien || new Set();
  const ouders = rSubAccessoryOf(acc);
  for (const sku of rVereistenVan(acc)) {
    if (gezien.has(sku)) continue;
    gezien.add(sku);
    const partner = (RDATA.accessories || []).find(a => String(a.sku).toUpperCase() === sku);
    if (!partner || !rIsAvailable(partner)) continue;
    if (!rSubAccessoryOf(partner).some(o => ouders.includes(o))) continue;
    const pkey = String(partner.sku).trim().toUpperCase();
    if (!selectedRSubAcc[pkey]) {
      rMaakPlaatsVoorSubAcc(partner);
      selectedRSubAcc[pkey] = partner;
      rSubAccQty[pkey] = Math.min(rMaxQtyFor(partner), 1);
    }
    rKiesSubAccVereistenBij(partner, gezien);
  }
}
// Ruimt sub-accessoires op waarvan de vereiste partner (zie hierboven)
// niet meer gekozen staat -- bv. dak wordt gewisseld van Panda naar
// Rabbit, dan vervalt het bijpassende Panda-rugpaneel automatisch mee.
// Herhaalt tot er niets meer verandert (zelfde stijl als rHandhaafVereisten).
function rHandhaafSubAccVereisten(){
  let veranderd = true;
  while (veranderd) {
    veranderd = false;
    for (const key of Object.keys(selectedRSubAcc)) {
      const acc = selectedRSubAcc[key];
      const ouders = rSubAccessoryOf(acc);
      const mist = rVereistenVan(acc).some(sku => {
        const partner = (RDATA.accessories || []).find(a => String(a.sku).toUpperCase() === sku);
        if (!partner) return false;
        if (!rSubAccessoryOf(partner).some(o => ouders.includes(o))) return false;
        return !rIsGekozenSubAcc(sku);
      });
      if (mist) { delete selectedRSubAcc[key]; delete rSubAccQty[key]; veranderd = true; }
    }
  }
}
// Kiest deze sub-accessoire in dit aantal (max_qty bepaalt hoeveel
// kaartjes -- 1x, 2x, ... -- er getoond worden). Nogmaals op hetzelfde
// aantal klikken zet de keuze weer uit.
function rChooseSubAcc(sku, aantal){
  const acc = (RDATA.accessories || []).find(a => String(a.sku).toUpperCase() === String(sku).toUpperCase());
  if (!acc || !rIsAvailable(acc)) return;
  const key = String(sku).trim().toUpperCase();
  const n = Math.min(rMaxQtyFor(acc), Math.max(1, Number(aantal) || 1));

  if (selectedRSubAcc[key] && rSubAccQtyOf(key) === n) {
    delete selectedRSubAcc[key];
    delete rSubAccQty[key];
    rHandhaafSubAccVereisten();
    renderR();
    return;
  }
  rMaakPlaatsVoorSubAcc(acc);
  selectedRSubAcc[key] = acc;
  rSubAccQty[key] = n;
  rKiesSubAccVereistenBij(acc);
  rHandhaafSubAccVereisten();
  renderR();
}
// Aantal bijstellen vanuit de rechterkolom (alleen zichtbaar bij max_qty > 1).
function rChangeSubAccQty(key, delta){
  if (!selectedRSubAcc[key]) return;
  rSubAccQty[key] = Math.min(R_MAX_QTY, Math.max(1, rSubAccQtyOf(key) + delta));
  renderR();
}
function rRemoveSubAcc(key){
  delete selectedRSubAcc[key];
  delete rSubAccQty[key];
  rHandhaafSubAccVereisten();
  renderR();
}
// Ruimt een gekozen sub-accessoire op zodra GEEN van zijn ouders meer
// gekozen is (bv. het logeerbed is verwijderd of vervangen door de grote
// bedlade uit dezelfde categorie).
function rHandhaafSubAccessoires(){
  Object.keys(selectedRSubAcc).forEach(key => {
    const acc = selectedRSubAcc[key];
    const ouders = rSubAccessoryOf(acc);
    const nogGekozen = ouders.some(sku => rIsGekozenAcc(sku) && rSubAccPastBijOuder(acc, sku));
    if (!nogGekozen) { delete selectedRSubAcc[key]; delete rSubAccQty[key]; }
  });
  rHandhaafSubAccVereisten();
}

// Heeft deze stap iets te kiezen voor het GEWENSTE bed? Stap 1 (bedkeuze) en
// het type "slats" (lattenbodem) doen in de rebuild-tool niet mee: breedte,
// kleur en lattenbodem liggen hier al vast (zie project-afspraak).
function rStepHasAccContent(step, bedB){
  if (!bedB) return false;
  return (RDATA.accessories || []).some(a => String(a.step_no) === String(step.step_no) && rAccCompatibleWithBed(a, bedB.sku));
}
function rActiveAccessorySteps(){
  const bedB = rRightBed();
  if (!bedB) return [];
  return (RDATA.steps || []).filter(st =>
    String(st.step_no) !== "1" &&
    String(st.type || "").toLowerCase() !== "slats" &&
    rStepHasAccContent(st, bedB));
}

/* ---------------- Informatie-popup per accessoire (7 sep 2026) -----------
   Alsnog toegevoegd op verzoek: dit was in de vereenvoudigingen hierboven
   (28 aug 2026) bewust weggelaten, maar bleek toch gewenst. Eén-op-één
   dezelfde werkwijze als grotefotoVan()/hasSpecs()/heeftInfo()/openInfo()
   in configurator.js, alleen met eigen (r-)functienamen en op basis van
   RDATA.accessories, zodat dit bestand nog steeds niets deelt met de
   hoofdconfigurator. De CSS (.guide-overlay/.guide-box/.info-box/.info-btn/
   .acc-thumb--zoom/...) staat al in configurator.css, dat ook op deze
   pagina wordt geladen -- dus hier is geen CSS-wijziging voor nodig. */
function rGroteFotoVan(item){
  const sh = (item && item.shopify) || {};
  return sh.imageLarge || sh.image || sh.configuratorImage || "";
}
function rHasSpecs(item){
  return !!(item && item.shopify && item.shopify.specifications);
}
function rHeeftInfo(item){
  return !!(item && (rGroteFotoVan(item) || rHasSpecs(item)));
}
function rOpenInfo(sku){
  const item = (RDATA.accessories || []).find(a => String(a.sku).toUpperCase() === String(sku).toUpperCase());
  if (!item) return;
  const sh = item.shopify || {};
  const foto = rGroteFotoVan(item);
  const titel = sh.title || item.sku;
  const specs = rHasSpecs(item) ? sh.specifications : "";
  // Dealer-modus: wel beeld/titel/specificaties tonen, maar geen link naar de
  // productpagina -- die zou de klant terug naar de webshop sturen, en dat
  // is in de winkel van de dealer juist niet de bedoeling. De REBUILD-tool
  // draait in de praktijk altijd in dealer-modus, maar we volgen hier toch
  // dezelfde regel als de hoofdconfigurator, voor het geval dat verandert.
  const link = rIsDealerMode() ? "" : (sh.url || "");

  const overlay = document.createElement("div");
  overlay.className = "guide-overlay";
  overlay.innerHTML = `
    <div class="guide-box info-box" role="dialog" aria-modal="true" aria-label="${String(titel).replace(/"/g,'&quot;')}">
      <button class="guide-close" aria-label="${rt("specsClose")}">&times;</button>
      <div class="info-content">
        ${foto ? `<div class="info-photo"><img src="${foto}" alt="" loading="lazy"></div>` : ``}
        <div class="info-text">
          <h3 class="info-title">${titel}</h3>
          ${sh.variantTitle && sh.variantTitle !== "Default Title"
            ? `<p class="info-variant">${sh.variantTitle}</p>` : ``}
          ${rHasPrice(item) ? `<p class="info-price">${rMoney(sh.price, sh.currency)}</p>` : ``}
          ${specs ? `<div class="info-specs">${specs}</div>` : ``}
          ${link ? `<a class="info-link" href="${link}" target="_blank" rel="noopener">${rt("infoProductPage")}</a>` : ``}
        </div>
      </div>
    </div>`;
  document.body.appendChild(overlay);

  const sluit = () => { overlay.remove(); document.removeEventListener("keydown", esc); };
  function esc(e){ if (e.key === "Escape") sluit(); }
  overlay.addEventListener("click", e => { if (e.target === overlay) sluit(); });
  overlay.querySelector(".guide-close").addEventListener("click", sluit);
  document.addEventListener("keydown", esc);
}

/* ---------------- Render ---------------- */
/* --- Grote kaartjes met tagline en kenmerken (zoals in de hoofdconfigurator) ---
   Gevuld via de metafields configurator.tagline en configurator.facts. Zonder
   die velden blijft het kaartje zoals het was. */
function rGrootKaart(a){
  const sh = (a && a.shopify) || {};
  return !!(String(sh.tagline || "").trim() || String(sh.facts || "").trim());
}
function rFeitenHtml(txt, max){
  const regels = String(txt || "").split(/\r?\n/).map(x => x.trim()).filter(Boolean).slice(0, max || 6);
  if (!regels.length) return "";
  return `<ul class="acc-facts">` + regels.map(r => {
    const i = r.indexOf(":");
    return (i > 0 && i < 40)
      ? `<li><span class="acc-fact-label">${rEscAttr(r.slice(0, i).trim())}</span><span class="acc-fact-val">${rEscAttr(r.slice(i + 1).trim())}</span></li>`
      : `<li><span class="acc-fact-val">${rEscAttr(r)}</span></li>`;
  }).join("") + `</ul>`;
}
function rGrootTekst(a){
  const sh = (a && a.shopify) || {};
  const tag = String(sh.tagline || "").trim();
  return `<div class="acc-name">${sh.title || a.sku}</div>` +
         (tag ? `<div class="acc-tagline">${rEscAttr(tag)}</div>` : ``) +
         rFeitenHtml(sh.facts, 2);
}
function rGrootVoet(a, prijs){
  return `<div class="acc-foot">${prijs ? `<div class="acc-price">+${prijs}</div>` : ``}${rHeeftInfo(a) ? `<button type="button" class="acc-more" onclick="event.stopPropagation();rOpenInfo('${a.sku}')">${rt("readMore")}</button>` : ``}</div>`;
}
function rGrootThumb(a, extra, voet){
  return `<div class="acc-side"><div class="acc-thumb-wrap">
        ${rFotoVan(a)
          ? `<img class="acc-thumb${rHeeftInfo(a) ? ' acc-thumb--zoom' : ''}" src="${rFotoVan(a)}" alt="" loading="lazy"${rHeeftInfo(a) ? ` onclick="event.stopPropagation();rOpenInfo('${a.sku}')"` : ``} onerror="${rFotoOnErrorAttr(a)}">`
          : `<div class="acc-thumb acc-thumb--empty"></div>`}${extra || ""}
      </div>${voet || ""}</div>`;
}

function rRenderAccCard(a, slot, groep){
  const max = rMaxQtyFor(a);
  const key = rAccKey(a.sku, slot);
  const slotArg = (slot === null || slot === undefined) ? "null" : slot;
  const groot = !!(groep || rGrootKaart(a));

  const mist = rIsAvailable(a) ? rOntbrekendeVereiste(a) : null;
  if (!rIsAvailable(a) || mist) {
    const prijs = rHasPrice(a) ? rMoney(a.shopify.price, a.shopify.currency) : "";
    if (groot) {
      return `<div class="acc-card acc-card--groot acc-card--soldout">
      ${rGrootThumb(a, `<span class="acc-soldout">${mist ? rt("requiresMissing", { v: rNaamVanSku(mist) }) : rt("unavailable")}</span>`, rGrootVoet(a, prijs))}
      <div class="acc-body">${rGrootTekst(a)}
      </div>
    </div>`;
    }
    return `<div class="acc-card acc-card--soldout">
      <div class="acc-thumb-wrap">
        ${rFotoVan(a)
          ? `<img class="acc-thumb${rHeeftInfo(a) ? ' acc-thumb--zoom' : ''}" src="${rFotoVan(a)}" alt="" loading="lazy"${rHeeftInfo(a) ? ` onclick="event.stopPropagation();rOpenInfo('${a.sku}')"` : ``} onerror="${rFotoOnErrorAttr(a)}">`
          : `<div class="acc-thumb acc-thumb--empty"></div>`}
        <span class="acc-soldout">${mist ? rt("requiresMissing", { v: rNaamVanSku(mist) }) : rt("unavailable")}</span>
      </div>
      ${rHeeftInfo(a) ? `<button class="info-btn" title="${rt("specsShow")}" onclick="event.stopPropagation();rOpenInfo('${a.sku}')">i</button>` : ``}
      <div class="acc-name">${a.shopify?.title || a.sku}</div>
      ${prijs ? `<div class="acc-price">+${prijs}</div>` : ``}
    </div>`;
  }

  let uit = "";
  for (let q = 1; q <= max; q++) {
    const gekozen = !!selectedRAcc[key] && (rAccQtyOf(key) === q || (q === max && rAccQtyOf(key) > max));
    const prijs = rHasPrice(a) ? rMoney(Number(a.shopify.price) * q, a.shopify.currency) : "";
    if (groot) {
      uit += `<div class="acc-card acc-card--groot ${gekozen ? "selected" : ""}" onclick="rChooseAcc('${a.sku}',${q},${slotArg})">
      <div class="acc-check">✓</div>
      ${rGrootThumb(a, max > 1 ? `<span class="acc-qty-badge">${q}×</span>` : ``, rGrootVoet(a, prijs))}
      <div class="acc-body">${rGrootTekst(a)}
      </div>
    </div>`;
      continue;
    }
    uit += `<div class="acc-card ${gekozen ? "selected" : ""}" onclick="rChooseAcc('${a.sku}',${q},${slotArg})">
      <div class="acc-check">✓</div>
      <div class="acc-thumb-wrap">
        ${rFotoVan(a)
          ? `<img class="acc-thumb${rHeeftInfo(a) ? ' acc-thumb--zoom' : ''}" src="${rFotoVan(a)}" alt="" loading="lazy"${rHeeftInfo(a) ? ` onclick="event.stopPropagation();rOpenInfo('${a.sku}')"` : ``} onerror="${rFotoOnErrorAttr(a)}">`
          : `<div class="acc-thumb acc-thumb--empty"></div>`}
        ${max > 1 ? `<span class="acc-qty-badge">${q}×</span>` : ``}
      </div>
      ${rHeeftInfo(a) ? `<button class="info-btn" title="${rt("specsShow")}" onclick="event.stopPropagation();rOpenInfo('${a.sku}')">i</button>` : ``}
      <div class="acc-name">${a.shopify?.title || a.sku}</div>
      ${prijs ? `<div class="acc-price">+${prijs}</div>` : ``}
    </div>`;
  }
  return uit;
}

// Het kaartje "Geen matras": een bewuste keuze om hier niets te nemen.
function rRenderGeenKaart(stapNo, cat, slot, slotArg, groot){
  const gekozen = rIsGeenGekozen(stapNo, cat, slot);
  const catArg = String(cat).replace(/\\/g, "\\\\").replace(/'/g, "\\'");
  return `<div class="acc-card acc-card--geen${groot ? " acc-card--groot" : ""} ${gekozen ? "selected" : ""}" onclick="rChooseGeen('${stapNo}','${catArg}',${slotArg})">
      <div class="acc-check">✓</div>
      <div class="acc-thumb-wrap"><div class="acc-geen-icon">
        <svg viewBox="0 0 24 24" width="34" height="34" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M5.6 5.6l12.8 12.8"/></svg>
      </div></div>
      <div class="acc-body">
        <div class="acc-name">${rEscAttr(rt("noMattress"))}</div>
      </div>
    </div>`;
}
// Kies bewust "Geen" in deze categorie en dit ligvlak; nogmaals klikken zet het uit.
function rChooseGeen(stapNo, cat, slot){
  const sl = (slot === undefined) ? null : slot;
  const k = rGeenKey(stapNo, cat, sl);
  if (rGeenKeuze[k]) { delete rGeenKeuze[k]; renderR(); return; }
  Object.keys(selectedRAcc).forEach(key => {
    const a = selectedRAcc[key];
    if (a.category === cat && String(a.step_no) === String(stapNo) && rSlotOfKey(key) === sl) {
      delete selectedRAcc[key]; delete rAccQty[key];
    }
  });
  rGeenKeuze[k] = true;
  rHandhaafVereisten();
  rHandhaafSubAccessoires();
  renderR();
}

// Van de gekozen item(s) in deze categorie: de eerste met minstens 1
// sub-accessoire (zie rSubAccessoriesVoor hierboven) -- normaal is dat er
// hoogstens 1, want de meeste van dit soort categorieën zijn zelf ook al
// "single"-selectie (zoals "Storage and guestbed").
function rGekozenMetSubAcc(catItems, slot){
  return catItems.find(a => {
    const key = rAccKey(a.sku, slot);
    return !!selectedRAcc[key] && rSubAccessoriesVoor(a.sku).length > 0;
  }) || null;
}
// Eén kaartje voor sub-accessoire "a" bij aantal "q" (zelfde opzet als
// rRenderAccCard: bij max_qty 2 staan er dus twee kaartjes naast elkaar,
// 1x en 2x, allebei met de prijs voor dat aantal).
function rRenderSubAccCard(a, q){
  const max = rMaxQtyFor(a);
  const key = String(a.sku).trim().toUpperCase();
  const gekozen = rIsGekozenSubAcc(a.sku) &&
    (rSubAccQtyOf(key) === q || (q === max && rSubAccQtyOf(key) > max));
  const prijs = rHasPrice(a) ? rMoney(Number(a.shopify.price) * q, a.shopify.currency) : "";
  return `<div class="acc-card ${gekozen ? "selected" : ""}" onclick="rChooseSubAcc('${a.sku}',${q})">
    <div class="acc-check">✓</div>
    <div class="acc-thumb-wrap">
      ${rFotoVan(a)
        ? `<img class="acc-thumb${rHeeftInfo(a) ? ' acc-thumb--zoom' : ''}" src="${rFotoVan(a)}" alt="" loading="lazy"${rHeeftInfo(a) ? ` onclick="event.stopPropagation();rOpenInfo('${a.sku}')"` : ``} onerror="${rFotoOnErrorAttr(a)}">`
        : `<div class="acc-thumb acc-thumb--empty"></div>`}
      ${max > 1 ? `<span class="acc-qty-badge">${q}×</span>` : ``}
    </div>
    ${rHeeftInfo(a) ? `<button class="info-btn" title="${rt("specsShow")}" onclick="event.stopPropagation();rOpenInfo('${a.sku}')">i</button>` : ``}
    <div class="acc-name">${a.shopify?.title || a.sku}</div>
    ${prijs ? `<div class="acc-price">+${prijs}</div>` : ``}
  </div>`;
}
// Eén kaartje per toegestaan aantal (1..max_qty) voor deze sub-accessoire.
function rRenderSubAccCards(a){
  const max = rMaxQtyFor(a);
  let uit = "";
  for (let q = 1; q <= max; q++) uit += rRenderSubAccCard(a, q);
  return uit;
}
// Sub-accessoires per categorie gegroepeerd tonen (10 sep 2026), zodat het
// duidelijk is als het om aparte keuzes gaat -- bv. dak + rugpaneel bij de
// "House Construction H128 cm"-optie. Is er maar 1 categorie (zoals bij de
// bestaande Beach House-optie: alleen "Roof"), dan verschijnt er geen extra
// kopje en ziet het er precies als voorheen uit.
function rRenderSubAccBlock(ouderAcc){
  const subs = rSubAccessoriesVoor(ouderAcc.sku).filter(a => rIsAvailable(a));
  if (!subs.length) return "";
  const cats = [...new Set(subs.map(a => a.category))];
  const groepen = cats.map(cat => {
    const catSubs = subs.filter(a => a.category === cat);
    const label = cats.length > 1
      ? `<div class="group-label subacc-cat-label">${rCategoryLabel(cat)}</div>` : ``;
    return `${label}<div class="acc-grid">${catSubs.map(a => rRenderSubAccCards(a)).join("")}</div>`;
  }).join("");
  return `<div class="subacc-block">
    <div class="group-label subacc-label">${rt("subAccessoryTitle", { v: ouderAcc.shopify?.title || ouderAcc.sku })}</div>
    ${groepen}
  </div>`;
}
function rRenderAccCatGroup(cat, items, slot, moetKiezen){
  const catItems = items.filter(i => i.category === cat);
  const required = catItems.some(i => String(i.required).toLowerCase() === "yes");
  const ouderMetSub = rGekozenMetSubAcc(catItems, slot);
  // Heeft minstens een artikel een tagline of kenmerken, dan staat de hele
  // groep in grote kaartjes.
  const groot = catItems.some(rGrootKaart);
  const slotArg = (slot === null || slot === undefined) ? "null" : slot;
  const stapNo = catItems.length ? catItems[0].step_no : "";
  const geenKaart = moetKiezen ? rRenderGeenKaart(stapNo, cat, slot, slotArg, groot) : ``;
  return `<div class="group">
    <div class="group-label">${rCategoryLabel(cat)} ${required ? `<span class="req-tag">${rt("required")}</span>` : ``}</div>
    <div class="acc-grid${groot ? " acc-grid--groot" : ""}">${catItems.map(a => rRenderAccCard(a, slot, groot)).join("")}${geenKaart}</div>
    ${ouderMetSub ? rRenderSubAccBlock(ouderMetSub) : ``}
  </div>`;
}

/* "Zelfde als onderbed": op het bovenbed een knop die in een klik hetzelfde
   artikel kiest als bij het onderbed (zelfde als zelfdeParen/kiesZelfde in
   configurator.js). */
function rZelfdeParen(stepNo, items){
  const vlakken = rSleepSurfaces(rRightBed());
  if (vlakken.length !== 2) return [];
  const paren = [];
  Object.entries(selectedRAcc).forEach(([key, bron]) => {
    if (rSlotOfKey(key) !== 1 || String(bron.step_no) !== String(stepNo) || !rPerVlakCat(bron.category, bron.step_no)) return;
    const kandidaten = items.filter(a => (rCategoryWidth(bron.category)
        ? rCategoryWidth(a.category) === vlakken[0]
        : a.category === bron.category) &&
      rIsAvailable(a) && !rOntbrekendeVereiste(a) &&
      String(a.shopify && a.shopify.title) === String(bron.shopify && bron.shopify.title));
    const doel = kandidaten.find(a => a.sku === bron.sku) || kandidaten[0];
    if (doel) paren.push({ doel, aantal: Math.min(rMaxQtyFor(doel), rAccQtyOf(key)) });
  });
  return paren;
}
function rRenderZelfdeKnop(stepNo, slot, items){
  if (slot !== 0) return "";
  if (rHeeftGastVlak()) return "";   // het logeerbed is geen "zelfde als"-geval
  const paren = rZelfdeParen(stepNo, items);
  if (!paren.length) return "";
  const alGekozen = paren.every(p => selectedRAcc[rAccKey(p.doel.sku, 0)] &&
    rAccQtyOf(rAccKey(p.doel.sku, 0)) === p.aantal);
  const namen = paren.map(p => (p.doel.shopify && p.doel.shopify.title) || p.doel.sku).join(" + ");
  return `<button type="button" class="same-btn ${alGekozen ? "selected" : ""}" onclick="rKiesZelfde('${stepNo}')">` +
         `<span class="same-check">${alGekozen ? "✓" : "="}</span>` +
         `<span class="same-text">${rEscAttr(rt("sameAsBottom", { v: namen }))}</span></button>`;
}
function rKiesZelfde(stepNo){
  const paren = rZelfdeParen(stepNo, rStapItems(stepNo));
  if (!paren.length) return;
  paren.forEach(p => rKiesInternAcc(p.doel, p.aantal, 0));
  paren.forEach(p => rKiesVereistenBij(p.doel));
  rHandhaafVereisten();
  rHandhaafSubAccessoires();
  renderR();
}

function rRenderAccStepBody(stepNo, bedB){
  const items = (RDATA.accessories || []).filter(a =>
    String(a.step_no) === String(stepNo) && (!bedB || rAccCompatibleWithBed(a, bedB.sku)));
  const cats = [...new Set(items.map(i => i.category))];
  if (!cats.length) return `<div class="empty-note">${rt("noAccessoriesForThisBed")}</div>`;

  const step = (RDATA.steps || []).find(st => String(st.step_no) === String(stepNo));
  const vlakken = rSleepSurfaces(bedB);
  const plicht = rPlichtCategorieen(step, cats, vlakken);
  // Categorieen met een maat in de naam horen bij één ligvlak; de rest
  // (dekbedovertrek, dak, ...) geldt voor het bed als geheel.
  const metMaat = cats.filter(c => rCategoryWidth(c));
  const zonderMaat = cats.filter(c => !rPerVlakCat(c, stepNo));

  // Eén ligvlak, of niets met een maat: gewoon alle categorieën onder elkaar.
  if (vlakken.length < 2 || !metMaat.length) {
    return cats.map(cat => rRenderAccCatGroup(cat, items, null, plicht.includes(cat))).join("");
  }

  // Twee of meer ligvlakken: elk ligvlak een eigen blok, bij twee eerst het
  // onderbed (index 1) en dan het bovenbed/logeerbed (index 0), net als in de
  // hoofdconfigurator.
  const volgorde = vlakken.length === 2 ? [1, 0] : vlakken.map((_, i) => i);
  let uit = "";
  volgorde.forEach(i => {
    const breedte = vlakken[i];
    if (!metMaat.some(c => rCategoryWidth(c) === breedte)) return;
    uit += `<div class="slot-head">${rSlotLabel(i, vlakken.length)}<span class="slot-size">${breedte} cm</span></div>`;
    uit += rRenderZelfdeKnop(stepNo, i, items);
    uit += cats.filter(c => rPerVlakCat(c, stepNo) && rVlakPast(c, i, vlakken))
               .map(cat => rRenderAccCatGroup(cat, items, i, plicht.includes(cat))).join("");
  });
  // Wat voor het bed als geheel geldt (dak, ...) komt onderaan.
  uit += zonderMaat.map(cat => rRenderAccCatGroup(cat, items, null, false)).join("");
  return uit;
}

function rRenderChosenAccList(bedB){
  const entries = Object.entries(selectedRAcc);
  const subEntries = Object.entries(selectedRSubAcc);
  if (!entries.length && !subEntries.length) return "";
  const normaal = entries.map(([key, a]) => `
    <div class="chosen-item">
      <button type="button" class="chosen-remove" title="${rt("remove")}" aria-label="${rt("remove")}" onclick="rRemoveAcc('${key}')">&times;</button>
      ${a.shopify?.image ? `<img class="chosen-thumb" src="${rFotoVan(a)}" alt="" loading="lazy" onerror="${rFotoOnErrorAttr(a)}">` : `<div class="chosen-thumb chosen-thumb--empty"></div>`}
      <div class="chosen-label">${a.shopify?.title || a.sku}${rSlotOfKey(key) !== null ? `<span class="chosen-slot">${rSlotLabel(rSlotOfKey(key), rSleepSurfaces(bedB).length)}</span>` : ``}</div>
      <div class="qty-row">
        <button type="button" class="qty-btn" title="${rt("fewer")}" aria-label="${rt("fewer")}" onclick="rChangeAccQty('${key}',-1)" ${rAccQtyOf(key) <= 1 ? "disabled" : ""}>&minus;</button>
        <span class="qty-num">${rAccQtyOf(key)}×</span>
        <button type="button" class="qty-btn" title="${rt("more")}" aria-label="${rt("more")}" onclick="rChangeAccQty('${key}',1)" ${rAccQtyOf(key) >= R_MAX_QTY ? "disabled" : ""}>+</button>
      </div>
    </div>`).join("");
  // Sub-accessoires (bv. matras voor het logeerbed) hebben alleen een
  // aantal-stap als max_qty > 1 (bv. 6378-10 onder de Roof-optie);
  // anders (zoals 7710/7730) blijft het bij een verwijderknop.
  const sub = subEntries.map(([key, a]) => `
    <div class="chosen-item">
      <button type="button" class="chosen-remove" title="${rt("remove")}" aria-label="${rt("remove")}" onclick="rRemoveSubAcc('${key}')">&times;</button>
      ${a.shopify?.image ? `<img class="chosen-thumb" src="${rFotoVan(a)}" alt="" loading="lazy" onerror="${rFotoOnErrorAttr(a)}">` : `<div class="chosen-thumb chosen-thumb--empty"></div>`}
      <div class="chosen-label">${a.shopify?.title || a.sku}</div>
      ${rMaxQtyFor(a) > 1 ? `
      <div class="qty-row">
        <button type="button" class="qty-btn" title="${rt("fewer")}" aria-label="${rt("fewer")}" onclick="rChangeSubAccQty('${key}',-1)" ${rSubAccQtyOf(key) <= 1 ? "disabled" : ""}>&minus;</button>
        <span class="qty-num">${rSubAccQtyOf(key)}×</span>
        <button type="button" class="qty-btn" title="${rt("more")}" aria-label="${rt("more")}" onclick="rChangeSubAccQty('${key}',1)" ${rSubAccQtyOf(key) >= R_MAX_QTY ? "disabled" : ""}>+</button>
      </div>` : ``}
    </div>`).join("");
  return `<div class="chosen-grid">${normaal}${sub}</div>`;
}

function rMissingPartsTotal(){
  const diff = rComputeDiff();
  if (!diff) return 0;
  let total = 0;
  diff.missing.forEach(sku => {
    const part = rFindPart(sku);
    if (part && part.shopify && Number(part.shopify.price) > 0) {
      total += Number(part.shopify.price) * rMissingQtyVan(diff, sku);
    }
  });
  return total;
}
function rAccChosenTotal(){
  let total = 0;
  Object.entries(selectedRAcc).forEach(([key, a]) => {
    if (a && a.shopify && Number(a.shopify.price) > 0) total += Number(a.shopify.price) * rAccQtyOf(key);
  });
  return total;
}
// Sub-accessoires tellen mee met hun eigen aantal (max_qty, bv. 1x/2x bij
// het Roof-paneel 6378-10; de meeste, zoals de matras bij het logeerbed,
// hebben geen max_qty en tellen dus altijd 1 stuk).
function rSubAccChosenTotal(){
  let total = 0;
  Object.entries(selectedRSubAcc).forEach(([key, a]) => {
    if (a && a.shopify && Number(a.shopify.price) > 0) total += Number(a.shopify.price) * rSubAccQtyOf(key);
  });
  return total;
}
function rGrandTotal(){ return rMissingPartsTotal() + rAccChosenTotal() + rSubAccChosenTotal(); }

function rRenderAccStep(stepNo){
  const bedA = rLeftBed();
  const bedB = rRightBed();
  if (!bedA || !bedB) return { left: `<div class="empty-note">${rt("chooseRightBed")}</div>`, right: "" };

  const refBlock = `${rRefChip(bedA)}<div class="ref-arrow-row">↓</div>${rRefChip(bedB)}<button type="button" class="ref-edit" onclick="rGoToStep(2)">${rt("changeBothBeds")}</button>`;
  const right = rRenderAccStepBody(stepNo, bedB);

  const actStappen = rActiveAccessorySteps();
  const isLaatste = actStappen.length > 0 && String(actStappen[actStappen.length - 1].step_no) === String(stepNo);
  const total = rGrandTotal();
  // Zelfde regel als in stap 3: 1 niet-besteltbaar onderdeel blokkeert de
  // hele ombouw, dus ook de winkelmandknop hier op de laatste
  // accessoirestap (zie rAllPartsOrderable hierboven bij rComputeDiff).
  const alleBeschikbaar = rAllPartsOrderable();

  // (7 sep 2026) Zelfde reden als bij rRenderStep3 hierboven: het
  // actiekaartje (totaal + "Offerte maken"/"In winkelmand"-knop) mag niet
  // meemoeten met de scrollbare lijst met gekozen accessoires. Bij een
  // langere lijst (of een lager scherm) vulde die lijst de scrollzone
  // helemaal en stond het kaartje er letterlijk ONDER, buiten beeld en
  // bereikbaar door in dat lijstje te scrollen -- dat zag er op de tablet/
  // touchscreen uit alsof de knop was verdwenen. Door "action" apart terug
  // te geven en in renderR() vast te prikken onder de scrollzone, blijft
  // totaal + knop altijd zichtbaar, ongeacht hoeveel accessoires gekozen
  // zijn of hoe klein het scherm is.
  const left = refBlock + rRenderChosenAccList(bedB);
  const action = rRenderFinalActionCard(total, alleBeschikbaar, isLaatste, rHeeftAllePrijzen());

  return { left, right, action };
}

function rChooseAcc(sku, aantal, slot){
  const acc = (RDATA.accessories || []).find(a => a.sku === sku);
  if (!acc || !rIsAvailable(acc)) return;
  if (rOntbrekendeVereiste(acc)) return;

  const n = Math.min(rMaxQtyFor(acc), Math.max(1, Number(aantal) || 1));
  const key = rAccKey(sku, slot);

  if (selectedRAcc[key] && rAccQtyOf(key) === n) {
    delete selectedRAcc[key]; delete rAccQty[key];
    rHandhaafVereisten();
    rHandhaafSubAccessoires();
    renderR();
    return;
  }
  rKiesInternAcc(acc, n, slot);
  rKiesVereistenBij(acc);
  rHandhaafVereisten();
  rHandhaafSubAccessoires();
  renderR();
}
function rChangeAccQty(key, delta){
  if (!selectedRAcc[key]) return;
  rAccQty[key] = Math.min(R_MAX_QTY, Math.max(1, rAccQtyOf(key) + delta));
  renderR();
}
function rRemoveAcc(key){
  delete selectedRAcc[key]; delete rAccQty[key];
  rHandhaafVereisten();
  rHandhaafSubAccessoires();
  renderR();
}

/* =====================================================================
   STAPPEN-NAVIGATIE
   Standaard 3 stappen (huidig bed / gewenst bed / onderdelen). Kiest de
   klant in stap 1 een bed dat in meerdere lattenbodem-uitvoeringen bestaat
   (30 aug 2026), dan komt daar een extra tussenstap "slats1" bij, ALLEEN
   zolang dat bed nog ambigu is (rLeftGroupHasSlatsChoice()) -- precies
   hetzelfde patroon als de accessoirestappen hieronder, die er ook alleen
   bij komen als ze relevant zijn. Antwoordt de klant in stap 3 "ja" op de
   accessoirevraag (28 aug 2026), dan komen daar de accessoirecategorieën
   van het GEWENSTE bed als extra stappen bij -- alleen de categorieën die
   voor dát bed ook echt iets te kiezen hebben, net als bij de
   hoofdconfigurator. Bij "nee" (of zolang de vraag nog niet beantwoord is)
   blijft het bij de vaste stappen.
   ===================================================================== */
var currentStep = 1;

function rAllSteps(){
  const a = rLeftBed(), b = rRightBed();
  const sub3 = (a && b)
    ? rt("step3SubDynamic", { from: (a.shopify && a.shopify.title) || a.filter_style, to: (b.shopify && b.shopify.title) || b.filter_style })
    : rt("step3Sub");
  const basis = [
    // Geen subtitel hier (1 sep 2026, op verzoek): "Use the filters to find
    // your bed." stond dubbel op het scherm -- vlak onder het zoekveldje
    // in stap 1 staat namelijk al dezelfde hint ("orUseFilters"). De titel
    // zelf blijft gewoon staan.
    { kind: "bed1", title: rt("step1Title"), sub: "" },
  ];
  if (rLeftGroupHasSlatsChoice()) {
    basis.push({ kind: "slats1", title: rt("slatsStepTitle"), sub: rt("slatsStepSub") });
  }
  basis.push(
    { kind: "bed2", title: rt("step2Title"), sub: rt("step2Sub") },
    { kind: "parts", title: rt("step3Title"), sub: sub3 },
  );
  if (rWantsAcc === true) {
    rActiveAccessorySteps().forEach(st => {
      basis.push({
        kind: "acc",
        step_no: st.step_no,
        title: rSheetText(st, "title"),
        sub: rSheetText(st, "subtitle"),
      });
    });
  }
  return basis;
}

// currentStep telt binnen de huidige stappenlijst; zorg dat hij nooit
// buiten de lijst valt (bv. nadat de accessoirevraag terug op "nee" of
// "nog niet beantwoord" is gezet, waardoor de lijst weer korter wordt).
function rClampStep(){
  const n = rAllSteps().length;
  if (currentStep > n) currentStep = n;
  if (currentStep < 1) currentStep = 1;
}

// Op POSITIE (n===2, n===3, ...) bepalen kon toen de stappenlijst nog altijd
// dezelfde vaste volgorde had. Sinds de "welke lattenbodem?"-tussenstap er
// soms wel en soms niet tussen zit (30 aug 2026), schuiven "gewenst bed" en
// "onderdelen" van positie op -- dus kijken we voortaan naar het SOORT stap
// op die positie (`kind`) in plaats van naar het volgnummer zelf.
function rCanReachStep(n){
  if (n === 1) return true;
  const steps = rAllSteps();
  if (n < 1 || n > steps.length) return false;
  const kind = steps[n - 1].kind;
  if (kind === "slats1") return !!selectedLeftGroupKey;
  if (kind === "bed2") return !!selectedLeftSku;
  if (kind === "parts") return !!selectedLeftSku && !!selectedRightSku;
  // Accessoirestappen staan alleen in de lijst als de klant al "ja" heeft
  // geantwoord -- en dat kan alleen nadat beide bedden gekozen zijn. Bestaat
  // de stap, dan is hij ook vrij bereikbaar (net als bij de hoofdconfigurator:
  // eenmaal een bed gekozen, mag je vrij tussen stappen springen).
  return true;
}
function rGoToStep(n){
  if (!rCanReachStep(n)) return;
  currentStep = n;
  renderR();
}
function rNextStep(){
  const laatste = rAllSteps().length;
  if (currentStep < laatste && rCanReachStep(currentStep + 1)) rGoToStep(currentStep + 1);
}
function rPrevStep(){
  if (currentStep > 1) rGoToStep(currentStep - 1);
}

// Klant beantwoordt de "wil je ook accessoires?"-vraag in stap 3.
function rAnswerWantsAcc(waarde){
  rWantsAcc = waarde;
  if (waarde === true && rActiveAccessorySteps().length) {
    rNextStep();   // meteen door naar de eerste accessoirecategorie
    return;
  }
  renderR();
}

/* =====================================================================
   RENDER
   ===================================================================== */
function rRefChip(bed, zonderSku){
  const kleur = rWaardeLabel("filter_colour", bed.filter_colour);
  const titel = (bed.shopify && bed.shopify.title) || bed.sku;
  // SKU tonen (okt 2026) zodat duidelijk is welk bed gekozen is; niet in de lattenbodemstap, die toont de SKU al per kaartje.
  const sku = (!zonderSku && bed.sku && bed.sku !== titel) ? ` · SKU: ${rEscAttr(bed.sku)}` : "";
  return `<div class="ref-chip">
    <img class="ref-chip-thumb" src="${rFotoVan(bed)}" alt="" loading="lazy" onerror="${rFotoOnErrorAttr(bed)}">
    <div class="ref-chip-txt"><b>${titel}</b>${kleur} · ${bed.filter_width} cm${sku}</div>
  </div>`;
}

// Tekst uit de Sheet-metaobjecten (steps) kan per taal: "title_nl" wordt
// gebruikt als de winkel in het Nederlands staat, anders valt hij terug op
// "title" (Engels/standaard). Zelfde patroon als sheetText() in de
// hoofdconfigurator.
function rSheetText(row, field){
  if (!row) return "";
  return row[field + "_" + R_LOCALE] || row[field] || "";
}

function rRenderFilterGroups(){
  const ordered = rFiltersOrder();
  const n = ordered.length;
  return `<div class="filter-grid" style="--filter-count:${n}">` + ordered.map((f, i) => {
    const vrij = rFilterUnlocked(i, filters);
    const mogelijk = vrij ? rValuesForFilter(i, filters).map(v => v.toLowerCase()) : [];
    const vals = rUniqueFilterVals(f.filter_key);
    return `<div class="group ${vrij ? "" : "locked"}"><div class="group-label">${f.label}</div><div class="pill-row">
      ${vals.map(v => {
        const active = String(filters[f.filter_key] || "").toLowerCase() === String(v).toLowerCase();
        const kiesbaar = vrij && mogelijk.includes(String(v).toLowerCase());
        const cls = active ? "selected" : (kiesbaar ? "available" : "disabled");
        return `<button type="button" class="pill ${cls}" ${kiesbaar || active ? "" : "disabled"} onclick="rToggleFilter('${f.filter_key}','${String(v).replace(/'/g, "\\'")}')">${rWaardeLabel(f.filter_key, v)}</button>`;
      }).join("")}
    </div></div>`;
  }).join("") + `</div>`;
}

// Zoekveld boven stap 1/2: filtert op SKU (waar service-mensen vaak naar
// vragen) én op de productnaam, zodat je zowel op nummer als op naam kunt
// zoeken. Puur een substring-match, hoofdletterongevoelig.
function rEscAttr(s){
  return String(s == null ? "" : s)
    .replace(/&/g, "&amp;").replace(/"/g, "&quot;")
    .replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
function rBedMatchesSearch(bed, query){
  const q = String(query || "").trim().toLowerCase();
  if (!q) return true;
  const sku = String(bed.sku || "").toLowerCase();
  const title = String((bed.shopify && bed.shopify.title) || "").toLowerCase();
  return sku.includes(q) || title.includes(q);
}
function rSetSearchLeft(waarde){ rSearchLeft = waarde; renderR(); }
function rSetSearchRight(waarde){ rSearchRight = waarde; renderR(); }

function rRenderBedSearch(inputId, waarde, setFnName){
  return `<div class="rbed-search">
    <input type="text" id="${inputId}" class="rbed-search-input" value="${rEscAttr(waarde)}"
      placeholder="${rEscAttr(rt("searchPlaceholder"))}" oninput="${setFnName}(this.value)">
    ${waarde ? `<button type="button" class="rbed-search-clear" onclick="${setFnName}('')" aria-label="${rEscAttr(rt("clearSearch"))}">&times;</button>` : ""}
  </div>`;
}

function rRenderBedGrid(beds, selectedSku, onClickFnName, zoekterm){
  if (!beds.length) return `<div class="empty-note">${rt("noMatch")}</div>`;
  const getoond = zoekterm ? beds.filter(b => rBedMatchesSearch(b, zoekterm)) : beds;
  if (!getoond.length) return `<div class="empty-note">${rt("noSearchMatch", { query: zoekterm })}</div>`;
  return `<div class="acc-grid rbed-grid">` + getoond.map(b => `
    <button type="button" class="acc-card rbed-card ${b.sku === selectedSku ? "selected" : ""}" onclick="${onClickFnName}('${b.sku}')">
      <img class="acc-thumb rbed-thumb" src="${rFotoVan(b)}" alt="" loading="lazy" onerror="${rFotoOnErrorAttr(b)}">
      <div class="acc-name rbed-name">${b.shopify?.title || b.sku}</div>
      <div class="rbed-sku">SKU: ${b.sku}</div>
    </button>`).join("") + `</div>`;
}

// Zoekt of één van de VARIANTEN binnen een groep (dus ongeacht lattenbodem)
// matcht met de zoekterm -- een servicemedewerker die een specifieke SKU
// intypt (bv. van de 23-lattenbodem-variant) moet het bedkaartje toch
// vinden, ook al toont dat kaartje een ANDERE variant als representant.
function rGroupMatchesSearch(groupBeds, query){
  const q = String(query || "").trim();
  if (!q) return true;
  return (groupBeds || []).some(b => rBedMatchesSearch(b, q));
}

// Stap 1 toont per "bed" (groep, zie rBedGroupKey) ÉÉN kaartje, ongeacht
// hoeveel lattenbodem-varianten dat bed heeft (30 aug 2026: de
// lattenbodemvraag komt er als aparte tussenstap bij, dus stap 1 hoeft niet
// meer per lattenbodem een apart, haast identiek kaartje te tonen). De
// representatieve variant (voor foto/naam/SKU op het kaartje) is de eerst
// voorkomende in RDATA.beds; heeft een bed meerdere varianten, dan tonen we
// daarbij een klein label zodat dat niet verrast bij de volgende stap.
// Klikken kiest altijd het hele BED (rPickLeftBed), nooit meteen één
// specifieke SKU -- is er maar 1 variant, dan is die keuze meteen definitief.
function rRenderStep1BedGrid(beds, zoekterm){
  if (!beds.length) return `<div class="empty-note">${rt("noMatch")}</div>`;
  const groepen = rGroupBedsBySlats(beds);
  const term = String(zoekterm || "").trim();
  const getoond = term ? groepen.filter(g => rGroupMatchesSearch(g, term)) : groepen;
  if (!getoond.length) return `<div class="empty-note">${rt("noSearchMatch", { query: term })}</div>`;
  return `<div class="acc-grid rbed-grid">` + getoond.map(groep => {
    const rep = groep[0];
    const geselecteerd = !!selectedLeftGroupKey && rBedGroupKey(rep) === selectedLeftGroupKey;
    return `
    <button type="button" class="acc-card rbed-card ${geselecteerd ? "selected" : ""}" onclick="rPickLeftBed('${rep.sku}')">
      <img class="acc-thumb rbed-thumb" src="${rFotoVan(rep)}" alt="" loading="lazy" onerror="${rFotoOnErrorAttr(rep)}">
      <div class="acc-name rbed-name">${rep.shopify?.title || rep.sku}</div>
      <div class="rbed-sku">SKU: ${rep.sku}</div>
    </button>`;
  }).join("") + `</div>`;
}

/* ---------------- stap 1: huidig bed ---------------- */
function rRenderStep1(){
  const alleGekozen = rAllTopFiltersChosen();
  // Zoeken doorbreekt bewust de "kies bij elk filter een waarde"-eis (op
  // verzoek 30 aug 2026): wie een SKU of naam kent, moet elk bed uit de
  // hele catalogus kunnen vinden, ook als er nog geen (of nog niet alle)
  // filters gekozen zijn. Staat er niets in het zoekveld, dan geldt gewoon
  // weer de bestaande regel: pas bedden tonen als alle filters gekozen zijn.
  const zoekterm = rSearchLeft;
  const zoekActief = !!String(zoekterm || "").trim();
  const basisBedden = zoekActief ? (RDATA.beds || []) : rMatches(filters);
  const right = (zoekActief || alleGekozen)
    ? rRenderStep1BedGrid(basisBedden, zoekterm)
    : `<div class="empty-note">${rt("chooseAllFilters")}</div>`;
  // Zoekveld staat bovenaan links, BOVEN de filters (op verzoek 30 aug 2026)
  // -- zo is meteen duidelijk dat zoeken een snelweg is, los van de
  // filterpillen eronder.
  // De "of gebruik de filters..."-tekst hoort alleen bij stap 1 (huidig
  // bed), niet bij stap 2 -- op verzoek 30 aug 2026.
  const left = rRenderBedSearch("rSearchInputLeft", rSearchLeft, "rSetSearchLeft")
    + `<div class="ref-note rbed-search-hint">${rt("orUseFilters")}</div>`
    + rRenderFilterGroups();
  return { left, right };
}

/* ---------------- tussenstap: welke lattenbodem zit er in dit bed? ------
   Komt alleen voor als het gekozen bed (stap 1) meerdere lattenbodem-
   varianten heeft (zie rLeftGroupHasSlatsChoice() / rAllSteps()). Zolang
   deze stap bestaat, staat selectedLeftGroupKey al vast maar selectedLeftSku
   pas na een keuze hier -- rLeftBed() (en dus stap 2/3) geeft dus pas een
   resultaat zodra de klant hier heeft gekozen. ------------------------- */
function rRenderSlatsStep(){
  if (!selectedLeftGroupKey) return { left: `<div class="empty-note">${rt("chooseLeftFirst")}</div>`, right: "" };
  const varianten = rSlatsVariantsForGroup(selectedLeftGroupKey);
  const rep = varianten[0];
  const left = `
    <div class="ref-note">${rt("slatsStepNote")}</div>
    ${rep ? rRefChip(rep, true) : ""}
    <button type="button" class="ref-edit" onclick="rGoToStep(1)">${rt("changeLeftBed")}</button>
  `;
  const right = `<div class="acc-grid rbed-grid">` + varianten.map(b => {
    const slatsUrl = rSlatsFoto(b.filter_slats);
    const fotoUrl = slatsUrl || rFotoVan(b);
    const onErrorAttr = slatsUrl ? rSlatsFotoOnErrorAttr(b) : rFotoOnErrorAttr(b);
    return `
    <button type="button" class="acc-card rbed-card ${b.sku === selectedLeftSku ? "selected" : ""}" onclick="rPickLeftSlats('${b.sku}')">
      <img class="acc-thumb rbed-thumb" src="${fotoUrl}" alt="" loading="lazy" onerror="${onErrorAttr}">
      <div class="acc-name rbed-name">${rWaardeLabel("filter_slats", b.filter_slats)}</div>
      <div class="rbed-sku">SKU: ${b.sku}</div>
    </button>`;
  }).join("") + `</div>`;
  return { left, right };
}

/* ---------------- stap 2: gewenst bed ---------------- */

/* Opmaak voor de uitleg "waarom staat mijn bed er niet bij?" (12 okt 2026).
   Staat hier in de JS i.p.v. in rebuild-configurator.css zodat er maar één
   bestand vervangen hoeft te worden; wordt één keer in de pagina gezet. */
var rUitlegStijlGezet = false;
function rZetUitlegStijl(){
  if (rUitlegStijlGezet) return;
  rUitlegStijlGezet = true;
  try {
    const st = document.createElement("style");
    st.setAttribute("data-rebuild-uitleg", "1");
    st.textContent = `
.bed-configurator-root .rx-pins{ margin:0 0 14px; }
.bed-configurator-root .rx-pins-title{ font-size:11.5px;color:var(--text-dim);margin-bottom:6px; }
.bed-configurator-root .rx-pin-row{ display:flex;flex-wrap:wrap;gap:6px; }
.bed-configurator-root .rx-pin{ font-size:12px;line-height:1.3;color:var(--white);border:1.5px solid var(--panel-border);border-radius:999px;background:rgba(0,0,0,.18);padding:4px 10px; }
.bed-configurator-root .rx-pin span{ color:var(--text-dim);margin-right:4px; }
.bed-configurator-root .rx-help{ border:1.5px dashed var(--panel-border);border-radius:12px;padding:10px 12px;margin:0 0 16px; }
.bed-configurator-root .rx-help b{ display:block;font-size:12.5px;color:var(--white);margin-bottom:4px; }
.bed-configurator-root .rx-help div{ font-size:12px;color:var(--text-dim);line-height:1.5; }
.bed-configurator-root .rx-excl{ margin-top:22px; }
.bed-configurator-root .rx-excl-title{ font-size:13px;font-weight:600;color:var(--white);margin-bottom:10px; }
.bed-configurator-root .rx-excl-list{ display:flex;flex-direction:column;gap:8px; }
.bed-configurator-root .rx-excl-item{ display:flex;align-items:center;gap:12px;border:1.5px solid var(--panel-border);border-radius:12px;background:rgba(0,0,0,.18);padding:8px 12px;opacity:.8; }
.bed-configurator-root .rx-excl-thumb{ width:56px;height:42px;object-fit:contain;flex-shrink:0;background:transparent;filter:grayscale(1);opacity:.7; }
.bed-configurator-root .rx-excl-txt{ min-width:0; }
.bed-configurator-root .rx-excl-name{ font-size:13px;color:var(--white);line-height:1.3; }
.bed-configurator-root .rx-excl-sku{ font-size:11px;color:var(--text-dim); }
.bed-configurator-root .rx-excl-why{ font-size:12px;color:var(--text-dim);margin-top:2px;line-height:1.4; }
.bed-configurator-root .rx-excl-more{ font-size:12px;color:var(--text-dim);margin-top:8px; }
`;
    document.head.appendChild(st);
  } catch (e) { /* opmaak is een extraatje; zonder blijft alles gewoon werken */ }
}

// Wat ligt er vast voor het gekozen huidige bed: breedte, kleur, lattenbodem.
function rRenderPinned(bed){
  const pins = [];
  if (bed.filter_width) pins.push([rt("pinnedWidth"), rEscAttr(bed.filter_width) + " cm"]);
  if (bed.filter_colour) pins.push([rt("pinnedColour"), rEscAttr(rWaardeLabel("filter_colour", bed.filter_colour))]);
  if (bed.filter_slats) pins.push([rt("pinnedSlats"), rEscAttr(rWaardeLabel("filter_slats", bed.filter_slats))]);
  if (!pins.length) return "";
  return `<div class="rx-pins"><div class="rx-pins-title">${rt("pinnedTitle")}</div><div class="rx-pin-row">`
    + pins.map(p => `<div class="rx-pin"><span>${p[0]}</span>${p[1]}</div>`).join("")
    + `</div></div>`;
}

// Bedden die NIET in de lijst staan, met de reden(en) waarom. Alleen als er
// gezocht wordt (anders zou je de hele bedcatalogus als "niet mogelijk"
// zien). Per bed (bedgroep) tonen we de variant met de minste afwijkingen; bij
// meerdere even goede varianten worden de afwijkende waarden samengevoegd
// (bv. "andere lattenbodem (Deluxe / Premium)").
function rExcludedBeds(leftBed, kandidaten, zoekterm){
  const term = String(zoekterm || "").trim();
  if (!leftBed || !term) return [];
  const toegestaan = new Set([...rAllowedTargetStyles(leftBed.filter_style)].map(s => s.toLowerCase()));
  const kandSkus = new Set((kandidaten || []).map(b => b.sku));
  const lc = v => String(v || "").toLowerCase();
  const groepen = new Map();   // bedgroep -> { titel, kinds, varianten }
  (RDATA.beds || []).forEach(b => {
    if (b.sku === leftBed.sku || kandSkus.has(b.sku)) return;
    if (!rBedMatchesSearch(b, term)) return;
    const kinds = [];
    if (rWidthBucket(b.filter_width) !== rWidthBucket(leftBed.filter_width)) kinds.push("Width");
    if (lc(b.filter_colour) !== lc(leftBed.filter_colour)) kinds.push("Colour");
    if (lc(b.filter_slats) !== lc(leftBed.filter_slats)) kinds.push("Slats");
    if (!kinds.length && !toegestaan.has(lc(b.filter_style))) kinds.push("Style");
    if (!kinds.length) return;   // geen reden = zou kandidaat zijn
    const titel = (b.shopify && b.shopify.title) || b.sku;
    const sleutel = rBedGroupKey(b);   // "hetzelfde bed", los van de lattenbodem
    const g = groepen.get(sleutel);
    if (!g || kinds.length < g.kinds.length) { groepen.set(sleutel, { titel, kinds, varianten: [b] }); }
    else if (kinds.length === g.kinds.length && kinds.join() === g.kinds.join()) { g.varianten.push(b); }
  });
  return [...groepen.values()].map(g => {
    const uniek = (fn) => [...new Set(g.varianten.map(fn).filter(Boolean))];
    const redenen = g.kinds.map(k => {
      if (k === "Width")  return rt("reasonWidth",  { v: rEscAttr(uniek(v => v.filter_width).join(" / ")) + " cm" });
      if (k === "Colour") return rt("reasonColour", { v: rEscAttr(uniek(v => rWaardeLabel("filter_colour", v.filter_colour)).join(" / ")) });
      if (k === "Slats")  return rt("reasonSlats",  { v: rEscAttr(uniek(v => rWaardeLabel("filter_slats", v.filter_slats)).join(" / ")) });
      return rt("reasonStyle");
    });
    return { titel: g.titel, bed: g.varianten[0], redenen };
  });
}

function rRenderExcluded(leftBed, kandidaten, zoekterm){
  const lijst = rExcludedBeds(leftBed, kandidaten, zoekterm);
  if (!lijst.length) return "";
  const MAX = 6;
  const getoond = lijst.slice(0, MAX);
  return `<div class="rx-excl"><div class="rx-excl-title">${rt("excludedTitle")}</div><div class="rx-excl-list">`
    + getoond.map(x => `
    <div class="rx-excl-item">
      <img class="rx-excl-thumb" src="${rFotoVan(x.bed)}" alt="" loading="lazy" onerror="${rFotoOnErrorAttr(x.bed)}">
      <div class="rx-excl-txt">
        <div class="rx-excl-name">${rEscAttr(x.titel)}</div>
        <div class="rx-excl-sku">SKU: ${rEscAttr(x.bed.sku)}</div>
        <div class="rx-excl-why">${rt("excludedBecause", { r: x.redenen.join(" · ") })}</div>
      </div>
    </div>`).join("")
    + `</div>`
    + (lijst.length > MAX ? `<div class="rx-excl-more">${rt("excludedMore", { n: lijst.length - MAX })}</div>` : ``)
    + `</div>`;
}

function rRenderStep2(){
  const a = rLeftBed();
  if (!a) return { left: `<div class="empty-note">${rt("chooseLeftFirst")}</div>`, right: "" };
  rZetUitlegStijl();

  const kandidaten = rRightCandidates(a);
  // Zelfde plek als in stap 1: het zoekveld staat bovenaan links, vóór de
  // referentie-informatie over het vastgezette huidige bed.
  const left = `
    ${rRenderBedSearch("rSearchInputRight", rSearchRight, "rSetSearchRight")}
    <div class="ref-note">${rt("lockedNote")}</div>
    ${rRefChip(a)}
    ${rRenderPinned(a)}
    <button type="button" class="ref-edit" onclick="rGoToStep(1)">${rt("changeLeftBed")}</button>
    <div class="ref-note">${rt("styleOnlyNote")}</div>
    <div class="rx-help"><b>${rt("notListedTitle")}</b><div>${rt("notListedBody")}</div></div>
  `;
  const grid = kandidaten.length
    ? rRenderBedGrid(kandidaten, selectedRightSku, "rSelectRight", rSearchRight)
    : `<div class="empty-note">${rt("noRightMatches")}</div>`;
  const right = grid + rRenderExcluded(a, kandidaten, rSearchRight);
  return { left, right };
}

/* ---------------- stap 3: onderdelen ---------------- */
// Het actiekaartje onderaan de laatste stap: buiten dealer-modus eerst (als
// de vraag nog niet beantwoord is) de ja/nee-vraag "wil je ook accessoires
// bestellen?" i.p.v. meteen de winkelmand-knop -- op verzoek 28 aug 2026.
// Bij "nee" gedraagt alles zich verder precies zoals voorheen (meteen de
// ontbrekende onderdelen in de winkelmand). Bij "ja" gaat de klant door
// naar de accessoirestappen (zie rAllSteps()); hier tonen we dan alleen een
// korte bevestiging plus een manier om terug te wijzigen.
//
// DEALER-MODUS (7 sep 2026): de knop zelf ("In winkelmand" / "Offerte
// maken") en wat hij doet (rAddToCart / rOnCartClick, dat het offerte-
// modaalvenster opent) komen uit rRenderFinalActionCard hieronder -- de
// ja/nee-vraag over accessoires blijft in beide gevallen hetzelfde, want
// die gaat over WAT er op de offerte/in de winkelmand komt, niet over HOE
// het besteld/geoffreerd wordt.
// Dealer-modus (7 sep 2026): zelfde principe als isDealerMode()/cartLabel()/
// onCartClick() in configurator.js -- ÉÉN knop, ÉÉN klik-handler
// (rOnCartClick), die intern beslist of het een winkelmand-actie (rAddToCart)
// of een offerte-actie (rOpenQuoteModal) wordt. Alleen het label verandert.
function rIsDealerMode(){
  return !!(window.REBUILD_CONFIGURATOR_SETTINGS && window.REBUILD_CONFIGURATOR_SETTINGS.dealerMode);
}

/* ---------------- Meten: gebruik en conversie (15 sep 2026) ----------------
   Zelfde GA4-opzet als meetGebeurtenis()/meetKanaal() in configurator.js,
   hier gedupliceerd (bewust, dit bestand deelt niets met de hoofdconfigurator)
   zodat het gebruik van de ombouw-tool ook meetelt. Stuurt niets als er geen
   Analytics op de pagina staat (gtag of dataLayer) -- geen fout, gewoon een
   no-op. */
function rMeetGebeurtenis(naam, extra){
  try {
    if (typeof window.gtag === "function") {
      window.gtag("event", naam, extra || {});
    } else if (Array.isArray(window.dataLayer)) {
      window.dataLayer.push({ event: naam, ...(extra || {}) });
    }
  } catch (e) {
    console.warn("Ombouw-tool: meting kon niet verstuurd worden.", e);
  }
}

// "webshop" op een gewone webshop-pagina, "dealer" op een touchscreen-pagina
// met dealer-modus aan -- zelfde onderscheid als meetKanaal() hierboven.
function rMeetKanaal(){
  return rIsDealerMode() ? "dealer" : "webshop";
}

let rGebruikGemeld = false;   // één keer per bezoek aan de ombouw-tool
// (14 sep 2026, op verzoek) prijsTekst is "" op een markt zonder prijzen --
// dan tonen we de korte knoptekst zonder bedrag (zelfde principe als
// addToWishlist/createQuoteShort in configurator.js) in plaats van een
// knop met een leeg of onjuist bedrag erin.
function rCartLabel(prijsTekst){
  if (!prijsTekst) {
    return rIsDealerMode() ? rt("createQuoteShort") : rt("addToCartShort");
  }
  return rIsDealerMode() ? rt("createQuote", { price: prijsTekst }) : rt("addToCart", { price: prijsTekst });
}
function rOnCartClick(){
  if (rIsDealerMode()) { rOpenQuoteModal(); return; }
  rAddToCart();
}

// heeftAllePrijzen: heeft deze markt een bedrag voor alles wat nu meetelt?
// Zo niet (14 sep 2026, op verzoek), dan tonen we nergens een bedrag --
// geen "Total: €0,00" en geen bedrag in de knoptekst -- want dat "€0" is
// net zo misleidend als het oude "Not orderable yet"-label: het onderdeel
// bestaat gewoon, deze markt laat er alleen geen prijs bij zien.
function rRenderFinalActionCard(total, alleBeschikbaar, toonActieKnop, heeftAllePrijzen){
  const prijsTekst = heeftAllePrijzen ? rMoney(total) : "";
  // (14 sep 2026, op verzoek) De knop mag NIET meer afhangen van "totaal >
  // 0" -- op een markt zonder prijzen is het totaal altijd 0, ook als er
  // wel degelijk onderdelen besteld/geoffreerd moeten worden. rHeeftTeBestellenItems()
  // kijkt puur naar "is er iets om te bestellen", los van prijzen.
  const magKlikken = alleBeschikbaar && rHeeftTeBestellenItems();
  const knopHtml = !toonActieKnop ? `` :
    `<button type="button" class="cta" id="rebuildCartBtn" onclick="rOnCartClick()" ${magKlikken ? "" : "disabled"}>${rCartLabel(prijsTekst)}</button>`;
  return `<div class="action-card">
    ${heeftAllePrijzen ? `<div class="action-total-row"><div class="action-total-label">${rt("total")}</div><div class="action-total-amount">${prijsTekst}</div></div>` : ``}
    ${knopHtml}
    ${toonActieKnop && !alleBeschikbaar ? `<div class="action-note">${rt("rebuildNotOrderable")}</div>` : ``}
  </div>`;
}

function rRenderStep3ActionCard(total, alleBeschikbaar, heeftAllePrijzen){
  // Op verzoek (1 sep 2026): zodra ook maar 1 benodigd onderdeel niet
  // besteltbaar is (alleBeschikbaar === false), mag de HELE ombouw niet
  // meer in de winkelmand -- de winkelmandknop hieronder wordt dan altijd
  // uitgeschakeld, ongeacht het totaal, en er komt een duidelijke melding
  // bij i.p.v. de oudere "sommige onderdelen tellen niet mee"-tekst.
  const totaalRowHtml = heeftAllePrijzen
    ? `<div class="action-total-row"><div class="action-total-label">${rt("total")}</div><div class="action-total-amount">${rMoney(total)}</div></div>`
    : ``;
  if (rWantsAcc === null) {
    return `<div class="action-card">
      ${totaalRowHtml}
      <div class="rebuild-accq-question">${rt("wantAccessoriesQuestion")}</div>
      <div class="rebuild-accq-buttons">
        <button type="button" class="cta cta-ghost" onclick="rAnswerWantsAcc(false)">${rt("no")}</button>
        <button type="button" class="cta" onclick="rAnswerWantsAcc(true)">${rt("yes")}</button>
      </div>
      ${!alleBeschikbaar ? `<div class="action-note">${rt("rebuildNotOrderable")}</div>` : ``}
    </div>`;
  }
  if (rWantsAcc === false) {
    return rRenderFinalActionCard(total, alleBeschikbaar, true, heeftAllePrijzen)
      + `<button type="button" class="ref-edit" onclick="rAnswerWantsAcc(null)">${rt("changeAccAnswer")}</button>`;
  }
  // rWantsAcc === true
  const heeftAccStappen = rActiveAccessorySteps().length > 0;
  return `<div class="action-card">
    ${totaalRowHtml}
    <div class="rebuild-accq-question">${rt("wantsAccessoriesConfirmed")}</div>
    ${heeftAccStappen ? `<button type="button" class="cta" onclick="rNextStep()">${rt("continueToAccessories")}</button>` : `<div class="empty-note">${rt("noAccessoriesForThisBed")}</div>`}
    <button type="button" class="ref-edit" onclick="rAnswerWantsAcc(null)">${rt("changeAccAnswer")}</button>
    ${!alleBeschikbaar ? `<div class="action-note">${rt("rebuildNotOrderable")}</div>` : ``}
  </div>`;
}

function rRenderStep3(){
  const bedA = rLeftBed();
  const bedB = rRightBed();
  if (!bedA) return { left: `<div class="empty-note">${rt("chooseLeftFirst")}</div>`, right: "" };
  if (!bedB) return { left: `<div class="empty-note">${rt("chooseRightBed")}</div>`, right: "" };

  const refBlock = `${rRefChip(bedA)}<div class="ref-arrow-row">↓</div>${rRefChip(bedB)}<button type="button" class="ref-edit" onclick="rGoToStep(2)">${rt("changeBothBeds")}</button>`;

  if (bedA.sku === bedB.sku) {
    return { left: refBlock, right: `<div class="empty-note">${rt("sameBed")}</div>` };
  }

  const partsA = rPartsOf(bedA);
  const partsB = rPartsOf(bedB);
  if (!partsA.length || !partsB.length) {
    return { left: refBlock + `<div class="rebuild-warning">${rt("dataMissingWarning")}</div>`, right: "" };
  }

  const diff = rComputeDiff();

  let total = 0;
  let right;
  if (!diff.missing.length) {
    right = `<div class="empty-note">${rt("noPartsMissing")}</div>`;
  } else {
    const rijen = diff.missing.map(sku => {
      const part = rFindPart(sku);
      const n = rMissingQtyVan(diff, sku);
      // (14 sep 2026, op verzoek) "bestaat" (staat dit onderdeel in de
      // webshop) en "heeftPrijs" (heeft het een bedrag in DEZE markt) zijn
      // twee losse vragen -- zie rIsAvailable/rHasPrice hierboven. Eerder
      // stond hier maar 1 check (prijs > 0) die beide door elkaar haalde,
      // waardoor een prijsloze markt per ongeluk "Not orderable yet" liet
      // zien bij onderdelen die gewoon bestaan, alleen zonder bedrag.
      const bestaat = rIsAvailable(part);
      const heeftPrijs = rHasPrice(part);
      const subtotaal = heeftPrijs ? Number(part.shopify.price) * n : 0;
      if (heeftPrijs) total += subtotaal;
      const titel = (part && part.shopify && part.shopify.title) || sku;
      const foto = part ? rFotoVan(part) : "";

      // Prijskolom: bedrag als de markt een prijs heeft; helemaal leeg (geen
      // bedrag, geen tekst) als het onderdeel bestaat maar deze markt geen
      // prijzen toont; het "Not orderable yet"-label alleen als het
      // onderdeel écht niet in de webshop staat.
      const prijsCel = heeftPrijs
        ? rMoney(subtotaal, part.shopify.currency)
        : (bestaat ? `` : `<span class="abadge">${rt("notOrderableYet")}</span>`);

      return `<div class="rebuild-part ${bestaat ? "" : "rebuild-part--missing"}">
        ${foto
          ? `<img class="rebuild-part-photo" src="${foto}" alt="" loading="lazy" onerror="${part ? rFotoOnErrorAttr(part) : "this.style.display='none'"}">`
          : `<div class="rebuild-part-photo rebuild-part-photo--empty"></div>`}
        <div class="rebuild-part-info">
          <div class="rebuild-part-title">${titel}</div>
          <div class="rebuild-part-sku">SKU: ${sku}${n > 1 ? ` · ${n}×` : ``}</div>
        </div>
        <div class="rebuild-part-price">${prijsCel}</div>
      </div>`;
    }).join("");
    right = `<div class="rebuild-parts-list">${rijen}</div>`;
  }

  // Eén bron van waarheid voor "mag deze ombouw wel/niet besteld worden"
  // (rAllPartsOrderable) -- zie de toelichting daar. Dat is dezelfde
  // voorwaarde als "elke rij hierboven bestaat ook echt in de webshop"
  // (14 sep 2026, gecorrigeerd: gaat over BESTAAN, niet over prijs), maar
  // nu ook herbruikbaar voor de winkelmandknop verderop in de
  // accessoirestappen.
  const alleBeschikbaar = rAllPartsOrderable();
  // (7 sep 2026) Het actiekaartje (totaal + knop) wordt NIET meer aan "left"
  // vastgeplakt, want dat blok komt in de scrollbare kolom terecht -- bij
  // een lange onderdelenlijst kon het kaartje dan onderaan "wegscrollen" en
  // leek de winkelmand-/offerteknop verdwenen. Door het apart als "action"
  // terug te geven, kan renderR() het BUITEN de scrollbare zone plaatsen,
  // vastgeprikt onderaan de linkerkolom -- zie ook rRenderAccStep hieronder.
  const action = rRenderStep3ActionCard(total, alleBeschikbaar, rHeeftAllePrijzen());
  return { left: refBlock, right, action };
}

function renderR(){
  const app = document.getElementById("rebuild-app");
  if (!app) return;
  rClampStep();

  // renderR() vervangt de hele HTML van deze sectie, ook bij elke toets in
  // het zoekveld (rSetSearchLeft/Right roepen renderR() aan). Zonder deze
  // omweg zou het zoekveld na elke letter de focus en cursorpositie
  // verliezen. We onthouden dus welk element (op basis van id) actief was
  // en zetten de focus/cursor daarna terug op het opnieuw getekende element
  // met datzelfde id.
  const actiefEl = document.activeElement;
  const actiefId = actiefEl && actiefEl.id ? actiefEl.id : null;
  const actiefSelStart = actiefEl && typeof actiefEl.selectionStart === "number" ? actiefEl.selectionStart : null;
  const actiefSelEnd = actiefEl && typeof actiefEl.selectionEnd === "number" ? actiefEl.selectionEnd : null;

  const steps = rAllSteps();
  const stepperHtml = steps.map((s, i) => {
    const n = i + 1;
    const cls = n < currentStep ? "done" : (n === currentStep ? "active" : "");
    return `<button type="button" class="seg ${cls}" ${rCanReachStep(n) ? "" : "disabled"} onclick="rGoToStep(${n})"><span class="fill"></span></button>`;
  }).join("");

  const huidige = steps[currentStep - 1];
  const panes = huidige.kind === "bed1" ? rRenderStep1()
    : huidige.kind === "slats1" ? rRenderSlatsStep()
    : huidige.kind === "bed2" ? rRenderStep2()
    : huidige.kind === "parts" ? rRenderStep3()
    : rRenderAccStep(huidige.step_no);

  const isLaatsteStap = currentStep === steps.length;
  // Stap 3 (onderdelen) regelt zijn eigen navigatie via de ja/nee-vraag en
  // de knoppen in het actiekaartje -- daar blijft de gewone "Volgende"-knop
  // dus altijd verborgen, ook als er daarna nog accessoirestappen volgen.
  const isOnderdelenStap = huidige.kind === "parts";
  const nextHidden = isLaatsteStap || isOnderdelenStap;
  const nextDisabled = !isLaatsteStap && !isOnderdelenStap && !rCanReachStep(currentStep + 1);

  app.innerHTML = `
    <div class="wrap rwiz-wrap">
      <div class="stepper">${stepperHtml}</div>
      <div class="step-meta">
        <span>${rt("stepOf", { n: currentStep, total: steps.length })}</span>
        <button type="button" class="restart-btn" onclick="rStartOver()">${rt("startOver")}</button>
      </div>
      <h2 class="title">${huidige.title}</h2>
      ${huidige.sub ? `<div class="subtitle">${huidige.sub}</div>` : ""}

      <div class="rwiz-columns">
        <div class="rwiz-left">
          <div class="rwiz-scroll">${panes.left}</div>
          ${panes.action || ""}
          <div class="rwiz-nav">
            <button type="button" class="cta cta-ghost" onclick="rPrevStep()" ${currentStep === 1 ? 'style="visibility:hidden"' : ''}>${rt("prev")}</button>
            <button type="button" class="cta" ${nextHidden ? 'style="visibility:hidden"' : ''} onclick="rNextStep()" ${nextDisabled ? "disabled" : ""}>${rt("next")}</button>
          </div>
        </div>
        <div class="rwiz-right">${panes.right}</div>
      </div>
    </div>`;

  if (actiefId) {
    const opnieuw = document.getElementById(actiefId);
    if (opnieuw) {
      opnieuw.focus();
      if (actiefSelStart !== null && typeof opnieuw.setSelectionRange === "function") {
        try { opnieuw.setSelectionRange(actiefSelStart, actiefSelEnd); } catch (e) { /* niet elk inputtype ondersteunt dit */ }
      }
    }
  }

  rMeetEnZetHoogte();
}

/* =====================================================================
   SCHERMHOOGTE ZELF METEN (i.p.v. het vaste "scherm min 200px" uit
   configurator.css klakkeloos over te nemen)
   ---------------------------------------------------------------------
   De hoofdconfigurator gaat ervan uit dat er altijd zo'n 200 pixels
   koptekst/footer om de kolommen heen zit. Op de ombouw-pagina bleek dat
   niet te kloppen (de kolommen begonnen verder naar beneden dan die
   aanname verwacht), waardoor de knoppen Vorige/Volgende niet meer
   vanzelf in beeld pasten en de hele pagina moest scrollen. In plaats van
   opnieuw een vast getal te gokken dat op een andere pagina weer fout kan
   zitten, meet dit hoeveel ruimte er ECHT nog over is vanaf waar de
   kolommen op DEZE pagina daadwerkelijk beginnen tot de onderkant van het
   scherm, en zet dat als --cfg-height op het wortel-element van déze
   sectie (raakt dus nooit de hoofdconfigurator, die zijn eigen --cfg-
   height uit configurator.css gewoon blijft gebruiken).
   ===================================================================== */
// Pure rekenstap, apart getest: gegeven hoe ver de kolommen al vanaf de
// bovenkant van het scherm staan, de schermhoogte, en een onderste
// veiligheidsmarge -- wat de hoogte van de kolommen moet worden. Nooit
// kleiner dan 430px (te weinig ruimte voor de inhoud) of groter dan 860px
// (zelfde bovengrens als de hoofdconfigurator, voor eenzelfde look).
function rBerekenCfgHoogte(top, innerHeight, marge){
  const beschikbaar = innerHeight - top - marge;
  return Math.max(430, Math.min(860, beschikbaar));
}

function rMeetEnZetHoogte(){
  const app = document.getElementById("rebuild-app");
  if (!app || typeof app.querySelector !== "function") return;
  const kolommen = app.querySelector(".rwiz-columns");
  const root = typeof app.closest === "function" ? app.closest(".bed-configurator-root") : null;
  if (!kolommen || !root) return;
  if (typeof kolommen.getBoundingClientRect !== "function") return;
  if (typeof window === "undefined" || typeof window.innerHeight !== "number") return;

  const top = kolommen.getBoundingClientRect().top;
  // (7 sep 2026) Onder de kolommen zit nog wat vaste padding die niet
  // meebeweegt met --cfg-height: de ".rwiz-wrap"-container en de buitenste
  // sectie-omlijsting hebben allebei hun eigen padding-bottom (in de CSS
  // bedoeld als nette witruimte onderaan de pagina). Die telde tot nu toe
  // niet mee als "nog te reserveren ruimte", waardoor de kolommen zelf wel
  // op het scherm pasten maar de pagina ALS GEHEEL (incl. die padding)
  // net te hoog werd -- gevolg: een browser-scrollbalk op de kiosk/
  // touchscreen-pagina, en op een lager scherm kon je daardoor ook de
  // totaalprijs en de offerte-/winkelmandknop kwijtraken onderin. Door die
  // padding hier ECHT te meten (i.p.v. te gokken) en mee te tellen in de
  // marge, past de hele pagina weer in één keer op het scherm.
  const wrapEl = app.querySelector(".rwiz-wrap");
  const wrapPadB = wrapEl ? parseFloat(getComputedStyle(wrapEl).paddingBottom) || 0 : 0;
  const rootPadB = parseFloat(getComputedStyle(root).paddingBottom) || 0;
  const marge = 32 + wrapPadB + rootPadB;
  const hoogte = rBerekenCfgHoogte(top, window.innerHeight, marge);
  root.style.setProperty("--cfg-height", hoogte + "px");
}

function rStartOver(){
  currentStep = 1;
  filters = {};
  selectedLeftSku = null;
  selectedLeftGroupKey = null;
  selectedRightSku = null;
  rResetAccKeuze();
  rSearchLeft = "";
  rSearchRight = "";
  rApplyDefaultFilters();
  renderR();
}

/* =====================================================================
   WINKELMAND
   ===================================================================== */
function rWinkelPad(pad){
  const S = window.REBUILD_CONFIGURATOR_SETTINGS || {};
  const root = (S.routesRoot || "/").replace(/\/$/, "");
  return root + pad;
}

function rNumericVariantId(ref){
  if (!ref) return null;
  const m = String(ref).match(/(\d+)$/);
  return m ? Number(m[1]) : null;
}

async function rAddToCart(){
  const diff = rComputeDiff();
  if (!diff) return;

  // Extra vangnet, voor het geval deze functie ooit ergens anders dan via
  // de (dan uitgeschakelde) winkelmandknop wordt aangeroepen: 1 niet-
  // besteltbaar onderdeel blokkeert de hele ombouw.
  if (!rAllPartsOrderable()) { alert(rt("rebuildNotOrderable")); return; }

  // Onderdelen en (als de klant "ja" heeft gezegd) accessoires gaan in ÉÉN
  // winkelmand-actie mee. Dezelfde variant twee keer (bv. hetzelfde matras
  // boven én onder gekozen) wordt hier samengevoegd tot één regel met een
  // hoger aantal, net als in de hoofdconfigurator.
  const perVariant = new Map();
  function rVoegToe(id, qty, propLabel, propValue){
    if (!id) return;
    if (perVariant.has(id)) { perVariant.get(id).quantity += qty; return; }
    perVariant.set(id, { id, quantity: qty, properties: { [propLabel]: propValue } });
  }

  // (14 sep 2026, gecorrigeerd) Een onderdeel/accessoire overslaan bij het
  // toevoegen aan de winkelmand mag alleen als het écht niet bestaat
  // (rIsAvailable => false) -- niet omdat deze markt er toevallig geen
  // prijs bij toont. Zelfde principe als addToCart() in configurator.js,
  // die ook niets uitfiltert op prijs.
  diff.missing.forEach(sku => {
    const part = rFindPart(sku);
    if (!rIsAvailable(part)) return; // bestaat niet in de webshop: overslaan
    const n = rMissingQtyVan(diff, sku);
    // Dit label staat straks op de order/pakbon in de administratie, dus
    // bewust NIET via rt() (die volgt de taal van de klant) maar altijd
    // in het Engels -- op verzoek 15 sep 2026, voor één vaste taal op
    // alle orders ongeacht de markt waarop besteld is.
    rVoegToe(rNumericVariantId(part.shopify.variant_id), n, R_TRANSLATIONS.en.propRebuild, `${diff.bedA.sku} → ${diff.bedB.sku}`);
  });

  if (rWantsAcc === true) {
    Object.entries(selectedRAcc).forEach(([key, acc]) => {
      if (!rIsAvailable(acc)) return; // bestaat niet in de webshop: overslaan
      const id = rNumericVariantId(acc.variant_id || acc.shopify.defaultVariantId);
      rVoegToe(id, rAccQtyOf(key), rt("propAccessoryFor"), diff.bedB.sku);
    });
    // Sub-accessoires met hun eigen aantal (max_qty, bv. 1x/2x bij het
    // Roof-paneel 6378-10), met dezelfde eigenschap als de gewone accessoires.
    Object.entries(selectedRSubAcc).forEach(([key, acc]) => {
      if (!rIsAvailable(acc)) return;
      const id = rNumericVariantId(acc.variant_id || acc.shopify.defaultVariantId);
      rVoegToe(id, rSubAccQtyOf(key), rt("propAccessoryFor"), diff.bedB.sku);
    });
  }

  const items = [...perVariant.values()];

  if (!items.length) {
    alert(rt("cartError"));
    return;
  }

  try {
    const r = await fetch(rWinkelPad("/cart/add.js"), {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ items }),
    });
    if (r.ok) {
      // Meten (15 sep 2026): zelfde soort event als bed_configurator_add_to_cart
      // in configurator.js. Hergebruikt rBouwOfferteRegels() voor de waarde --
      // dezelfde, al geteste optelling die ook de offerte/het actiekaartje
      // gebruikt, dus geen dubbele rekenlogica.
      const { regels, metPrijzen, totaalRuw } = rBouwOfferteRegels();
      rMeetGebeurtenis("bed_rebuild_add_to_cart", {
        value: metPrijzen ? Math.round(totaalRuw * 100) / 100 : undefined,
        currency: metPrijzen ? (rCurrency() || undefined) : undefined,
        bed_from_sku: diff.bedA ? diff.bedA.sku : undefined,
        bed_to_sku: diff.bedB ? diff.bedB.sku : undefined,
        items: items.length,
        channel: rMeetKanaal(),
      });
      window.location.href = rWinkelPad("/cart");
      return;
    }

    let reden = "";
    try {
      const err = await r.json();
      reden = err.description || err.message || "";
      console.error("Cart-fout van Shopify:", err, "| verstuurd:", items);
    } catch {
      reden = await r.text().catch(() => "");
      console.error("Cart-fout (geen JSON):", reden, "| verstuurd:", items);
    }
    alert(rt("cartError") + (reden ? "\n\n" + reden : ""));
  } catch (e) {
    console.error("Netwerkfout bij toevoegen aan winkelmand:", e);
    alert(rt("networkError", { msg: e.message }));
  }
}

/* =====================================================================
   DEALER-MODUS -- OFFERTE-PDF (7 sep 2026)
   ---------------------------------------------------------------------
   Zelfde opzet als genereerOffertePdf/downloadOfferte/
   verstuurOfferteViaEmail/openQuoteModal/onCartClick in configurator.js,
   hier met eigen (r-prefix) namen en eigen state, en gebruikmakend van de
   GEDEELDE PDF-motor in offerte-pdf.js (window.OffertePdf.maakOffertePdfV2)
   -- zie de uitleg bovenaan dit bestand en in offerte-pdf.js zelf.

   rBouwOfferteRegels() combineert de ontbrekende onderdelen (rComputeDiff)
   met -- als de klant "ja" heeft gezegd op de accessoirevraag -- de
   gekozen accessoires, tot dezelfde "regels"-vorm die de PDF-motor
   verwacht (titel/sku/aantal/prijsTekst/totaalTekst/fotoUrl/
   fotoUrlTerugval). Dit is bewust een APARTE opbouw t.o.v. rAddToCart()
   hierboven (die bouwt cart-items, geen PDF-regels), ook al lijken de twee
   functies op elkaar.
   ===================================================================== */
function rBouwOfferteRegels(){
  const diff = rComputeDiff();
  const regels = [];

  // (14 sep 2026, gecorrigeerd) Een regel overslaan mag alleen als het
  // onderdeel/de accessoire écht niet bestaat (rIsAvailable => false) --
  // rAllPartsOrderable blokkeert dan toch al de hele offerte-knop. Bestaat
  // het wel, maar heeft deze markt er geen prijs bij (rHasPrice => false),
  // dan komt de regel gewoon op de offerte te staan mét lege
  // prijsTekst/totaalTekst -- dezelfde regels-vorm die de PDF-motor al
  // kent via "metPrijzen" hieronder, dus geen aparte aanpassing daar nodig.
  if (diff) {
    diff.missing.forEach(sku => {
      const part = rFindPart(sku);
      if (!rIsAvailable(part)) return; // bestaat niet in de webshop: overslaan
      const n = rMissingQtyVan(diff, sku);
      const heeftPrijs = rHasPrice(part);
      const prijs = heeftPrijs ? Number(part.shopify.price) : 0;
      regels.push({
        titel: (part.shopify && part.shopify.title) || sku,
        sku,
        aantal: n,
        prijsTekst: heeftPrijs ? rMoney(prijs, part.shopify.currency) : "",
        totaalTekst: heeftPrijs ? rMoney(prijs * n, part.shopify.currency) : "",
        fotoUrl: rFotoVan(part) || "",
        fotoUrlTerugval: rFotoTerugval(part) || "",
      });
    });
  }

  if (rWantsAcc === true) {
    Object.entries(selectedRAcc).forEach(([key, acc]) => {
      if (!rIsAvailable(acc)) return;
      const n = rAccQtyOf(key);
      const heeftPrijs = rHasPrice(acc);
      const eenheidsprijs = heeftPrijs ? Number(acc.shopify.price) : 0;
      regels.push({
        titel: acc.shopify.title || acc.sku,
        sku: acc.sku,
        aantal: n,
        prijsTekst: heeftPrijs ? rMoney(eenheidsprijs, acc.shopify.currency) : "",
        totaalTekst: heeftPrijs ? rMoney(eenheidsprijs * n, acc.shopify.currency) : "",
        fotoUrl: rFotoVan(acc) || "",
        fotoUrlTerugval: rFotoTerugval(acc) || "",
      });
    });
    // Sub-accessoires met hun eigen aantal (max_qty, bv. 1x/2x bij het
    // Roof-paneel 6378-10; zonder max_qty, zoals de matras bij het
    // logeerbed, blijft dat gewoon 1 stuk).
    Object.entries(selectedRSubAcc).forEach(([key, acc]) => {
      if (!rIsAvailable(acc)) return;
      const n = rSubAccQtyOf(key);
      const heeftPrijs = rHasPrice(acc);
      const eenheidsprijs = heeftPrijs ? Number(acc.shopify.price) : 0;
      regels.push({
        titel: acc.shopify.title || acc.sku,
        sku: acc.sku,
        aantal: n,
        prijsTekst: heeftPrijs ? rMoney(eenheidsprijs, acc.shopify.currency) : "",
        totaalTekst: heeftPrijs ? rMoney(eenheidsprijs * n, acc.shopify.currency) : "",
        fotoUrl: rFotoVan(acc) || "",
        fotoUrlTerugval: rFotoTerugval(acc) || "",
      });
    });
  }

  const metPrijzen = regels.every(r => !!r.prijsTekst);
  const totaal = rGrandTotal();
  return { regels, metPrijzen, totaalTekst: metPrijzen ? rMoney(totaal) : "", totaalRuw: totaal };
}

// Taalcode voor Intl.DateTimeFormat/toLocaleDateString; "en" wordt "en-GB"
// zodat de datum als dag-maand-jaar staat, consistent met de rest van
// Europa. Zelfde functie als pdfLocale() in configurator.js, hier
// gedupliceerd omdat het maar 1 regel is en dit bestand bewust niets deelt
// met de hoofdconfigurator.
function rPdfLocale(){
  return R_LOCALE === "en" ? "en-GB" : R_LOCALE;
}

// Supabase Edge Function "send-offerte" (2 okt 2026) -- zelfde server-route
// als configurator.js gebruikt (zie de uitleg daar); hier met eigen
// "r"-namen gedupliceerd in plaats van gedeeld, zoals de rest van dit
// bestand dat ook doet (zie de toelichting bovenaan dit bestand).
const R_SUPABASE_OFFERTE_FUNCTIE_URL = "https://dqodtpnuboyjkgezjkxc.supabase.co/functions/v1/send-offerte";
const R_SUPABASE_OFFERTE_PUBLISHABLE_KEY = "sb_publishable_UuhVnetaN1DgUEA3daWWYQ_SXms6Rms";

// Bouwt de regels, genereert de PDF (via de gedeelde motor) en zet die
// klaar om te downloaden/mailen. Gooit een fout bij een lege selectie of
// als de PDF niet gebouwd kan worden; de aanroeper (rOpenQuoteModal) vangt
// die op en toont een nette melding.
async function rGenereerOffertePdf({ email, naam, dealerNaam, dealerEmail, actie }){
  if (!window.OffertePdf || typeof window.OffertePdf.maakOffertePdfV2 !== "function") {
    // offerte-pdf.js is niet geladen -- meestal omdat dat bestand nog niet
    // als Asset in Shopify Admin staat, of omdat de <script>-tag ervoor per
    // ongeluk is verwijderd uit rebuild-configurator.liquid.
    throw new Error("offerte-pdf.js is niet geladen (ontbreekt als Asset in Shopify, of de <script>-tag ervoor is weg).");
  }
  const bedA = rLeftBed();
  const bedB = rRightBed();
  const { regels, metPrijzen, totaalTekst, totaalRuw } = rBouwOfferteRegels();
  const datumTekst = new Date().toLocaleDateString(rPdfLocale());
  const logoUrl = (window.REBUILD_CONFIGURATOR_SETTINGS && window.REBUILD_CONFIGURATOR_SETTINGS.dealerLogoUrl) || "";
  const titelA = (bedA && ((bedA.shopify && bedA.shopify.title) || bedA.sku)) || "";
  const titelB = (bedB && ((bedB.shopify && bedB.shopify.title) || bedB.sku)) || "";
  // (7 sep 2026) Was eerst "TitelA → TitelB": het pijltje-teken zit niet in
  // het kleine, ingebakken PDF-lettertype (dat alleen Latin-1 + euroteken +
  // "slimme" aanhalingstekens bevat, zie offerte-pdf.js), dus kwam er in de
  // PDF een "?" te staan in plaats van een pijltje. Op verzoek nu een gewone
  // zin i.p.v. een symbool -- leesbaarder, en geen lettertype-afhankelijkheid
  // meer. Vertaald per taal via rebuildTitleLine hierboven.
  const bedTitel = (titelA && titelB) ? rt("rebuildTitleLine", { from: titelA, to: titelB }) : (titelA || titelB || "");

  const pdfBytes = await window.OffertePdf.maakOffertePdfV2({
    regels,
    metPrijzen,
    totaalTekst,
    klantNaam: naam,
    klantEmail: email,
    dealerNaam,
    dealerEmail,
    bedTitel,
    datumTekst,
    logoUrl,
    vertaal: rt,
  });

  // Meten (15 sep 2026): zelfde soort event als bed_configurator_quote_created
  // in configurator.js, inclusief het onderscheid download/e-mail via "actie"
  // (al doorgegeven door rDownloadOfferte()/rVerstuurOfferteViaEmail()
  // hieronder -- hier alleen gebruikt om te meten, niet om iets te wijzigen
  // aan de PDF zelf).
  rMeetGebeurtenis("bed_rebuild_quote_created", {
    value: metPrijzen ? Math.round(totaalRuw * 100) / 100 : undefined,
    currency: metPrijzen ? (rCurrency() || undefined) : undefined,
    bed_from_sku: bedA ? bedA.sku : undefined,
    bed_to_sku: bedB ? bedB.sku : undefined,
    items: regels.length,
    channel: rMeetKanaal(),
    action: actie,
    dealer: dealerNaam || undefined,
  });

  const bestandsnaam = `offerte-ombouw-${(bedB && bedB.sku) || "bed"}-${Date.now()}.pdf`;
  const blob = new Blob([pdfBytes], { type: "application/pdf" });
  return { blob, bestandsnaam, pdfBytes, regels, metPrijzen, totaalTekst, bedTitel };
}

function rDownloadOffertePdf(blob, bestandsnaam){
  if (typeof URL === "undefined" || typeof document === "undefined") return;
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = bestandsnaam;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 4000);
}

// dealerEmail komt als "cc" in de mailto-link terecht, zodat de dealer bij
// het versturen automatisch ook zelf een kopie krijgt.
function rOpenOfferteMailConcept(email, dealerEmail, bestandsnaam){
  if (typeof window === "undefined") return;
  const onderwerp = encodeURIComponent(rt("quoteMailSubject"));
  const body = encodeURIComponent(rt("quoteMailBody", { file: bestandsnaam }));
  const cc = dealerEmail ? `&cc=${encodeURIComponent(dealerEmail)}` : "";
  window.location.href = `mailto:${encodeURIComponent(email)}?subject=${onderwerp}${cc}&body=${body}`;
}

// Knop "PDF downloaden": maakt de PDF en zet die meteen als download klaar.
async function rDownloadOfferte({ email, naam, dealerNaam, dealerEmail }){
  const { blob, bestandsnaam } = await rGenereerOffertePdf({ email, naam, dealerNaam, dealerEmail, actie: "download" });
  rDownloadOffertePdf(blob, bestandsnaam);
}

// Zelfde server-route als verstuurOfferteViaServer() in configurator.js --
// zie de uitleg daar. Geeft `true` terug bij bevestigd succes, anders
// altijd `false` (nooit een fout die verder omhoog gegooid wordt).
async function rVerstuurOfferteViaServer({ email, dealerEmail, klantNaam, dealerNaam, bedTitel, totaalTekst, regels, pdfBytes, bestandsnaam }){
  if (typeof fetch !== "function") return false;
  if (!window.OffertePdf || typeof window.OffertePdf.pdfArrayBufferNaarBase64 !== "function") return false;

  const pdfBase64 = window.OffertePdf.pdfArrayBufferNaarBase64(pdfBytes);
  if (!pdfBase64) return false;

  const controller = (typeof AbortController === "function") ? new AbortController() : null;
  const timeoutId = controller ? setTimeout(() => controller.abort(), 20000) : null;
  try {
    const res = await fetch(R_SUPABASE_OFFERTE_FUNCTIE_URL, {
      method: "POST",
      headers: { "Content-Type": "application/json", "apikey": R_SUPABASE_OFFERTE_PUBLISHABLE_KEY },
      body: JSON.stringify({
        email,
        dealerEmail,
        klantNaam,
        dealerNaam,
        storeId: dealerNaam,
        taal: R_LOCALE,
        bedTitel,
        totaalTekst,
        regels,
        pdfBase64,
        bestandsnaam,
      }),
      signal: controller ? controller.signal : undefined,
    });
    if (!res.ok) {
      console.warn("[offerte] server gaf een foutstatus, val terug op delen/mailto:", res.status);
      return false;
    }
    const data = await res.json().catch(() => null);
    if (!data || data.ok !== true) {
      console.warn("[offerte] server meldt dat versturen niet gelukt is, val terug op delen/mailto:", data && data.error);
      return false;
    }
    return true;
  } catch (e) {
    console.warn("[offerte] server niet bereikbaar, val terug op delen/mailto:", e && e.message);
    return false;
  } finally {
    if (timeoutId) clearTimeout(timeoutId);
  }
}

// Knop "Per e-mail versturen": probeert eerst de offerte écht te laten
// versturen via onze eigen server (rVerstuurOfferteViaServer hierboven,
// sinds 2 okt 2026). Lukt dat, dan is de klant al gemaild (met de dealer
// in cc) en is er verder niets meer te doen. Lukt dat niet, dan valt dit
// terug op de oorspronkelijke manier: eerst de Web Share API proberen, en
// anders downloaden + een mailto-concept met het dealer-adres als cc.
async function rVerstuurOfferteViaEmail({ email, naam, dealerNaam, dealerEmail }){
  const { blob, bestandsnaam, pdfBytes, regels, metPrijzen, totaalTekst, bedTitel } =
    await rGenereerOffertePdf({ email, naam, dealerNaam, dealerEmail, actie: "email" });

  const serverGelukt = await rVerstuurOfferteViaServer({
    email, dealerEmail, klantNaam: naam, dealerNaam, bedTitel, totaalTekst, regels, pdfBytes, bestandsnaam,
  });
  if (serverGelukt) return;

  let gedeeld = false;
  if (typeof navigator !== "undefined" && navigator.share && navigator.canShare && typeof File === "function") {
    try {
      const file = new File([blob], bestandsnaam, { type: "application/pdf" });
      if (navigator.canShare({ files: [file] })) {
        await navigator.share({ files: [file], title: rt("quoteModalTitle"), text: rt("quoteShareText", { email }) });
        gedeeld = true;
      }
    } catch (e) {
      if (e && e.name === "AbortError") gedeeld = true;
    }
  }

  if (!gedeeld) {
    rDownloadOffertePdf(blob, bestandsnaam);
    rOpenOfferteMailConcept(email, dealerEmail, bestandsnaam);
  }
}

// Simpel e-mailadres-formaat -- zelfde vuistregel als configurator.js
// (bewust geen volledige RFC5322-validatie, dat is voor dit doel niet nodig).
function rIsValidEmail(v){
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(v || "").trim());
}

// Opent het offertevenster: dealernaam, dealer-e-mailadres, e-mailadres van
// de klant en naam van de klant -- ALLE vier verplicht (sinds 5 okt 2026), voor
// zowel downloaden als versturen -- en de twee actieknoppen. Zelfde structuur/CSS-klassen/element-ID's als
// openQuoteModal() in configurator.js (hergebruikt bewust .guide-overlay/
// .guide-box zoals de rest van de popups daar, en dezelfde IDs zoals
// quoteDealerInput/quoteDownloadBtn/... -- dat kan geen kwaad, want deze
// tool staat altijd op een eigen pagina, nooit samen met de
// hoofdconfigurator op dezelfde pagina).
function rOpenQuoteModal(){
  const { regels } = rBouwOfferteRegels();
  if (!regels.length) { alert(rt("quoteNoItems")); return; }

  const overlay = document.createElement("div");
  overlay.className = "guide-overlay";
  overlay.innerHTML = `
    <div class="guide-box quote-box" role="dialog" aria-modal="true" aria-label="${rt("quoteModalTitle")}">
      <button class="guide-close" aria-label="${rt("quoteCancelBtn")}">&times;</button>
      <div class="quote-content">
        <h3 class="quote-title">${rt("quoteModalTitle")}</h3>
        <p class="quote-intro">${rt("quoteIntro")}</p>
        <label class="quote-label" for="quoteDealerInput">${rt("quoteDealerLabel")} *</label>
        <input type="text" id="quoteDealerInput" class="quote-input" placeholder="${rEscAttr(rt("quoteDealerPlaceholder"))}" autocomplete="off">
        <label class="quote-label" for="quoteDealerEmailInput">${rt("quoteDealerEmailLabel")} *</label>
        <input type="email" id="quoteDealerEmailInput" class="quote-input" placeholder="${rEscAttr(rt("quoteDealerEmailPlaceholder"))}" autocomplete="off">
        <label class="quote-label" for="quoteEmailInput">${rt("quoteEmailLabel")} *</label>
        <input type="email" id="quoteEmailInput" class="quote-input" placeholder="${rEscAttr(rt("quoteEmailPlaceholder"))}" autocomplete="email">
        <label class="quote-label" for="quoteNameInput">${rt("quoteNameLabel")} *</label>
        <input type="text" id="quoteNameInput" class="quote-input" placeholder="${rEscAttr(rt("quoteNamePlaceholder"))}" autocomplete="name">
        <div class="quote-error" id="quoteErrorBox" style="display:none;"></div>
        <div class="quote-actions">
          <button type="button" class="cta cta-ghost" id="quoteCancelBtn">${rt("quoteCancelBtn")}</button>
          <button type="button" class="cta cta-secondary" id="quoteDownloadBtn">${rt("quoteDownloadBtn")}</button>
          <button type="button" class="cta" id="quoteEmailActionBtn">${rt("quoteEmailBtn")}</button>
        </div>
      </div>
    </div>`;
  document.body.appendChild(overlay);

  const sluit = () => { overlay.remove(); document.removeEventListener("keydown", esc); };
  function esc(e){ if (e.key === "Escape") sluit(); }
  overlay.addEventListener("click", e => { if (e.target === overlay) sluit(); });
  overlay.querySelector(".guide-close").addEventListener("click", sluit);
  overlay.querySelector("#quoteCancelBtn").addEventListener("click", sluit);
  document.addEventListener("keydown", esc);

  const dealerInput = overlay.querySelector("#quoteDealerInput");
  const dealerEmailInput = overlay.querySelector("#quoteDealerEmailInput");
  const emailInput = overlay.querySelector("#quoteEmailInput");
  const nameInput = overlay.querySelector("#quoteNameInput");
  const errorBox = overlay.querySelector("#quoteErrorBox");
  const downloadBtn = overlay.querySelector("#quoteDownloadBtn");
  const emailBtn = overlay.querySelector("#quoteEmailActionBtn");

  const toonFout = (msg) => {
    errorBox.textContent = msg;
    errorBox.style.display = "block";
  };

  // ALLE vier de velden (dealernaam, dealer-e-mailadres, e-mailadres van de
  // klant, naam van de klant) zijn verplicht, bij BEIDE knoppen (PDF
  // downloaden en per e-mail versturen) -- zonder volledig, geldig ingevulde
  // velden wordt er geen PDF gebouwd. Controleert in dezelfde volgorde als
  // op het scherm, toont de foutmelding van het eerste veld dat niet klopt
  // en zet de focus daarop. Spaties alleen telt als leeg. Geeft null terug
  // als er iets niet klopt, anders de getrimde waarden.
  function valideerAlles(){
    const dealerNaam = dealerInput.value.trim();
    if (!dealerNaam) {
      toonFout(rt("quoteDealerRequired"));
      dealerInput.focus();
      return null;
    }
    const dealerEmail = dealerEmailInput.value.trim();
    if (!rIsValidEmail(dealerEmail)) {
      toonFout(rt("quoteInvalidDealerEmail"));
      dealerEmailInput.focus();
      return null;
    }
    const email = emailInput.value.trim();
    if (!rIsValidEmail(email)) {
      toonFout(rt("quoteInvalidEmail"));
      emailInput.focus();
      return null;
    }
    const naam = nameInput.value.trim();
    if (!naam) {
      toonFout(rt("quoteNameRequired"));
      nameInput.focus();
      return null;
    }
    return { dealerNaam, dealerEmail, email, naam };
  }

  function zetBezig(actieveBtn, bezig){
    downloadBtn.disabled = bezig;
    emailBtn.disabled = bezig;
    if (bezig) {
      actieveBtn.dataset.origText = actieveBtn.textContent;
      actieveBtn.textContent = rt("quoteGenerating");
    } else if (actieveBtn.dataset.origText) {
      actieveBtn.textContent = actieveBtn.dataset.origText;
    }
  }

  downloadBtn.addEventListener("click", async () => {
    const gegevens = valideerAlles();
    if (!gegevens) return;
    errorBox.style.display = "none";
    zetBezig(downloadBtn, true);
    try {
      await rDownloadOfferte(gegevens);
      sluit();
    } catch (e) {
      console.error("PDF downloaden mislukt:", e);
      toonFout(rt("quoteError"));
      zetBezig(downloadBtn, false);
    }
  });

  // Per e-mail versturen: de dealer krijgt via cc automatisch ook een kopie
  // (zie de e-mail-functie), zodat de dealer altijd een bewijs van de
  // verstuurde offerte behoudt.
  emailBtn.addEventListener("click", async () => {
    const gegevens = valideerAlles();
    if (!gegevens) return;
    errorBox.style.display = "none";
    zetBezig(emailBtn, true);
    try {
      await rVerstuurOfferteViaEmail(gegevens);
      sluit();
    } catch (e) {
      console.error("Offerte versturen mislukt:", e);
      toonFout(rt("quoteError"));
      zetBezig(emailBtn, false);
    }
  });

  if (typeof dealerInput.focus === "function") {
    setTimeout(() => dealerInput.focus(), 30);
  }
}

/* =====================================================================
   START
   ===================================================================== */
loadRebuildData();

// Bij het draaien/vergroten van het venster (bv. telefoon gekanteld, of een
// browservenster dat van formaat verandert) opnieuw meten -- ontlast met een
// korte vertraging zodat dit niet bij elke pixel tijdens het slepen draait.
// Bestaat niet in de testomgeving van test-harness.js (geen echte browser),
// vandaar de guard.
if (typeof window !== "undefined" && typeof window.addEventListener === "function") {
  let rResizeTimer = null;
  window.addEventListener("resize", () => {
    clearTimeout(rResizeTimer);
    rResizeTimer = setTimeout(rMeetEnZetHoogte, 150);
  });
}